/* Automatisch aus app/public/funnel.js gespiegelt.
   Nicht hier bearbeiten, sondern in app/public und dann sync-theme.js laufen lassen. */
const BACKEND = window.WUNOLO_BACKEND || ''
/* Wunolo Personalisierungs-Funnel.
   Eine Seite, sechs Schritte, kein Framework: damit sich das Ganze spaeter
   ohne Build-Kette als Section in ein Shopify-Theme einhaengen laesst. */

const HAIR = [
  ['light blonde', 'Hellblond', '#EADCB8'],
  ['blonde', 'Blond', '#D6BC85'],
  ['dark blonde', 'Dunkelblond', '#B08D5B'],
  ['light brown', 'Hellbraun', '#8B6239'],
  ['brown', 'Braun', '#5C3C24'],
  ['black', 'Schwarz', '#221A16'],
  ['red', 'Rot', '#B5541F'],
]

const EYES = [
  ['light blue', 'Hellblau', '#A9C9DE'],
  ['blue', 'Blau', '#5B84AC'],
  ['green', 'Grün', '#858A5A'],
  ['hazel', 'Haselnuss', '#9A7742'],
  ['dark brown', 'Tiefbraun', '#4A3222'],
  ['grey', 'Grau', '#8D9199'],
]

const DEDICATIONS = [
  'Für {NAME}, weil du genau richtig bist, wie du bist.',
  '{NAME}, du kannst mehr, als du glaubst. Wir sind so stolz auf dich.',
  'Für {NAME} zum Geburtstag. Auf viele mutige Abenteuer!',
  '{NAME}, wir haben dich unendlich lieb. Mama und Papa',
]

const ICONS = { angst: '🌙', kita: '🎨', dino: '🦕', prinzessin: '👑', weltraum: '🚀', einhorn: '🦄', schule: '🎒', wut: '🔥', geschwister: '💙', grenzen: '✋', fehler: '🌱', trauer: '🕊️', anderssein: '🌈', umzug: '🔑', ruhe: '🐚' }

/* Auf einer Shopify-Produktseite steht die Geschichte schon fest: Das Produkt
   IST die Geschichte. Die Section reicht die Id durch, dann entfaellt Schritt 1.
   Auf der eigenstaendigen Funnel-Seite bleibt die Auswahl erhalten. */
const PINNED_STORY = (typeof window !== 'undefined' && window.WUNOLO_STORY_ID) || null
/* Testballon "zum Verwechseln aehnlich" (06.10.2026, Paul): In diesem Weg wird
   das Kind nicht gezeichnet, Kopf und Haare aus dem Foto kommen auf fertige
   Buchseiten. tx(alt, neu) waehlt die zweite Fassung nur dort; alle anderen
   Buecher sehen die bisherigen Texte. Erkannt am Theme-Wert WUNOLO_STIL oder an
   der Geschichte (Kennung endet auf -aehnlich). Texte: konversion/2026-10-06-funnel-texte-aehnlich.md */
const AEHNLICH = (typeof window !== 'undefined' && window.WUNOLO_STIL === 'aehnlich') || /-aehnlich$/.test(PINNED_STORY || '')
const tx = (alt, neu) => AEHNLICH ? neu : alt
/* Testballon ohne Aussehen-Schritt (08.10.2026, Paul: "frag im neuen
   Testballon den Aussehen-Schritt raus"): Haar- und Augenfarbe liest dort
   kein Bildauftrag, GPT nimmt Gesicht, Haare und Augen aus dem Foto
   (labor/alter-hinweis-test). Uebersprungene Schritte fehlen im Stepper, in
   der Zaehlung und im Balken, go() springt in Laufrichtung darueber. */
const UEBERSPRUNGEN = AEHNLICH ? new Set([2]) : new Set()
function sichtbareSchritte () {
  const liste = []
  for (let i = FIRST_STEP; i <= LETZTER_SCHRITT; i++) if (!istUebersprungen(i)) liste.push(i)
  return liste
}
/* Poster zum Buch (29.10.2026): Schritt 6 gibt es nur, wenn der Server zur
   Geschichte ein Poster meldet, das fertig ist oder gerade entsteht, und ein
   gedrucktes Buch gewaehlt ist. Sonst bleibt "Dein Buch" der letzte Schritt. */
function istUebersprungen (i) {
  return UEBERSPRUNGEN.has(i) || (i === POSTER_SCHRITT && !posterSchrittDa())
}
function letzterSchritt () {
  const liste = sichtbareSchritte()
  return liste[liste.length - 1]
}
const PINNED_TITLE = (typeof window !== 'undefined' && window.WUNOLO_STORY_TITLE) || null
/* "Figur zuerst" (07.09. bis 16.09.) gibt es nicht mehr: Der Einstieg ueber
   /pages/figur brachte aus Anzeigen 61 Vorschauen, 4 Warenkoerbe und 0
   Kaeufe. Jeder Weg beginnt jetzt mit einem Buch, und die Vorschau zeigt
   das Buch mit dem Kind (KONZEPT-16-09-FIGUR-ZUERST.md). Was bleibt: die
   gespeicherte Figur per Token fuer ein Zweitbuch (figurAnbieten). */
const FIRST_STEP = PINNED_STORY ? 1 : 0
// Seit 29.10.2026 mit dem Posterschritt; ob er erscheint, sagt posterSchrittDa().
const BUCH_SCHRITT = 5
const POSTER_SCHRITT = 6
const LETZTER_SCHRITT = POSTER_SCHRITT

/* ---------------------------------------------------------------- Messung */
/*
 * Wo steigen Besucher aus? Ein Auftrag entsteht erst beim Foto, alles davor
 * war unsichtbar (Befund Head of Conversion, 11.09.). Deshalb je Stufe ein
 * Ereignis an den eigenen Server.
 *
 * Die Sitzungskennung lebt nur in dieser Variablen, also bis der Tab
 * geschlossen wird: kein Cookie, kein sessionStorage, nichts, was auf dem
 * Geraet bleibt. Damit ist die Messung keine Einwilligungsfrage. Ein Reload
 * beginnt eine neue Sitzung, das nehmen wir in Kauf.
 */
const MESS_SITZUNG = (() => {
  // Zurueck aus der Kasse (25.09.): Der Browser laedt die Seite neu, der
  // Verlaufseintrag traegt aber die Sitzung vom Kauf (kasseMerken). Mit ihr
  // geht dieselbe Sitzung weiter, statt dass eine zweite ohne Foto entsteht.
  try {
    const alt = history.state?.wunoloKasse?.sitzung
    if (typeof alt === 'string' && /^[\w-]{6,40}$/.test(alt)) return alt
  } catch {}
  try { return crypto.randomUUID().slice(0, 16) } catch { return Math.random().toString(36).slice(2, 14) }
})()
/* Eigene Durchlaeufe markieren, damit Pauls Tests die Treppe nicht faelschen.
   Einmal ?messung=test aufrufen, dann gilt es auf diesem Geraet weiter. */
const MESS_TEST = (() => {
  try {
    if (new URLSearchParams(location.search).get('messung') === 'test') localStorage.setItem('wunolo-messung-test', '1')
    if (new URLSearchParams(location.search).get('messung') === 'echt') localStorage.removeItem('wunolo-messung-test')
    return localStorage.getItem('wunolo-messung-test') === '1'
  } catch { return false }
})()
/* Browser und System (30.09., PayPal-Pruefung): 88 Prozent der Besucher
   kommen aus dem Browser in Instagram oder Facebook, dort braucht PayPal eine
   Anmeldung von Hand, und auf Android ist offen, ob Google Pay erscheint.
   Die Treppe braucht deshalb die grobe Einordnung, nicht die Kennung: Nur
   die drei Werte verlassen das Geraet, gespeichert wird nichts. */
const MESS_UMGEBUNG = (() => {
  try {
    const ua = String(navigator.userAgent || '')
    const browser = /Instagram/i.test(ua) ? 'instagram' : /FBAN|FBAV|FB_IAB|FBIOS|FB4A/.test(ua) ? 'facebook' : 'andere'
    const system = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ? 'ios' : /Android/i.test(ua) ? 'android' : 'andere'
    return { browser, system }
  } catch { return { browser: 'andere', system: 'andere' } }
})()
/* Welche Anzeige die Sitzung gebracht hat (14.09., Kontocheck Tag 4): Meta
   haengt seit dem 11.09. utm_content mit dem Anzeigennamen an jeden Klick.
   Nur aus der Adresse gelesen, nirgends abgelegt, damit die Messung
   einwilligungsfrei bleibt. Ohne den Parameter bleibt das Feld leer. */
/* Test Mailfeld (24.09., Paul): Seit dem 22.09. steht das Mailfeld in
   Schritt 1, und seitdem gehen weniger Leute ueber Schritt 1 hinaus (76 gegen
   39 Prozent), dafuer kommen dreimal so viele Adressen. Statt zu raten, teilt
   der Zufall jede Sitzung: a = Mailfeld in Schritt 1 wie bisher, b = am Ende
   von Schritt 2 (Aussehen), weiterhin vor dem Foto. Nur in dieser Variablen,
   nichts auf dem Geraet; ein Reload ist eine neue Sitzung mit neuem Los. */
/* Bildtest im Testballon (06.10., Paul): Der Server teilt jeden Auftrag
   Gemini oder GPT zu. Der Browser merkt sich die Haelfte, damit dieselbe
   Person beim naechsten Kind dieselbe Art Vorschau sieht, und jedes
   Messereignis traegt sie. Ohne Speicher (privates Fenster) entscheidet der
   Server jedes Mal neu, das ist hinnehmbar. */
let BILD_VARIANTE = (() => {
  try { const v = localStorage.getItem('wunolo.bildtest'); return v === 'gpt' || v === 'gemini' ? v : null } catch { return null }
})()
function bildVarianteMerken (v) {
  if (v !== 'gpt' && v !== 'gemini') return
  BILD_VARIANTE = v
  try { localStorage.setItem('wunolo.bildtest', v) } catch {}
}
// Im Testballon ohne Aussehen-Schritt gibt es den Platz von Variante b nicht
// (08.10.): dort immer a, und so wird es auch gemeldet.
const MAIL_VARIANTE = AEHNLICH ? 'a' : (() => {
  try { return crypto.getRandomValues(new Uint8Array(1))[0] < 128 ? 'a' : 'b' } catch { return Math.random() < 0.5 ? 'a' : 'b' }
})()
function mailfeldPlatzieren () {
  if (MAIL_VARIANTE !== 'b') return
  const zeile = document.getElementById('vorab-mail-zeile')
  const ziel = document.querySelector('.step[data-step="2"] .fk-felder')
  if (zeile && ziel) ziel.after(zeile)
}
const MESS_ANZEIGE = (() => {
  // Bezahlte Google-Klicks tragen utm_content zweimal (15.10.): zuerst sag_organic
  // aus Shopifys Produktlink, dahinter gads-... aus unserem Kampagnen-Suffix.
  // Ein gads-Wert geht vor, sonst gilt der erste wie bisher.
  try {
    const alle = new URLSearchParams(location.search).getAll('utm_content')
    return String(alle.find(a => /^gads-/.test(a)) || alle[0] || '').trim().slice(0, 80)
  } catch { return '' }
})()
/* Woher der Besuch kommt (16.09., Paul: Meta, Google oder direkt?).
   Vorrang hat ?herkunft aus dem Theme: Die erste Seite des Besuchs kennt den
   Verweis, im Konfigurator steht als Verweisende immer wunolo.de, weil der
   Klick von der eigenen Seite kommt (wunolo-plausible.liquid haengt den Wert
   an jeden Konfigurator-Link). Wer direkt hier landet, wird hier bestimmt.
   Nur gelesen, nirgends abgelegt, damit die Messung einwilligungsfrei bleibt. */
const MESS_HERKUNFT = (() => {
  try {
    const p = new URLSearchParams(location.search)
    const vomTheme = (p.get('herkunft') || '').trim().toLowerCase().slice(0, 24)
    if (vomTheme) return vomTheme
    const quelle = (p.get('utm_source') || '').toLowerCase()
    if (quelle) {
      if (/face|insta|meta|\bfb\b/.test(quelle)) return 'meta'
      if (/google|gads|adwords/.test(quelle)) return 'google'
      if (/tiktok/.test(quelle)) return 'tiktok'
      if (/klaviyo|mail|newsletter|resend/.test(quelle)) return 'mail'
      return quelle.slice(0, 24)
    }
    const ref = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''
    const eigen = location.hostname.toLowerCase().replace(/^www\./, '')
    if (!ref) return 'direkt'
    if (ref.replace(/^www\./, '') === eigen) return 'intern'
    if (/facebook|instagram|fb\.me|fb\.com/.test(ref)) return 'meta'
    if (/google/.test(ref)) return 'google'
    if (/tiktok/.test(ref)) return 'tiktok'
    if (/bing|duckduckgo|ecosia|yahoo/.test(ref)) return 'suche'
    return ref.replace(/^www\./, '').slice(0, 24)
  } catch { return '' }
})()
const messGesehen = new Set()

/*
 * Figur-Einstieg sichtbar machen (11.09., Head of Conversion).
 *
 * Zwei Dinge, die nur hier gelten: Das Beweisbild ("Foto wird Figur") steht
 * in Schritt 1, weil die Anzeigen genau das versprechen und die Seite bis
 * dahin nur ein Formular zeigte. Und die Einleitungszeile nennt statt Faro
 * den Datenschutz, denn C3 oeffnet mit "Niemals lade ich ein Foto hoch" und
 * bekam drei Schritte lang keine Antwort. Faro passt ausserdem nicht zu den
 * Traumwelten, die diese Seite mitverkauft.
 *
 * Die Klasse am body schaltet zusaetzlich die Chat-Blase aus (styles.css):
 * Sie lag ueber der Alterswahl.
 */
if (typeof document !== 'undefined') {
  document.body.classList.add('fk-funnel-seite')
}
function messe (ereignis, extra = {}) {
  // Jede Stufe zaehlt einmal je Sitzung. Wer zurueckgeht und wiederkommt,
  // ist eine Sitzung, nicht zwei; nur foto_abgelehnt darf sich wiederholen,
  // weil die Zahl der Fehlversuche die eigentliche Aussage ist.
  if (!MESS_WIEDERHOLBAR.has(ereignis) && messGesehen.has(ereignis)) return
  messGesehen.add(ereignis)
  // Buch an jedem Schritt (15.10.): Bisher trug erst "Weiter zur Bestellung"
  // die storyId, Foto und Vorschau liessen sich keinem Buch zuordnen. Der
  // Funnel kennt das Buch von der Buchseite (PINNED_STORY) oder aus der Wahl.
  let geschichte = PINNED_STORY
  try { geschichte = state.storyId || PINNED_STORY } catch { /* state noch nicht angelegt */ }
  const daten = {
    sitzung: MESS_SITZUNG,
    ereignis,
    quelle: 'buch',
    storyId: geschichte || undefined,
    geraet: (typeof window !== 'undefined' && window.innerWidth < 768) ? 'mobil' : 'desktop',
    test: MESS_TEST,
    // undefined faellt beim Serialisieren weg: ohne Anzeige kein Feld.
    anzeige: MESS_ANZEIGE || undefined,
    herkunft: MESS_HERKUNFT || undefined,
    mailtest: MAIL_VARIANTE,
    bildtest: AEHNLICH && BILD_VARIANTE ? BILD_VARIANTE : undefined,
    browser: MESS_UMGEBUNG.browser,
    system: MESS_UMGEBUNG.system,
    ...extra
  }
  try {
    // Im Shopify-Theme liegt der Funnel auf wunolo.de, der Server aber auf
    // app.wunolo.de. Die Adresse steht in WUNOLO_BACKEND, gesetzt von der
    // Funnel-Section; lokal ist sie leer und der Pfad bleibt relativ.
    // (11.09.: Erst stand hier WUNOLO_API, eine Variable, die es nirgends
    // gibt. Alle Meldungen liefen gegen wunolo.de/api/messung und bekamen
    // von Shopify eine 404. Live gesehen, nicht in den Tests.)
    const ziel = (window.WUNOLO_BACKEND || '') + '/api/messung'
    const koerper = JSON.stringify(daten)
    // Bewusst text/plain statt application/json: Ueber Domaingrenzen hinweg
    // macht application/json aus der Anfrage eine "nicht einfache", die einen
    // Preflight braucht. sendBeacon kann keinen Preflight, der Browser wirft
    // die Meldung dann still weg. Der Server liest den Rumpf ohnehin als
    // JSON, der Kopf interessiert ihn nicht.
    // sendBeacon ueberlebt den Seitenwechsel (Klick auf ein Buch), fetch ist
    // der Rueckfall. Beides ohne await: Der Funnel wartet nie auf die Messung.
    if (navigator.sendBeacon) navigator.sendBeacon(ziel, new Blob([koerper], { type: 'text/plain;charset=UTF-8' }))
    else fetch(ziel, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: koerper, keepalive: true }).catch(() => {})
  } catch { /* eine verlorene Messung ist folgenlos */ }
}
/*
 * Den Warenkorb am Auftrag vermerken (17.09., Paul: "wo genau springt der
 * Kunde ab, in welchem Screen"). Die Treppe zaehlt anonyme Sitzungen, die
 * Werkstatt kennt Auftraege; ohne diesen Vermerk endet die Spur eines
 * Auftrags beim Knopf "Weiter zur Bestellung", und niemand sieht, ob die
 * Kundin vor Ausgabe und Preis stehen blieb oder erst in der Kasse ging.
 *
 * Schicken und weitergehen, nie darauf warten: Der Weg zur Kasse darf an
 * einem Vermerk nicht haengen. keepalive ueberlebt den Seitenwechsel.
 */
function warenkorbVermerken () {
  if (!state.jobId) return
  try {
    const ziel = (window.WUNOLO_BACKEND || '') + '/api/jobs/' + encodeURIComponent(state.jobId) + '/warenkorb'
    fetch(ziel, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: '{}', keepalive: true }).catch(() => {})
  } catch { /* ein verlorener Vermerk ist folgenlos */ }
}
// Wiederholbare Ereignisse (16.09.): Fehlversuche, Neu-zeichnen-Laeufe mit
// ihrem Hinweis, die Blaettertiefe (der Server nimmt das Maximum) und
// Geschichtenwechsel. Alles andere zaehlt einmal je Sitzung.
const MESS_WIEDERHOLBAR = new Set(['foto_abgelehnt', 'figur_neu', 'seiten', 'geschichte_gewechselt'])
/*
 * Die Sitzung geht mit dem Auftrag mit (16.09., PLAN-16-09-TREPPE.md): Der
 * Bestell-Webhook kennt den Auftrag, und nur so kann er "Gekauft" als Stufe
 * derselben Sitzung schreiben. Kein neues Datum ueber die Kundin, die
 * Kennung ist eine Zufallszahl, die mit dem Tab verschwindet.
 */
function messKennung () {
  return {
    sitzung: MESS_SITZUNG,
    test: MESS_TEST,
    geraet: (typeof window !== 'undefined' && window.innerWidth < 768) ? 'mobil' : 'desktop',
    anzeige: MESS_ANZEIGE || undefined,
    herkunft: MESS_HERKUNFT || undefined,
    browser: MESS_UMGEBUNG.browser,
    system: MESS_UMGEBUNG.system
  }
}
/*
 * Blaettertiefe (16.09.): Der Seitenzaehler merkt sich die tiefste Seite,
 * gemeldet wird beim Verlassen des Schritts, beim Geschichtenwechsel und
 * beim Schliessen der Seite, jeweils nur, wenn es tiefer ging als zuletzt
 * gemeldet. Der Server nimmt je Sitzung das Maximum.
 */
function seitenMelden () {
  if (!state.coverUrl || state.tiefeMax === null || state.tiefeMax === undefined) return
  if (state.tiefeGemeldet !== null && state.tiefeGemeldet !== undefined && state.tiefeMax <= state.tiefeGemeldet) return
  state.tiefeGemeldet = state.tiefeMax
  messe('seiten', { tiefe: state.tiefeMax })
}
/*
 * Seite geschlossen, waehrend etwas lief (16.09.): Ohne dieses Ereignis war
 * "Foto geprueft ohne Buch gesehen" nicht von einem Fehler zu unterscheiden.
 */
function wartenMelden () {
  let grund = null
  if (typeof nz === 'object' && nz.zustand === 'lauf') grund = 'neu'
  else if (state.coverLaeuft) grund = 'cover'
  else if (state.previewStarted && !state.sheetUrl) grund = 'figur'
  if (grund) messe('warten_abgebrochen', { grund })
}
if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => { seitenMelden(); wartenMelden() })
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') { seitenMelden(); wartenMelden() } })
}

const state = {
  step: FIRST_STEP,
  storyId: PINNED_STORY,
  storyTitle: PINNED_TITLE,
  // Poster zum Buch (29.10.2026): Stand vom Server, Wahl der Kundin, nie vorausgewaehlt.
  poster: { stand: null, dabei: false, groesse: '30x40' },
  name: '',
  gender: null,
  age: null,
  ageRange: null,
  hairColor: null,
  hairStyle: null,
  eyeColor: null,
  consent: false,
  photoOk: false,
  jobId: null,
  vorabMail: '',
  // Figur aus einem frueheren Auftrag uebernommen (13.09.): Dann gab es in
  // diesem Auftrag nie einen Foto- und nie einen Aussehensschritt, und der
  // Kaufschritt ist der erste eigene.
  figurUebernommen: false,
  // Adresse, an die der Link zur Figur wirklich rausgegangen ist (13.09.).
  // Nicht dasselbe wie vorabMail: Die ist nur hinterlegt, ohne Einwilligung
  // und ohne Versand. Erst diese hier schaltet die weiteren Mailfragen ab.
  mailGesichert: '',
  binding: null,
  dedication: '',
}

const $ = s => document.querySelector(s)
const $$ = s => Array.from(document.querySelectorAll(s))
const steps = $$('.step')

/* ------------------------------------------------------------ Aufbau */
function buildSwatches (container, data, key) {
  container.innerHTML = data.map(([value, label, color]) => `
    <button class="swatch" type="button" data-value="${value}" aria-label="${label}" aria-pressed="false">
      <i style="background:${color}"></i><span>${label}</span>
    </button>`).join('')
  container.addEventListener('click', e => {
    const btn = e.target.closest('.swatch')
    if (!btn) return
    container.querySelectorAll('.swatch').forEach(b => b.setAttribute('aria-pressed', 'false'))
    btn.setAttribute('aria-pressed', 'true')
    state[key] = btn.dataset.value
    validate()
  })
}

/**
 * Baut die Ausgabe-Auswahl aus den echten Produktvarianten.
 *
 * Vorher standen Softcover und Hardcover fest im Markup. Als am 11.08. die
 * Digitalausgabe ans Produkt kam, erschien sie im Funnel deshalb nicht, und
 * niemand haette sie kaufen koennen. Jetzt kommt die Auswahl aus dem Produkt
 * selbst, damit sie nie wieder auseinanderlaufen kann.
 *
 * Im Theme liefert das Liquid window.WUNOLO_VARIANTS (Titel klein geschrieben
 * auf Varianten-Id) und WUNOLO_PRICES. Lokal gibt es beides nicht, dann
 * bleiben die statischen Knoepfe aus index.html stehen.
 */
function buildEditions (container) {
  const varianten = window.WUNOLO_VARIANTS
  if (!container || !varianten || !Object.keys(varianten).length) return
  const preise = window.WUNOLO_PRICES || {}
  // Anzeigetitel unveraendert aus Shopify. Aus dem kleingeschriebenen
  // Schluessel zurueckzurechnen ergab "Digitalausgabe (Pdf)".
  const titelAnzeige = window.WUNOLO_VARIANT_TITLES || {}
  // Nur nachpruefbare Eigenschaften als Merkmal, keine Beliebtheits- oder
  // Prozentbehauptungen: Der Shop hat bislang eine einzige Bestellung, und
  // erfundene Sozialbeweise sind nach UWG § 5 irrefuehrend. Dieselbe Regel
  // gilt im Bewertungsblock schon laenger (Test dort), sie fehlte nur hier.
  // Keine Lieferzeit mehr auf den Kacheln (Paul, 24.09.: kurz halten). Im
  // Aufklapper steht nur der schnellste Weg, "Premiumversand 2 bis 3 Tage plus
  // Druck"; Standard und Preise je Versandart zeigt die Kasse.
  // Nutzentext je Bindung (22.09., nach dem Muster des Marktfuehrers, aber
  // ohne Differenzbetrag: "10 Euro mehr" lenkt den Blick auf den Aufschlag
  // statt auf den Nutzen, Head of Conversion 22.09.).
  const merkmal = {
    digital: 'Sofort verfügbar',
    softcover: 'Leicht und biegsam, für unterwegs.',
    hardcover: 'Fester Einband, der jahrelanges Vorlesen aushält.',
    layflat: 'Dicke Fotoseiten, öffnet sich ganz flach.'
  }
  // Schild am Hardcover: "Meistgewaehlt" (Paul, 22.09., nach Hinweis auf die
  // Regel vom 16.09., dass eine Aussage ueber andere Kundinnen belegt sein
  // muss). Grundlage: 9 von 16 Warenkoerben der Runde 2 waren Hardcover.
  // Sobald Kaeufe da sind, gilt deren Verhaeltnis; kippt es, kommt das Schild
  // ans Softcover oder weg.
  // Grafik der Bindung (22.09., Designpaket buchformat_kacheln): im Shop als
  // Theme-Asset ueber WUNOLO_BUCHBILDER, lokal unter /brand/.
  const bilder = window.WUNOLO_BUCHBILDER || {}

  // Halloween-Preis im Testballon (Paul, 08.10.2026): bis 31.10., 23:59 Uhr
  // Berlin der regulaere Preis ab 01.11. durchgestrichen daneben, mit
  // Ersparnis. Nur solange der echte Variantenpreis darunter liegt; nach der
  // Umstellung durch die Preiswacht also nie, auch wenn die Uhr falsch geht.
  // Dieselben Zahlen stehen in snippets/wunolo-halloween.liquid.
  const halloweenRegel = (art, zahl) => {
    if (!AEHNLICH || Date.now() > Date.UTC(2026, 9, 31, 22, 59, 59)) return 0
    const regel = { softcover: 39.95, hardcover: 49.95 }[art]
    return regel && Number(zahl) > 0 && Number(zahl) < regel ? regel : 0
  }
  const euroHw = n => `${n.toFixed(2).replace('.', ',')}\u00a0€`
  let halloween = false

  // Reihenfolge mit Layflat (04.11.2026, Paul): Hardcover, Softcover, Layflat.
  // Vom 03.11. an stand das Layflat als Anker oben. Am Telefon liegen die
  // Kacheln untereinander, der erste Preis war also 59,95, waehrend Anzeige
  // und Produktseite "ab 29,95" versprechen. Kolenda: ein teurer Anker schadet
  // bei Varianten desselben Produkts und bei Erstbesuchern; die Wissensbasis
  // des Head of Conversion fuehrt "harter Preisanker vorn" als Fehler (Karte
  // 13). Der Kompromisseffekt (Simonson 1989) braucht das Layflat nur
  // sichtbar, nicht oben. Ohne Layflat-Variante bleibt die alte Folge aus
  // Shopify (Softcover, Hardcover), damit Theme und Varianten getrennt live
  // gehen koennen.
  const artVon = titel => Object.keys(merkmal).find(wort => titel.includes(wort))
  const titelListe = Object.keys(varianten)
  const mitLayflat = titelListe.some(t => artVon(t) === 'layflat')
  const rang = { hardcover: 0, softcover: 1, layflat: 2, digital: 3 }
  if (mitLayflat) titelListe.sort((a, b) => (rang[artVon(a)] ?? 9) - (rang[artVon(b)] ?? 9))
  if (mitLayflat) {
    const titel = $('#ausgabe-titel')
    if (titel) titel.textContent = 'Hardcover, Softcover oder Layflat?'
    const beide = $('#ausgabe-beide')
    if (beide) beide.textContent = 'Alle'
  }
  container.innerHTML = titelListe.map(titel => {
    const schoen = titelAnzeige[titel] || titel.replace(/(^|\s|\()\p{Ll}/gu, c => c.toUpperCase())
    const art = artVon(titel)
    const tag = art ? merkmal[art] : ''
    // data-price und data-titel schreiben (13.09.): Die Zusammenfassung liest
    // genau diese beiden Attribute, und buildEditions hat sie nie gesetzt.
    // Deshalb stand dort immer "ab 29,99 €", egal was gewaehlt war.
    const zahl = (window.WUNOLO_PRICE_NUMBERS || {})[titel]
    const empfohlen = titel.includes('hardcover')
    // Schild am Layflat (Paul 03.11.2026): "Das Besondere", in Gold. Eigene
    // Worte, nicht die des Marktfuehrers.
    const besonders = art === 'layflat'
    const bild = art && art !== 'digital' ? (bilder[art] || `/brand/wunolo-buch-${art}.svg`) : ''
    const regel = halloweenRegel(art, zahl)
    if (regel) halloween = true
    const preisText = regel
      ? `${euroHw(Number(zahl))} <s><span class="hw-sr">regulär ab 01.11.: </span>${euroHw(regel)}</s>`
      : (preise[titel] || '')
    // data-art (23.09.): Das Buch-CSS unterscheidet Softcover und Hardcover
    // ueber dieses Attribut, weil data-value der Variantentitel aus Shopify ist.
    return `<button class="choice fk-ausgabe${empfohlen ? ' choice-empfohlen' : ''}${besonders ? ' choice-besonders' : ''}" type="button" data-value="${titel}" data-art="${art || ''}" aria-pressed="false"
      ${zahl ? `data-price="${zahl}"` : ''} data-titel="${escHtml(schoen)}">
      ${empfohlen ? '<span class="choice-badge">Meistgewählt</span>' : ''}
      ${besonders ? '<span class="choice-badge choice-badge-gold">Das Besondere</span>' : ''}
      ${bild ? ausgabeBildHtml(art, bild) : ''}
      <strong>${schoen}</strong><small${regel ? ' class="fk-hw-preis"' : ''}>${preisText}</small>
      ${regel ? `<span class="fk-hw-spar">Du sparst ${euroHw(regel - Number(zahl))}</span>` : ''}
      ${tag ? `<span class="tag">${tag}</span>` : ''}
    </button>`
  }).join('')
  // Preise in "Details zum Buch" aus den Varianten (08.10.): Dort standen fest
  // 29,99 und 39,99, im Testballon stimmt das seit dem Halloween-Preis nicht.
  const zahlVon = wort => Number((window.WUNOLO_PRICE_NUMBERS || {})[Object.keys(varianten).find(t => t.includes(wort))]) || 0
  const detailsPreise = $('#details-preise-oben')
  if (detailsPreise && zahlVon('softcover') && zahlVon('hardcover')) {
    detailsPreise.textContent = zahlVon('layflat')
      ? `Softcover ${euroHw(zahlVon('softcover'))}, Hardcover ${euroHw(zahlVon('hardcover'))} oder Layflat ${euroHw(zahlVon('layflat'))}, persönliche Widmung inklusive`
      : `Softcover ${euroHw(zahlVon('softcover'))} oder Hardcover ${euroHw(zahlVon('hardcover'))}, persönliche Widmung inklusive`
  }
  // Halloween: Schild ueber den Kacheln, Erklaerung des Streichpreises darunter.
  container.parentElement?.querySelectorAll('.fk-hw').forEach(el => el.remove())
  if (halloween) {
    container.insertAdjacentHTML('beforebegin', '<span class="fk-hw fk-hw-chip"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6c.3-1.6 1.2-2.8 2.6-3.4l.5 1.1c-1 .5-1.6 1.3-1.8 2.4" fill="#5E8C3A"/><ellipse cx="7.6" cy="14" rx="5.4" ry="7" fill="#C2571A"/><ellipse cx="16.4" cy="14" rx="5.4" ry="7" fill="#C2571A"/><ellipse cx="12" cy="14" rx="5.6" ry="7.6" fill="#E8742C"/><path d="M9 12.5l1.5-1.6 1.5 1.6zm3.6 0l1.5-1.6 1.5 1.6z" fill="#3a1a08"/></svg>Halloween-Preis bis 31.10.</span>')
    container.insertAdjacentHTML('afterend', '<p class="fk-hw fk-hw-regel">Durchgestrichen: regulärer Preis ab 01.11.2026.</p>')
  }
  // Winterzauber (31.10.2026): Schild ueber den Kacheln, nur mit bestaetigtem
  // Bestellschluss. Text und Ende kommen aus snippets/wunolo-winter.liquid
  // (window.WUNOLO_WINTER aus sections/wunolo-funnel.liquid). Kein Preisvergleich.
  const winter = window.WUNOLO_WINTER
  if (AEHNLICH && !halloween && winter && winter.schild && Date.now() / 1000 <= winter.bis) {
    container.insertAdjacentHTML('beforebegin', `<span class="fk-hw fk-wz-chip"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5V21.5M3.77 7.25L20.23 16.75M3.77 16.75L20.23 7.25M10 4L12 6L14 4M10 20L12 18L14 20M17.93 6.27L17.2 9L19.93 9.73M19.93 14.27L17.2 15L17.93 17.73M4.07 14.27L6.8 15L6.07 17.73M6.07 6.27L6.8 9L4.07 9.73" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>${escHtml(winter.schild)}</span>`)
  }
  // Die Kacheln sind neu gebaut, also das eigene Cover wieder eintragen.
  zeigeEigenesCover()
  vorauswahlAusgabe()
}

/* Bild einer Ausgabe-Kachel: das Symbol, bis das eigene Cover da ist, dann
   das Buch in 3D. Das Layflat liegt aufgeschlagen und hat zwei Haelften,
   links die Textseite (zeigeLayflatTextseite), rechts das Cover (03.11.2026). */
function ausgabeBildHtml (art, bild) {
  const cover = '<img class="fk-ausgabe-cover" alt="" width="640" height="660">'
  const innen = art === 'layflat'
    ? `<span class="fk-lf-links" aria-hidden="true"></span><span class="fk-lf-rechts">${cover}</span>`
    : cover
  return `<span class="fk-ausgabe-bild"><img class="fk-ausgabe-symbol" src="${escHtml(bild)}" alt="" width="840" height="630" loading="lazy"><span class="fk-buch" hidden><span class="fk-buch-3d">${innen}<span class="fk-buch-flaeche" aria-hidden="true"></span></span></span></span>`
}

/* Softcover vorgewaehlt (22.09., Head of Conversion und Paul): Jeder Anker
   auf der Produktseite sagt 29,99 und 3 bis 4 Tage plus Druck; ein vorgewaehltes
   Hardcover hiesse 45,98 mit Versand gegen diesen Anker. Vorher war nichts
   gewaehlt, der Weiter-Knopf blieb grau, und die Kachel las sich wie eine
   Pruefung statt wie ein Angebot. Wer schon gewaehlt hat, behaelt seine Wahl.
   Mit Layflat Hardcover vorgewaehlt (Paul 03.11.2026, gleichzeitig mit der
   Layflat-Kachel). Seit 04.11. steht das vorgewaehlte Hardcover auch zuerst. */
function vorauswahlAusgabe () {
  if (state.binding) return
  const knoepfe = $$('#binding .choice')
  const vorgabe = knoepfe.some(b => b.dataset.art === 'layflat') ? /hardcover/i : /softcover/i
  const knopf = knoepfe.find(b => vorgabe.test(b.dataset.value || '')) || $('#binding .choice')
  if (!knopf) return
  $$('#binding .choice').forEach(b => b.setAttribute('aria-pressed', 'false'))
  knopf.setAttribute('aria-pressed', 'true')
  state.binding = knopf.dataset.value
  validate()
}

/* Versand als Zahl (22.09.): Die Summe mit Versand steht vor der Kasse, nicht
   erst darin. Der Betrag kommt aus der Section-Einstellung des Themes
   (WUNOLO_VERSAND), lokal gilt der Rueckfall. Seit dem 24.09. ist das der
   Standardversand (3,99); Premium DHL waehlt die Kundin erst in der Kasse,
   deshalb rechnet die Summe mit Standard und sagt "ab". */
// Standardversand kostenlos ab diesem Warenwert (Versandprofil in Shopify,
// Deutschland und Oesterreich, Stand 03.11.2026).
const VERSANDFREI_AB = 55

function versandBetrag () {
  const roh = String(window.WUNOLO_VERSAND ?? '3,99').replace(',', '.')
  const n = Number(roh)
  return Number.isFinite(n) && n >= 0 ? n : 3.99
}

function bindChoices (container, key, transform = v => v) {
  container.addEventListener('click', e => {
    const btn = e.target.closest('.choice')
    if (!btn) return
    container.querySelectorAll('.choice').forEach(b => b.setAttribute('aria-pressed', 'false'))
    btn.setAttribute('aria-pressed', 'true')
    state[key] = transform(btn.dataset.value)
    // Altersspanne mitnehmen, falls der Knopf eine traegt. Sie ist die
    // eigentliche Angabe fuer die Zeichnung, die Zahl nur ein Vertreter.
    if (btn.dataset.range) state.ageRange = btn.dataset.range
    validate()
  })
}

async function loadStories () {
  // Bei fest verdrahteter Geschichte gibt es nichts auszuwaehlen. Der Abruf
  // wuerde nur eine Liste rendern, die niemand zu sehen bekommt.
  if (PINNED_STORY) return
  const res = await geduldig(() => fetch(BACKEND + '/api/stories'))
  const { stories } = await res.json()
  $('#stories').innerHTML = stories.map(s => `
    <button class="card story-card" type="button" data-id="${s.id}">
      <span class="badge">${ICONS[s.occasion] || '📖'}</span>
      <span>
        <h3>${s.title}</h3>
        <p>${s.theme}</p>
        <span class="age">${s.age} Jahre</span>
      </span>
    </button>`).join('')
  $('#stories').addEventListener('click', e => {
    const card = e.target.closest('.story-card')
    if (!card) return
    // Andere Geschichte nach der Vorschau (15.09., Paul): Der Auftrag kennt
    // noch die alte, das Cover gehoert zur alten. Merken; auf dem Figur-
    // Schritt setzt coverNeu() die Figur aufs Cover der neuen Geschichte.
    if (state.storyId && state.storyId !== card.dataset.id && state.jobId) { state.geschichteGewechselt = true; state.storyVorher = state.storyId }
    state.storyId = card.dataset.id
    state.storyTitle = card.querySelector('h3')?.textContent.trim() || null
    $$('.story-card').forEach(c => c.style.borderColor = '')
    card.style.borderColor = 'var(--night)'
    validate()
    setTimeout(() => go(1), 220)
  })
}

/* -------------------------------------------------- Kopf und Zusammenfassung */

/* Namen der Schritte fuer den Stepper. Der Index entspricht data-step im
   Markup, damit beides nicht auseinanderlaufen kann. Auf einer Produktseite
   ist Schritt 0 (Geschichte) uebersprungen, der Stepper zeigt dann vier. */
const SCHRITT_NAMEN = ['Geschichte', 'Kind', 'Aussehen', 'Foto', 'Figur', 'Buch', 'Poster']

function zeichneStepper () {
  /* Im Figur-Einstieg gehoert die Buchwahl in den Stepper (13.09., Befund
     Paul): Dort stand "Schritt 4 von 4", waehrend nach der Figur noch die
     Buchwahl und die Buchseite kommen. Paul: "Man denkt, ich waehl die
     Geschichte aus und bin damit direkt im Warenkorb." Sie ist technisch ein
     Zustand innerhalb von Schritt 4, fuer die Kundin aber ein eigener
     Schritt, und der Stepper soll zaehlen, was sie sieht. */
  const sichtbar = SCHRITT_NAMEN.map((n, i) => ({ name: n, i })).filter(s => sichtbareSchritte().includes(s.i))
  $('#fk-stepper').innerHTML = sichtbar.map((s, pos) => {
    const zustand = s.i < state.step ? 'erledigt' : s.i === state.step ? 'aktuell' : 'offen'
    /* Steht die Zeichnung, sind die Schritte davor nicht mehr anspringbar
       (13.09.): Sie sind in der Zeichnung aufgegangen, und der Fotoschritt
       haette ohnehin kein Foto mehr. Sonst waere der Stepper eine zweite
       Tuer in dieselbe Sackgasse wie der Zurueck-Knopf. */
    // Dieselbe Regel wie beim Zurueck-Knopf: erledigte Schritte sind wieder
    // anspringbar, seit der Fotoschritt mit fertiger Zeichnung keine
    // Sackgasse mehr ist. Nur bei uebernommener Figur bleibt alles vor dem
    // Kaufschritt zu, diese Schritte gab es in dem Auftrag nie. Seit
    // 04.11.2026 (Paul) sind sie trotzdem anspringbar und fuehren auf die
    // Wahl des Kindes (zurueckZurKindwahl), wie der Zurueck-Knopf.
    const zu = zustand === 'erledigt'
    return `<button class="fk-schritt" type="button" data-zustand="${zustand}" data-ziel="${s.i}"
      ${zu ? '' : 'disabled'} aria-current="${zustand === 'aktuell'}">
      <i>${zustand === 'erledigt' ? '✓' : pos + 1}</i><span>${s.name}</span></button>`
  }).join('')
}

/* Kickerzeile ueber der Ueberschrift: "Schritt 2 von 5 · Aussehen". Sie ist
   auf schmalen Schirmen der einzige Ort, an dem der Schrittname steht, weil
   der Stepper dort nur Ziffern zeigt. */
function schreibeKicker () {
  const gesamt = sichtbareSchritte().length
  const nummer = sichtbareSchritte().indexOf(state.step) + 1
  const el = steps[state.step]?.querySelector('.fk-kicker')
  const name = steps[state.step].dataset.kicker || ''
  if (el) el.textContent = `Schritt ${nummer} von ${gesamt} · ${name}`
}

const GESCHLECHT = { girl: 'Mädchen', boy: 'Junge' }
const HAAR_STIL = { 'straight hair': 'glatt', 'wavy hair': 'wellig', 'curly hair': 'lockig' }

/* Deutsche Bezeichnung eines Farbwerts. Die Auswahl schickt englische Werte
   an das Modell, angezeigt wird die Beschriftung, die die Kundin geklickt hat. */
function farbName (container, wert) {
  const btn = $(`#${container} [data-value="${wert}"]`)
  return btn ? btn.querySelector('span')?.textContent || btn.textContent.trim() : wert
}

function aktualisiereZusammenfassung () {
  const setze = (id, wert) => {
    const el = $(id)
    if (!el) return
    el.textContent = wert || 'noch offen'
    el.classList.toggle('offen', !wert)
  }

  const kind = [state.name, GESCHLECHT[state.gender], state.ageRange && `${state.ageRange} Jahre`]
    .filter(Boolean).join(' · ')
  setze('#fk-zf-kind', kind)

  const aussehen = state.hairColor
    ? [farbName('hair', state.hairColor), HAAR_STIL[state.hairStyle],
       state.eyeColor && `Augen ${farbName('eyes', state.eyeColor).toLowerCase()}`]
      .filter(Boolean).join(', ')
    : ''
  setze('#fk-zf-aussehen', aussehen)
  // Ohne Aussehen-Schritt (Testballon) faellt die Zeile weg statt "noch offen".
  const aussehenZeile = $('#fk-zf-aussehen')?.parentElement
  if (aussehenZeile) aussehenZeile.style.display = UEBERSPRUNGEN.has(2) ? 'none' : ''
  setze('#fk-zf-foto', state.sheetChosen ? 'gelöscht, nur die Figur bleibt' : state.photoOk ? '✓ hochgeladen' : '')

  // Preis: erst wenn eine Ausgabe gewaehlt ist, steht er fest. Vorher "ab",
  // sonst behauptet die Karte eine Zahl, die noch nicht gilt.
  const preisEl = $('#fk-zf-preis')
  if (preisEl) {
    const gewaehlt = state.binding && $(`#binding [data-value="${state.binding}"]`)
    const preis = Number(gewaehlt?.dataset.price) || 0
    const alle = $$('#binding .choice').map(b => Number(b.dataset.price)).filter(n => n > 0)
    /* Die Widmung mit ihrem Betrag, nicht nur als Wort (13.09., Befund Paul):
       Hier stand " + Widmung" hinter dem Buchpreis, die Zahl daneben blieb der
       Buchpreis. Wer Softcover und eine Widmung gewaehlt hatte, las 29,99 statt
       31,98, und im Warenkorb standen dann zwei Positionen. Eine Summe, die
       nicht die Summe ist, ist schlimmer als keine. */
    // Widmung inklusive (22.09.): kein Aufpreis mehr, also auch keine Summe,
    // die ihn einrechnet. Der Betrag oben bleibt der Buchpreis.
    const euro = n => `${n.toFixed(2).replace('.', ',')} €`
    const guenstigster = alle.length ? Math.min(...alle) : 29.99
    // Poster zum Buch (29.10.2026): dabei, dann steht die Summe aus Buch und Poster.
    const posterPreis = posterImKorb() ? POSTER_PREISE[state.poster.groesse].zumBuch : 0
    preisEl.textContent = preis ? `${euro(preis + posterPreis)}${posterPreis ? ' mit Poster' : ''}` : `ab ${euro(guenstigster)}`
    // Versand vor der Kasse nennen (22.09.): Die eine Kasse mit Adresse vom
    // 17.09. endete genau beim Sprung von 31,98 auf 37,97. Bis 04.11.2026 stand
    // hier die Summe mit Versand ("Mit Versand ab 43,94"). Seitdem der Betrag
    // getrennt (Paul 04.11.: die krumme Summe bricht den Anker 39,95): Preise
    // werden nach der ersten Ziffer bewertet (Thomas und Morwitz 2005), ein
    // getrennt genannter Aufschlag wiegt leichter (Morwitz, Greenleaf und
    // Johnson 1998), und die Kaufbox der Produktseite sagt dasselbe. Die
    // Ueberraschung in der Kasse bleibt aus, weil der Betrag dasteht.
    // Standardversand; Premium waehlt die Kundin erst in der Kasse.
    const versand = versandBetrag()
    const titel = gewaehlt?.dataset.titel
    const frei = preis > 0 && preis + posterPreis >= VERSANDFREI_AB
    const versandText = frei ? 'versandkostenfrei' : `zzgl. ${euro(versand)} Versand`
    const zeile = $('#fk-preiszeile')
    // Ab der Schwelle (Paul 03.11.2026, Layflat zu 59,95): Standardversand
    // kostet ab 55 Euro nichts, in Deutschland und Oesterreich.
    if (zeile) zeile.textContent = `Inkl. MwSt., ${versandText}`
    // Dieselbe Angabe in der Karte rechts und in der Buchvorschau, dort stand
    // nur "zzgl. Versand" ohne Betrag. Der Link auf die Versandseite bleibt.
    for (const el of $$('.fk-zf-steuer, .bv-preis-wert small')) {
      const href = el.querySelector('a')?.getAttribute('href')
      el.innerHTML = href
        ? `inkl. MwSt., ${frei ? '' : 'zzgl. '}<a href="${escHtml(href)}" target="_blank" rel="noopener">${frei ? 'versandkostenfrei' : `${escHtml(euro(versand))} Versand`}</a>`
        : `inkl. MwSt., ${escHtml(versandText)}`
    }
    const leistenPreis = $('#bv-leiste-preis')
    if (leistenPreis) leistenPreis.textContent = `ab ${euro(guenstigster)}`
    // Versandschwelle nur aus der Section-Einstellung (22.09.): leer heisst
    // kein Satz. Das Versandprofil in Shopify muss die Schwelle kennen.
    const versandfrei = $('#fk-versandfrei')
    if (versandfrei) {
      const satz = String(window.WUNOLO_VERSANDFREI || '').trim()
      versandfrei.textContent = satz
      versandfrei.hidden = !satz
    }
    const detailsVersand = $('#details-versand')
    // Die Schwelle steht fest im Markup, der Betrag kommt aus der Einstellung,
    // damit er mit der Preiszeile darueber zusammenpasst. Oesterreich (9,99)
    // stand hier bis zum 22.09. und ist wieder raus (Paul: zu viel Platz);
    // die Zahl steht in der Versandrichtlinie, auf die der Funnel verlinkt.
    if (detailsVersand) detailsVersand.textContent = `Alle Preise inkl. MwSt. Versand ab ${euro(versand)}, ab 55 € frei`
  }

  // Buchtitel und Cover kommen vom echten Produkt, wenn der Funnel im Shop
  // laeuft. Auf der eigenstaendigen Seite bleibt die neutrale Fassung stehen.
  if (window.WUNOLO_PRODUKT_TITEL) $('#fk-zf-titel').textContent = window.WUNOLO_PRODUKT_TITEL
  const cover = $('#fk-zf-cover')
  if (window.WUNOLO_PRODUKT_BILD && cover) {
    cover.src = window.WUNOLO_PRODUKT_BILD
    cover.hidden = false
  }
  // Das eigene Cover statt der Platzhalter-Grafik (23.09., Paul): Der letzte
  // Blick vor "In den Warenkorb" soll "das ist Mias Buch" sein, nicht
  // "irgendein Buch". Sobald die Vorschau ein Cover hat, tragen beide
  // Ausgabe-Kacheln und die Zusammenfassung dieses Cover; ohne Cover (kein
  // Foto, Pruefung zweimal gescheitert) bleiben die neutralen Grafiken.
  zeigeEigenesCover()
  const unter = $('#fk-zf-unter')
  if (unter) {
    const name = state.binding && $(`#binding [data-value="${state.binding}"]`)?.dataset.titel
    unter.textContent = name ? `${name} · personalisiert` : 'personalisiert'
  }
}

/* ------------------------------------------------------------ Navigation */
/* Der Weiter-Knopf sagt, warum er noch nicht aktiv ist (Handoff foto_schritt):
   im Fotoschritt je nach Zustand der Karte, sonst der Schrittname. */
function weiterText () {
  // Mit Namen (12.09., Paul): "Geschichte waehlen" beschreibt die Mechanik,
  // nicht das Ergebnis. Der Schritt davor heisst schon "Buchheldin zeichnen",
  // also bleibt der Ton gleich.
  //
  // Genitiv statt "fuer" oder "mit": "fuer Mia" waere ein Geschenk wie jedes
  // andere Kinderbuch, "mit Mia" trifft es inhaltlich, liesse sich aber auch
  // als "gemeinsam mit Mia aussuchen" lesen. "Mias Buch" sagt, dass es ihres
  // ist, ohne diese Doppeldeutigkeit.
  // Gemessen bei 375 px: im Knopf sind 292 px frei. "Geschichte mit
  // Charlotte-Sophie aussuchen" braucht 351 und bricht um, "Mias Buch
  // aussuchen" nur 171, "Charlotte-Sophies Buch aussuchen" 281.
  if (state.step === 3) {
    const z = state.fotoZustand || 'leer'
    if (z === 'leer') return 'Erst ein Foto auswählen'
    if (z === 'prueft') return 'Foto wird geprüft…'
    if (z === 'hinweis') return 'Anderes Foto wählen'
    // Ohne "Weiter:" (12.09., Paul): Das Wort sagt nichts, was der Knopf nicht
    // schon durch seine Stellung sagt, und kostet 66 px, die bei langen Namen
    // fehlen. Reicht das nicht, faellt der Name weg statt umzubrechen:
    // "Charlotte-Sophies Buchheldin zeichnen" braucht 353 px und macht aus dem
    // Knopf zwei Zeilen (87 statt 60 px hoch).
    const held = state.gender === 'girl' ? 'Buchheldin' : 'Buchheld'
    const ohne = tx(`${state.gender === 'girl' ? 'deine' : 'deinen'} ${held} zeichnen`, `${state.name.trim() || 'Dein Kind'} ins Buch holen`)
    const g = genitiv(state.name)
    const mit = AEHNLICH ? '' : (g ? `${g} ${held} zeichnen` : '')
    return mit && passtInKnopf(mit) ? mit : ohne
  }
  // Mit Poster ist "Dein Buch" nicht mehr der letzte Schritt (29.10.2026).
  if (state.step === BUCH_SCHRITT && letzterSchritt() > BUCH_SCHRITT) return 'Weiter'
  const labels = ['Weiter', 'Weiter', 'Weiter', 'Vorschau erstellen', 'Weiter', 'Zur Kasse', 'Zur Kasse']
  return labels[state.step]
}
/* Textseite links im aufgeschlagenen Layflat (03.11.2026, Paul: "eine
   Textseite von uns ... in dem gleichen Design"): die erste Textseite der
   Buchvorschau, gesetzt wie dort (bv-page bv-text, Schriftstufe des Buchs),
   also der Anfang des eigenen Buchs mit dem Namen des Kindes. Bis die
   Vorschau da ist, steht leeres Papier mit Federstrich und Seitenzahl. */
let lfTextseite = ''
function zeigeLayflatTextseite () {
  const html = lfTextseite || `<div class="bv-page bv-page-papier bv-text">${bvFuss(2)}</div>`
  for (const links of $$('#binding .fk-lf-links')) {
    if (links.dataset.inhalt === html) continue
    links.innerHTML = html
    links.dataset.inhalt = html
  }
}
function zeigeEigenesCover () {
  const url = state.coverUrl || null
  for (const kachel of $$('#binding .fk-ausgabe-bild')) {
    const symbol = kachel.querySelector('.fk-ausgabe-symbol')
    const buch = kachel.querySelector('.fk-buch')
    const eigenes = kachel.querySelector('.fk-ausgabe-cover')
    if (!symbol || !buch || !eigenes) continue
    if (url && eigenes.getAttribute('src') !== url) eigenes.src = url
    buch.hidden = !url
    symbol.hidden = Boolean(url)
    kachel.classList.toggle('mit-cover', Boolean(url))
  }
  if (url) zeigeLayflatTextseite()
  const zf = $('#fk-zf-cover')
  if (zf && url) { zf.src = url; zf.hidden = false }
}
function schreibeWeiterText () {
  const n = $('#next')
  if (n) n.textContent = weiterText()
  // Zahlungsarten nur unter dem Kaufknopf (23.09.): Auf den Schritten
  // davor ist noch nichts zu bezahlen, dort waere die Zeile Rauschen.
  const zahlarten = $('#fk-zahlarten')
  if (zahlarten) zahlarten.hidden = state.step !== letzterSchritt()
}

/*
 * Schrittwechsel im Verlauf des Browsers eintragen (13.09.).
 *
 * Der Funnel hatte bis heute keinen einzigen Verlaufseintrag: vier Schritte,
 * fuer den Browser eine einzige Seite. Auf dem Telefon fuehrt die
 * Zurueck-Wischgeste damit nicht einen Schritt zurueck, sondern aus dem Funnel
 * heraus, und beim Wiederkommen ist alles weg: Name, Aussehen, Foto,
 * Auftragsnummer, Figur. Der naechste Foto-Upload legt einen neuen Auftrag an,
 * also eine neue bezahlte Zeichnung.
 *
 * Gemessen am 13.09.: 26 von 68 Anlaeufen seit Werbestart waren
 * Wiederholungen desselben Vornamens, viele davon im Abstand von null bis
 * einer Minute. Karlo viermal, Niki fuenfmal. Keiner dieser Anlaeufe hatte
 * "Neu zeichnen lassen" benutzt, alle hatten ihre Versuche noch. In einer
 * Minute ueberlegt niemand, ob ihm die Figur gefaellt; da ist jemand
 * rausgeflogen und hat wieder angefangen. 98 von 115 Sitzungen sind mobil.
 *
 * Der erste Schritt bekommt replaceState, damit der Verlauf nicht mit einem
 * leeren Eintrag beginnt: Wer im ersten Schritt zurueckwischt, soll die Seite
 * wirklich verlassen.
 */
/* Rueckweg bei uebernommener Figur (04.11.2026, Paul: "wenn man in der
 * Buchvorschau einen Schritt zurueck will geht das nicht, und der Link oben
 * bei der Nummer fuer Schritte funktioniert auch nicht"). Bis dahin gab es auf
 * Schritt 4 keinen Zurueck-Knopf und die Schritte davor waren im Stepper
 * gesperrt, weil der Auftrag nie einen Kind- oder Fotoschritt hatte. Das gilt
 * auch nach dem Rueckweg aus der Kasse (auftragWiederherstellen).
 *
 * Zurueck heisst hier: noch einmal die Wahl des Kindes, mit den gespeicherten
 * Figuren und "Anderes Kind". Ueber ein Neuladen, damit vom Auftrag nichts im
 * Zustand bleibt (laufendes Cover, Buchvorschau, Poster). Die Messsitzung geht
 * weiter wie beim Rueckweg aus der Kasse; der Verlaufseintrag traegt bewusst
 * keinen Auftrag, sonst stellte ausKasseZurueck ihn wieder her. Ein Token in
 * der Adresse faellt weg, sonst uebernaehme figurAnbieten die Figur sofort.
 */
function zurueckZurKindwahl () {
  messe('zurueck_kindwahl')
  try {
    const u = new URL(location.href)
    u.searchParams.delete('figur')
    history.replaceState({ wunoloKasse: { sitzung: MESS_SITZUNG } }, '', u.pathname + u.search)
  } catch {}
  location.reload()
}
// Vor der Buchvorschau liegt bei uebernommener Figur nur die Wahl des Kindes.
const ruecksprungZurKindwahl = ziel => state.figurUebernommen && ziel < 4

function merkeSchritt (n) {
  try {
    const jetzt = history.state && typeof history.state.wunoloSchritt === 'number' ? history.state.wunoloSchritt : null
    if (jetzt === null) history.replaceState({ wunoloSchritt: n }, '')
    else if (jetzt !== n) history.pushState({ wunoloSchritt: n }, '')
  } catch {}
}

window.addEventListener('popstate', e => {
  const n = e.state && typeof e.state.wunoloSchritt === 'number' ? e.state.wunoloSchritt : null
  // Kein eigener Eintrag: Der Besucher ist vor unserem ersten Schritt, dann
  // gehoert das Zurueck dem Browser und er verlaesst die Seite.
  if (n === null) return
  // Zurueckwischen am Telefon ist derselbe Weg wie der Zurueck-Knopf.
  if (ruecksprungZurKindwahl(n)) return zurueckZurKindwahl()
  go(n, { ausHistory: true })
})

/*
 * Alles, was von der aktuellen Position abhaengt: Zurueck, Weiter, Stepper,
 * Kickerzeile, Fortschrittsbalken.
 *
 * An einer Stelle und nicht nur in go(), weil zwei Zustaende die Position
 * aendern, ohne einen Schritt zu wechseln: die fertige Zeichnung und die
 * offene Buchwahl. Vorher stand deshalb "Schritt 4 von 5 - Deine Figur" ueber
 * der Buchwahl, obwohl der Stepper daneben schon den fuenften Punkt zeigte.
 *
 * Welche Schritte hinter dem aktuellen noch Sinn ergeben
 * (13.09., zwei Befunde von Paul).
 *
 * Erstens: Der Zurueck-Knopf fuehrte von der grossen Vorschau auf den
 * Fotoschritt, und der zeigte eine leere Karte mit "Erst ein Foto auswaehlen".
 * Nach der Bestaetigung ist das Foto sogar geloescht. Name, Aussehen und Foto
 * sind in der Zeichnung aufgegangen; wer etwas anderes will, nimmt "Anderes
 * Kind oder neues Foto".
 *
 * Zweitens: Wurde die Figur uebernommen, gab es in diesem Auftrag nie einen
 * Fotoschritt und nie eine Aussehenswahl. Dann ist der Kaufschritt der erste
 * eigene Schritt, und hinter ihm liegt nichts.
 *
 * Muss auch ausserhalb von go() laufen: Beim normalen Weg steht die Zeichnung
 * erst fest, wenn der Schritt laengst gezeichnet ist.
 */
function aktualisiereSchrittanzeige () {
  const figurDa = Boolean(state.sheetUrl)
  /* Zurueck gibt es wieder auf Schritt 4 und 5 (13.09., Paul: "da fehlt der
     gut funktionierende Zurueck-Knopf"). Ich hatte ihn heute Mittag entfernt,
     weil er in eine Sackgasse fuehrte: Der Fotoschritt zeigte eine leere Karte
     und verlangte ein Foto, obwohl die Zeichnung schon stand. Die Sackgasse
     ist inzwischen weg, dort steht jetzt "Karl ist schon gezeichnet" mit dem
     Weg zurueck zur Zeichnung. Damit ist auch der Knopf wieder ehrlich.

     Eine Ausnahme bleibt, und zwar auf dem Figur-Schritt statt im Kaufschritt
     (13.09., zweite Korrektur nach Pauls Befund "in Schritt 5 gibt es immer
     noch kein Zurueck"): Bei einer uebernommenen Figur gab es in diesem
     Auftrag nie ein Foto, hinter Schritt 4 liegt also nichts. Aber davor liegt
     sehr wohl etwas, naemlich der Kaufschritt, aus dem man kam. Also fuehrt
     Zurueck im Kaufschritt ganz normal auf die Zeichnung, und auf der
     Zeichnung uebernimmt der Knopf "Zurueck zur Bestellung" direkt unter dem
     Bild. Ich hatte die Ausnahme zuerst andersherum gesetzt und damit
     ausgerechnet den Bildschirm ohne Rueckweg gelassen, auf dem man am
     laengsten steht. */
  // Seit 04.11.2026 auch bei uebernommener Figur auf Schritt 4: Er fuehrt dann
  // zurueck auf die Wahl des Kindes (zurueckZurKindwahl).
  const zurueck = $('#back')
  if (zurueck) zurueck.hidden = state.step === FIRST_STEP
  // Ueber den Verlauf des Browsers kommt man trotzdem auf den Fotoschritt.
  // Dann sagt der Kasten dort, dass die Zeichnung noch da ist.
  const schonGezeichnet = $('#foto-hat-figur')
  if (schonGezeichnet) schonGezeichnet.hidden = !(state.step === 3 && figurDa)
  /* Und auf dem Figur-Schritt selbst: Wer im Kaufschritt auf "Figur ansehen"
     tippt, landet vor einer 775 px hohen Zeichnung, und der Weiter-Knopf am
     Fuss liegt bei 1150 px. Ohne einen Weg direkt unter dem Bild sieht das
     aus wie eine Sackgasse (Befund Paul, 13.09.). Nur bei bestaetigter Figur
     und nur, wenn es ueberhaupt einen Kaufschritt gibt: Im Figur-Einstieg
     endet der Weg mit der Buchwahl. */
  /* Nur dort, wo es den normalen Zurueck-Knopf nicht gibt (13.09., Befund
     Paul: "dafuer hier zwei Zurueck-Button"). Bei einer uebernommenen Figur
     ist der Knopf in der Fussleiste ausgeblendet, weil hinter Schritt 4
     nichts liegt; dann traegt dieser hier den Weg zurueck, und zwar direkt
     unter dem Bild statt 1150 px tiefer. Im normalen Weg gibt es unten
     "Zurueck" und "Weiter" nebeneinander, da waere er der dritte Knopf mit
     derselben Aufgabe. */
  const zurueckKauf = $('#zurueck-zum-kauf')
  if (zurueckKauf) {
    // Erst mit fertigem Cover (04.11.2026, Paul): Waehrend es entstand, stand
    // der Knopf am Desktop zweizeilig neben der leeren Figur und fuehrte in
    // die Bestellung, bevor es ein Buch zu sehen gab.
    zurueckKauf.hidden = !(state.step === 4 && state.figurUebernommen && LETZTER_SCHRITT >= 5) || Boolean(state.coverLaeuft)
  }
  /* Der Weiter-Knopf verschwindet nur an zwei Stellen, und beide haben einen
     eigenen Weg nach vorn: auf der Angebotskarte (sie traegt "Ja, das ist
     Karl" und "Anderes Kind") und in der offenen Buchwahl (dort sind die
     Cover die Wahl). Sonst steht er immer, gerade im Kaufschritt. */
  const weiter = $('#next')
  if (weiter) {
    const angebotSteht = Boolean($('#figur-angebot') && !$('#figur-angebot').hidden)
    // Dritte Stelle (22.09., Paul): Wer aus der Bestellung "Figur ansehen"
    // tippt, hat den Weg nach vorn direkt unter dem Bild. Der Fuss-Knopf
    // darunter waere derselbe Knopf noch einmal, mit dem Mailkasten dazwischen.
    const rueckwegSteht = Boolean(zurueckKauf && !zurueckKauf.hidden)
    weiter.hidden = (state.step === FIRST_STEP && angebotSteht) || rueckwegSteht
  }
  zeichneStepper()
  schreibeKicker()
  const total = sichtbareSchritte().length
  const erreicht = sichtbareSchritte().indexOf(state.step) + 1
  const balken = $('#progress')
  if (balken) balken.style.width = `${(erreicht / total) * 100}%`
}

function go (n, { ausHistory = false } = {}) {
  // Wer die Buchvorschau verlaesst, hat fertig geblaettert: Tiefe melden (16.09.).
  if (state.step === 4 && n !== 4) seitenMelden()
  if (istUebersprungen(n)) n += n < state.step ? -1 : 1
  state.step = Math.max(FIRST_STEP, Math.min(letzterSchritt(), n))
  if (!ausHistory) merkeSchritt(state.step)
  steps.forEach((s, i) => s.classList.toggle('active', i === state.step))
  // Ab jetzt steuert das Skript die Sichtbarkeit. Die Sections zeigen
  // Schritt 1 per Inline-Regel nur, solange dieses Attribut fehlt (sonst
  // stand er unter jedem spaeteren Schritt, Befund Paul 07.09.).
  $('.funnel')?.setAttribute('data-fk-schritt', String(state.step))
  // Treppe: geoeffnet, dann je erreichtem Schritt eine Stufe. Gemeldet wird
  // beim Betreten, denn wer Schritt 3 sieht, hat Schritt 2 ausgefuellt.
  messe('schritt1')
  if (state.step >= 2) messe('schritt2', { alter: state.ageRange || undefined })
  if (state.step >= 3) messe('schritt3')
  if (state.step === 5) vorauswahlAusgabe()
  // Stand des Posters zum Buch holen, sobald die Vorschau steht (29.10.2026):
  // Er entscheidet, ob "Dein Buch" schon "Zur Kasse" traegt.
  if (state.step === 4 || state.step === BUCH_SCHRITT) posterStandHolen()
  aktualisiereSchrittanzeige()
  zeigeBuchLeiste()
  $$('.name-slot').forEach(el => { el.textContent = state.name || 'dein Kind' })
  // Die Widmungsvorschlaege tragen denselben Namen wie die Ueberschriften.
  zeigeWidmungswahl()
  // Genitiv fuer die Einwilligung: "Mias Figur", "Max’ Figur", ohne Namen
  // "die Figur". Dieselbe Regel wie in der Ueberschrift (s, x, z, ß).
  $$('.name-slot-genitiv').forEach(el => { el.textContent = genitiv(state.name) || 'die' })
  // Heldin statt Held bei Maedchen (Feedback aus der ersten Bestellung,
  // 11.08.). Stand fest im Markup und war damit fuer die Haelfte der Kinder
  // falsch, ausgerechnet auf der Seite, die das eigene Kind zeigt.
  $$('.held-slot').forEach(el => { el.textContent = state.gender === 'girl' ? 'Heldin' : 'Held' })
  // Gezielt zur Überschrift des aktiven Schritts, nicht blind nach oben:
  // Auf der Shop-Seite sitzt der Funnel unter drei Kopfzeilen, und nach dem
  // Schrittwechsel verschwand die Überschrift unter dem klebenden Kopf
  // (Befund 11.08., F2 im UX-Plan). scroll-margin-top steht im CSS.
  // Bewusst instant: Das Theme scrollt in einem eigenen Container mit
  // scroll-behavior smooth, und dessen Animation endete auf einer veralteten
  // Zielposition (232px daneben, 11.08.). Ein Sprung kann nicht driften.
  steps[state.step]?.scrollIntoView({ behavior: 'instant', block: 'start' })
  // "Zur Buchvorschau" versprach eine Seite, die es nicht gibt: Schritt 5 ist
  // die Ausgabenwahl, keine Vorschau des fertigen Buchs (Feedback 12.08.).
  schreibeWeiterText()
  // Nach der Buchwahl (Figur zuerst) gibt es keinen Weiter-Knopf mehr; wer
  // zurueckgeht, bekommt ihn wieder.
  // Knoepfe, Stepper, Kickerzeile und Balken haengen alle an
  // aktualisiereSchrittanzeige, weiter oben in dieser Funktion aufgerufen.
  aktualisiereZusammenfassung()
  // Der Textlink zurueck zur Produktseite steht nur im ersten Schritt, danach
  // uebernimmt "Zurueck" (Handoff).
  const rueckweg = $('#fk-rueckweg')
  if (rueckweg) rueckweg.hidden = state.step !== FIRST_STEP
  // Eine Fehlermeldung vom Kaufknopf gehoert nicht unter den naechsten Schritt.
  const kaufStatus = $('#kauf-status')
  if (kaufStatus) { kaufStatus.hidden = true; kaufStatus.textContent = '' }
  // Der Emoji-Hinweis steht, bis der Widmungsschritt verlassen wird.
  const emojiHinweis = $('#widmung-emoji-hinweis')
  if (emojiHinweis && state.step !== BUCH_SCHRITT) emojiHinweis.hidden = true
  validate()
  if (state.step === POSTER_SCHRITT) posterZeigen({ betreten: true })
  if (state.step === 3) turnstileHinweisPlanen()
  if (state.step === 4) schreibeFigurTexte()
  if (state.step === 4 && !state.previewStarted) startPreview()
  else if (state.step === 4 && state.geschichteGewechselt) coverNeu()
  // Wer den Schritt verlaesst, waehrend die Rueckfrage oder Vorher/Nachher
  // steht, hat sich entschieden: Rueckfrage weg, neue Figur nicht
  // uebernommen. Waehrend des Zeichnens bleibt das Overlay, der Server
  // zeichnet ohnehin weiter, und beim Zurueckkommen steht der Stand.
  if (state.step !== 4 && typeof nz === 'object' && nz.zustand && nz.zustand !== 'lauf') {
    if (nz.zustand === 'fertig') nzBehalten(); else nzZeige(null)
  }
}

function canAdvance () {
  switch (state.step) {
    case 0: return Boolean(state.storyId)
    case 1: return state.name.trim().length >= 2 && state.gender && state.age
    case 2: return state.hairColor && state.hairStyle && state.eyeColor
    // Mit Turnstile (16.09.): erst weiter, wenn der Bot-Check sein Token
    // geliefert hat, sonst kaeme vom Server ein 403 ohne Erklaerung. Ohne
    // Sitekey (lokal, oder Check aus) aendert sich nichts.
    case 3: return Boolean(state.consent && state.photoOk && (!turnstileSitekey() || state.turnstileToken))
    // Nicht, solange das Neu-zeichnen-Overlay steht (15.09.): Bestellen ist
    // waehrend des Zeichnens gesperrt, die Klasse setzt nzZeige.
    case 4: return Boolean(state.sheetUrl) && !document.body.classList.contains('bv-busy')
    case 5: return Boolean(state.binding)
    // "Zur Kasse" geht mit und ohne Poster, auch solange es noch entsteht.
    case 6: return Boolean(state.binding)
    default: return false
  }
}

function validate () {
  const knopf = $('#next')
  // Nicht entsperren, solange der Kauf laeuft (12.09.): validate() feuert bei
  // jedem Tastendruck in der Widmung und bei jeder Ausgabenwahl. Ohne diese
  // Zeile wurde der gesperrte Knopf wieder anklickbar, waehrend die Sperre
  // stand, und jeder Tipp fiel still durch. Im Browser nachgewiesen: drei
  // Klicks, keine Anfrage, keine Meldung.
  if (knopf.dataset.laeuft === '1') return
  knopf.disabled = !canAdvance()
  aktualisiereZusammenfassung()
}

/* ------------------------------------------------------------ Foto */
/* Die vorab hinterlegte Adresse aus dem Feld in den Zustand (13.09.). Sie
   dient nur dem Wiederfinden, deshalb ohne Werbe-Einwilligung: Der Server
   legt sie am Auftrag ab und schickt sie nicht an den Newsletter-Dienst.
   Seit dem 22.09. eine eigene Funktion, weil sie an zwei Stellen gebraucht
   wird: beim Auftrag zum Foto und beim Verlassen des ersten Schritts. */
function vorabMailUebernehmen () {
  const vorab = ($('#vorab-mail')?.value || '').trim()
  if (!vorab || vorab === state.vorabMail) return Boolean(state.vorabMail)
  state.vorabMail = vorab
  // Getrennt von mail_hinterlassen, siehe NEBENEREIGNISSE in messung.js.
  messe('mail_vorab')
  return true
}

/* Auftrag anlegen, sobald jemand seine Adresse dalaesst (22.09., Paul).
   Vorher entstand der Auftrag erst mit dem Foto; wer dazwischen ging,
   hinterliess nichts, und der Satz "Wir speichern deine Angaben" stimmte
   fuer diese Strecke nicht. Die Anlage kostet nichts, sie schreibt nur einen
   Datensatz: teuer wird erst das Zeichnen.

   Erst nach dem Aussehen-Schritt, nicht schon nach dem Namen: Die Route
   verlangt Haar- und Augenfarbe. Und ohne Adresse passiert weiterhin nichts,
   sonst stuende die Werkstatt voll mit Auftraegen von Leuten, die nie
   wiederkommen wollen.

   Der Auftrag entsteht dabei ohne Einwilligung fuers Foto, die kommt einen
   Schritt spaeter. Deshalb traegt einwilligungNachtragen() sie nach, sobald
   der Haken sitzt; ohne das bliebe der Auftrag auf false und der Upload
   liefe in ein 403 (der Server prueft das am Auftrag, nicht an der Anfrage). */
async function auftragSichern () {
  if (state.jobId || !vorabMailUebernehmen()) return
  if (!AEHNLICH && (!state.hairColor || !state.eyeColor)) return
  try { await ensureJob() } catch (err) { console.warn('[Auftrag sichern]', err) }
}

/*
 * Kurzer Neustart des Servers (23.10.2026, Paul: Deploys sollen Kundinnen im
 * Funnel nicht stoeren). Waehrend eines Deploys ist app.wunolo.de einige
 * Sekunden weg. Im Shop sieht der Browser das als Netzfehler (Railways
 * Fehlerseite traegt keine CORS-Kopfzeilen), auf app.wunolo.de selbst als
 * 502, 503 oder 504 ohne unser JSON. Statt einer Fehlermeldung wartet der
 * Funnel still, bis der Server wieder da ist, und schickt die Anfrage dann
 * noch einmal. Der Server haengt eine wiederholte Figur an den laufenden Lauf
 * und nimmt unterbrochene nach dem Start selbst wieder auf (laufend.js).
 *
 * Nur, wenn der Server wirklich weg ist: Antwortet /health, war es ein
 * abgebrochener langer Abruf (das iPhone legt nach gut 30 Sekunden auf), der
 * Server arbeitet weiter, und es bleibt beim Nachfragen der jeweiligen Stelle.
 * Eine eigene Zeitgrenze der Stelle (AbortSignal.timeout) ist ebenfalls kein
 * Neustart.
 */
// Sechs Minuten (23.10., Paul): Beim Schluesseltausch am 22.10. beendete
// Railway den alten Container zu frueh, app.wunolo.de war rund fuenf Minuten
// weg. Zwei Minuten haetten die Kundin dann doch die Fehlermeldung sehen lassen.
const NEUSTART_GEDULD_MS = 360000
async function serverAntwortet () {
  try {
    const res = await fetch((window.WUNOLO_BACKEND || '') + '/health', {
      cache: 'no-store',
      signal: typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(5000) : undefined
    })
    return res.ok
  } catch {
    return false
  }
}
async function istNeustartAntwort (res) {
  if (![502, 503, 504].includes(res.status)) return false
  // Unser Server antwortet auch mit 502 und 503 (Shopify weg, Budget), dann
  // immer mit { error }. Das soll die Kundin lesen, nicht abwarten.
  const daten = await res.clone().json().catch(() => null)
  return !(daten && typeof daten.error === 'string')
}
async function geduldig (anfrage) {
  const ende = Date.now() + NEUSTART_GEDULD_MS
  let warte = 1500
  for (;;) {
    try {
      const res = await anfrage()
      if (Date.now() > ende || !(await istNeustartAntwort(res))) return res
    } catch (err) {
      if (err?.name === 'AbortError' || err?.name === 'TimeoutError' || Date.now() > ende || await serverAntwortet()) throw err
    }
    console.info('[neustart] Server kurz weg, neuer Versuch in', warte, 'ms')
    await new Promise(r => setTimeout(r, warte))
    warte = Math.min(warte * 1.5, 6000)
  }
}

async function einwilligungNachtragen () {
  if (!state.jobId || !state.consent) return
  try {
    // Muster `fetch(`${BACKEND}/api/` beibehalten: sync-theme schreibt genau das auf
    // die Backend-Adresse um (toThemeJs), im Shop laeuft der Funnel sonst
    // gegen wunolo.de statt app.wunolo.de.
    await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/einwilligung`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }))
  } catch (err) { console.warn('[Einwilligung nachtragen]', err) }
}

async function ensureJob () {
  if (state.jobId) return state.jobId
  vorabMailUebernehmen()
  const res = await geduldig(() => fetch(BACKEND + '/api/jobs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      storyId: state.storyId, name: state.name, gender: state.gender, age: state.age, ageRange: state.ageRange,
      hairColor: state.hairColor, hairStyle: state.hairStyle, eyeColor: state.eyeColor,
      consent: state.consent,
      vorabMail: state.vorabMail || undefined,
      // Welcher Satz stand unter dem Feld (15.10.)? Ohne "Keine Werbung"
      // darf die Adresse in die Erinnerungen, siehe server.js.
      vorabHinweis: state.vorabMail ? (document.querySelector('#vorab-mail-zeile [data-hinweis]')?.dataset.hinweis || undefined) : undefined,
      messung: messKennung(),
      bildtest: AEHNLICH ? (BILD_VARIANTE || undefined) : undefined,
    }),
  }))
  const data = await res.json()
  if (!res.ok) throw new Error(data.error)
  state.jobId = data.jobId
  if (data.bildtest) bildVarianteMerken(data.bildtest)
  return state.jobId
}

/* --------------------------------- Foto-Karte (Handoff foto_schritt, 07.09.) */
/* Vier Zustaende auf einer Karte: leer, prueft, passt, hinweis. Beim Pruefen
   hakt alle 0,9 s eine Regel ab, die vierte dreht bis zur Antwort; danach
   werden die Regeln aus dem echten Pruefergebnis gesetzt (regelnAus). Der
   Dateiname erscheint nie, die Kundin sieht ihr Foto. */
const FOTO_REGELN = ['gesicht', 'kind', 'frei', 'scharf', 'gross']
// Keine Regel lehnt mehr ab (Paul, 15.09.), Gegenstueck zu FOTO_REGELN_AKTIV
// in src/fotoregeln.js: Die Karte zeigt nach dem Hochladen "Passt", ein
// nicht erfuellter Punkt bleibt offen statt rot, und nichts haelt auf.
const FOTO_REGELN_AKTIV = false
const FOTO_HINWEISE = {
  gesicht: n => `Das Gesicht ist zur Seite gedreht. Bitte ein Foto, auf dem ${n} in die Kamera schaut.`,
  // Nur noch Rueckfall: Den Text zur Regel "kind" waehlt kindHinweis nach
  // Befund. Der frueher hier stehende Sammelsatz behauptete zu viele Gesichter
  // auch dann, wenn das Modell gar keine Person erkannt hatte.
  kind: n => `Wir sehen mehr als eine Person im Bild. Bitte ein Foto, auf dem nur ${n} zu sehen ist, ${tx('dann klappt die Zeichnung sicher.', 'dann wird es sicher ähnlich.')}`,
  frei: () => 'Wir sehen eine Mütze oder Brille. Bitte ein Foto ohne, damit Haare und Augen sichtbar sind.',
  scharf: () => 'Das Foto ist unscharf oder zu dunkel. Bitte eines bei Tageslicht.',
  gross: n => `Das Gesicht ist sehr klein im Bild. Bitte ein Foto näher dran, sonst können wir ${n} nicht erkennen.`
}

/* Die vier Regeln aus der Antwort der Foto-Pruefung (PHOTO_CHECK_PROMPT). */
/*
 * Aus der Pruefantwort die vier Regeln ableiten, die auf der Karte stehen.
 *
 * "kind" zaehlt seit dem 13.09. Personen, nicht Kinder: Massgeblich ist, dass
 * GENAU EINE Person im Bild ist. Ob das Modell sie als Kind oder Erwachsenen
 * einstuft, entscheidet nicht mehr ueber die Ablehnung.
 *
 * Grund: Von acht endgueltig abgelehnten Fotos betrafen sieben die
 * Altersspanne "8+", bei nur einem angenommenen aus dieser Spanne. Fuenfmal
 * meldete das Modell null Kinder, viermal davon dieselbe Person als
 * Erwachsenen. Die Mutter eines Neunjaehrigen sah ihr Kind auf dem Foto und
 * las "Wir sehen mehr als ein Gesicht im Bild". Wer ein Bild von sich selbst
 * hochlaedt, bekommt jetzt eine Zeichnung von sich; das ist seine
 * Entscheidung und allemal besser, als die Haelfte der Schulkinder
 * auszusperren.
 */
/* Wie viele Personen sieht das Modell? Seit dem 13.09. fragt der Prompt nur
   noch danach. Die beiden alten Zahlen stehen als Rueckfall, weil Antworten
   von vor der Umstellung noch in den Auftraegen liegen. */
function personenIm (check) {
  if (typeof check?.person_count === 'number') return check.person_count
  return (check?.children_count ?? 0) + (check?.adults_count ?? 0)
}

function regelnAus (check) {
  if (!check || typeof check !== 'object') return null
  const personen = personenIm(check)
  return {
    gesicht: check.face_clearly_visible !== false && ['frontal', 'three_quarter'].includes(check.face_angle),
    kind: check.is_photograph !== false && personen === 1,
    frei: !check.face_obscured_by || check.face_obscured_by === 'none',
    scharf: ['sharp', 'slightly_blurry'].includes(check.sharpness) && ['good', 'harsh_shadows'].includes(check.lighting),
    // Siehe src/fotoregeln.js: Die Gesichtsgroesse hing frueher am
    // Gesamturteil des Modells und fiel mit ihm weg. Ohne genug Pixel im
    // Gesicht erfindet das Modell die Zuege.
    gross: typeof check.face_share !== 'number' || check.face_share >= 0.10
  }
}

/* Ein Gesicht klar zu sehen und genau eine Person, auch wenn das Modell es
   fuer kein echtes Foto haelt. */
function gesichtDa (check) {
  return check?.face_clearly_visible === true && personenIm(check) === 1
}

/* Welcher Satz zur Ablehnung passt: Niemand erkannt, zu viele, oder gar kein
   Foto. Vorher stand in allen drei Faellen "Wir sehen mehr als ein Gesicht". */
function kindHinweis (check, name) {
  const wer = name || 'dein Kind'
  if (check?.is_photograph === false) return `Das sieht nach einer Zeichnung oder einem Bildschirmfoto aus. Wir brauchen ein echtes Foto von ${wer}.`
  const personen = personenIm(check)
  if (personen === 0) return `Wir erkennen niemanden auf dem Bild. Bitte ein Foto, auf dem ${wer} gut zu sehen ist.`
  return `Wir sehen mehr als eine Person im Bild. Bitte ein Foto, auf dem nur ${wer} zu sehen ist, ${tx('dann klappt die Zeichnung sicher.', 'dann wird es sicher ähnlich.')}`
}

function setzeFotoZustand (zustand, { regeln = {}, laeuft = 0, hinweis = '' } = {}) {
  state.fotoZustand = zustand
  const karte = $('#fotokarte')
  if (karte) karte.dataset.zustand = zustand
  $$('#fk-checks li').forEach((li, i) => {
    const r = FOTO_REGELN[i]
    // 'fehler' ist ein technischer Abbruch, kein Foto-Befund (09.09.):
    // Die Haken bleiben offen statt gruen, sonst behauptet die Anzeige,
    // das Foto sei geprueft worden.
    li.dataset.zustand = zustand === 'passt' ? (regeln[r] === false ? 'offen' : 'ok')
      : zustand === 'hinweis' ? (regeln[r] === false ? 'fehlt' : 'ok')
        : zustand === 'prueft' ? (i < laeuft ? 'ok' : i === laeuft ? 'laeuft' : 'offen')
          : 'offen'
  })
  const titel = $('#fk-statustitel')
  if (titel) {
    titel.textContent = zustand === 'prueft' ? 'Wir schauen kurz drauf…'
      : zustand === 'passt' ? tx('Passt. Damit können wir zeichnen.', `Passt. Damit kommt ${state.name.trim() || 'dein Kind'} ins Buch.`)
        : zustand === 'hinweis' ? 'Ein Punkt passt noch nicht'
          : zustand === 'fehler' ? 'Ups, das hat nicht geklappt' : ''
  }
  const box = $('#fk-fotohinweis')
  if (box) { box.hidden = !hinweis; box.textContent = hinweis || '' }
  // Der Ausweg gehoert nur zum technischen Abbruch: Bei einem echten Befund
  // ("Muetze auf") hilft kein zweiter Versuch mit demselben Bild, da fuehrt
  // "Anderes Foto" im Kartenfuss weiter.
  const nochmal = $('#foto-nochmal')
  if (nochmal) nochmal.hidden = zustand !== 'fehler' || !state.fotoDatei
  schreibeWeiterText()
}

/* Lange Kante des hochgeladenen Fotos. Gemini bekommt ohnehin nur eine
   skalierte Fassung zu sehen, und die Zeichnung braucht das Gesicht, nicht
   die Poren. Dasselbe Bild wird spaeter zum Zeichnen weiterverwendet,
   deshalb nicht kleiner. */
const FOTO_KANTE = 1600
const FOTO_GUETE = 0.85
const FOTO_FORMATE = ['image/jpeg', 'image/png', 'image/webp']

/* Bild aus einer Datei laden. createImageBitmap ist der kurze Weg, kann aber
   HEIC nicht ueberall; das Bildelement nutzt den Decoder des Systems, und
   der kann es auf dem iPhone. */
function ladeBild (file) {
  const ueberElement = () => new Promise((erfuellen, ablehnen) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => { URL.revokeObjectURL(url); erfuellen(img) }
    img.onerror = () => { URL.revokeObjectURL(url); ablehnen(new Error('Bild nicht lesbar')) }
    img.src = url
  })
  if (typeof createImageBitmap === 'function') {
    return createImageBitmap(file).catch(ueberElement)
  }
  return ueberElement()
}

/**
 * Foto vor dem Hochladen verkleinern.
 *
 * Bis 09.09. ging die Datei roh aus der Kamera zum Server, auf einem iPhone
 * gern vier bis acht Megabyte. Hochladen, Umwandeln und die Pruefung durch
 * Gemini hingen alle an einer einzigen Anfrage, und im Mobilfunk riss sie
 * ab, bevor eine Antwort kam: "Load failed", ohne dass am Foto etwas falsch
 * war. Mit 1600 px bleiben rund dreihundert Kilobyte uebrig.
 *
 * Nebenbei wird das Format verlaesslich: Der Server nimmt nur JPEG, PNG und
 * WebP. Die Auswahlliste im Formular haelt HEIC schon fern, iOS wandelt beim
 * Auswaehlen um. Ueber die Leinwand kommt aber in jedem Fall ein JPEG heraus,
 * auch wenn ein Geraet sich einmal nicht daran haelt.
 *
 * Geht etwas schief, faehrt die Originaldatei raus. Ein Foto, das gross
 * ankommt, ist besser als eines, das gar nicht ankommt.
 */
async function verkleinereFoto (file) {
  if (typeof document === 'undefined' || !file) return file
  let bild = null
  try {
    bild = await ladeBild(file)
    const breite = bild.width || bild.naturalWidth
    const hoehe = bild.height || bild.naturalHeight
    if (!breite || !hoehe) return file
    const faktor = Math.min(1, FOTO_KANTE / Math.max(breite, hoehe))
    // Schon klein genug und in einem Format, das der Server nimmt: nichts tun.
    if (faktor === 1 && FOTO_FORMATE.includes(file.type)) return file
    const leinwand = document.createElement('canvas')
    leinwand.width = Math.round(breite * faktor)
    leinwand.height = Math.round(hoehe * faktor)
    leinwand.getContext('2d').drawImage(bild, 0, 0, leinwand.width, leinwand.height)
    const blob = await new Promise(r => leinwand.toBlob(r, 'image/jpeg', FOTO_GUETE))
    return blob || file
  } catch (err) {
    console.warn('[foto] Verkleinern nicht moeglich, Original geht raus:', err)
    return file
  } finally {
    if (bild && typeof bild.close === 'function') bild.close()
  }
}

/**
 * Nach einem Verbindungsabbruch den Befund am Auftrag nachfragen.
 *
 * Gleiches Muster wie warteAufFigur() beim Zeichnen: Der Server prueft zu
 * Ende, auch wenn die Antwort die Kundin nie erreicht. Die Marke sorgt
 * dafuer, dass wir den Befund zu unserem Foto abwarten und nicht den eines
 * frueheren Versuchs fuer eine Antwort halten.
 */
async function warteAufFotoPruefung (marke) {
  if (!state.jobId) return null
  const ende = Date.now() + 120000
  while (Date.now() < ende) {
    await new Promise(r => setTimeout(r, 3000))
    try {
      const res = await fetch(`${BACKEND}/api/jobs/${state.jobId}?t=${Date.now()}`, { cache: 'no-store' })
      if (!res.ok) continue
      const job = await res.json()
      if (!job.photoCheck || job.photoCheckMarke !== marke) continue
      // Nicht das Gesamturteil des Modells, sondern unsere eigenen Regeln
      // (13.09.): Sonst haette ein nachgeholter Befund andere Folgen als der
      // erste, und Fotos mit einer erwachsen wirkenden Person fielen wieder
      // durch, obwohl der Server sie angenommen hat.
      //
      // ALLE Regeln, auch gross (13.09., zweiter Durchgang): Hier standen vier
      // von fuenf, gross fehlte. Nach einem Verbindungsabbruch sagte die Karte
      // deshalb "Passt", waehrend der Server dasselbe Foto verworfen hatte, und
      // der naechste Schritt antwortete "Kein Foto vorhanden". Die Liste muss
      // dieselbe sein wie in fotoBrauchbar() auf der Serverseite.
      const r = regelnAus(job.photoCheck)
      return { check: job.photoCheck, usable: !FOTO_REGELN_AKTIV || Boolean(r && r.gesicht && r.kind && r.frei && r.scharf && r.gross), ohnePerson: Boolean(job.ohnePerson) }
    } catch {
      // Verbindung noch tot, naechster Versuch
    }
  }
  return null
}

/* Befund anzeigen. Steht fuer sich, weil ihn zwei Wege liefern: die Antwort
   auf das Hochladen und die Nachfrage nach einem Abbruch. */
/* Keine Person im Bild (16.09., Paul): Hinweis, aber weiter. Der Server
   zeichnet dann unser Modellkind nach den Angaben im Formular. */
function ohnePersonHinweis (check = null) {
  const name = state.name.trim() || 'dein Kind'
  const alter = { '2-3': '2 bis 3 Jahre', '4-5': '4 bis 5 Jahre', '6-7': '6 bis 7 Jahre', '8+': '8 bis 10 Jahre' }[state.ageRange] || (state.age ? `${state.age} Jahre` : '')
  // Beugung fuer "blonde, lockige Haare, blaue Augen": Grundform klein plus e;
  // Haselnuss ist die Ausnahme.
  const beuge = w => { const g = String(w || '').toLowerCase(); return g === 'haselnuss' ? 'haselnussbraune' : g ? g + 'e' : '' }
  const haare = [state.hairColor && beuge(farbName('hair', state.hairColor)), state.hairStyle && beuge(HAAR_STIL[state.hairStyle])].filter(Boolean).join(', ')
  const angaben = [state.gender === 'boy' ? 'Junge' : 'Mädchen', alter, haare && `${haare} Haare`, state.eyeColor && `${beuge(farbName('eyes', state.eyeColor))} Augen`].filter(Boolean).join(', ')
  if (AEHNLICH) {
    // Fotostil (20.10.2026): ohne Gesicht geht es nicht weiter, also sagen,
    // was hilft und wo der Knopf ist.
    const weiter = `Tipp unten auf "Anderes Foto", am besten eins, auf dem ${name} allein und von vorn zu sehen ist.`
    // KI-Bild oder abfotografierter Bildschirm mit gut sichtbarem Gesicht
    // (29.10.2026, Pauls Testfoto): eigener, kurzer Satz statt "kein Gesicht,
    // zu dunkel". Das Modell urteilt hier nicht immer gleich; wer das Original
    // noch einmal aus der Galerie nimmt, kommt meist durch.
    if (check?.is_photograph === false && gesichtDa(check)) return 'Das sieht nicht nach einem Originalfoto aus. Bitte lade das Foto direkt aus deiner Galerie hoch.'
    if (check?.is_photograph === false) return `Auf diesem Bild erkennen wir kein Foto mit Gesicht, vielleicht ist es zu dunkel angekommen. In diesem Buch kommt ${name} mit dem echten Gesicht ins Buch. ${weiter}`
    return `Wir erkennen kein Gesicht auf dem Bild. In diesem Buch kommt ${name} mit dem echten Gesicht ins Buch, deshalb brauchen wir ein Foto, auf dem das Gesicht gut zu sehen ist. ${weiter}`
  }
  return `Wir erkennen kein Gesicht auf dem Bild. Wir zeichnen ${name} deshalb nach deinen Angaben: ${angaben}. Du kannst weitergehen oder ein anderes Foto wählen.`
}

function uebernehmeFotoBefund (check, usable, ohnePerson = false) {
  const regeln = regelnAus(check) || {}
  state.ohnePerson = Boolean(ohnePerson)
  // Fotostil ohne Gesicht (20.10.2026, Paul): Bisher stand hier gruen "Passt"
  // mit dem Satz, dass wir ein Foto mit Gesicht brauchen, und Weiter blieb
  // offen. Die Vorschau scheiterte dann am Server (GESICHT_NOETIG), und
  // "Nochmal" schickte dasselbe Foto erneut: drei Menschen gingen so zwischen
  // 16. und 18.10. Jetzt "Ein Punkt passt noch nicht", Weiter gesperrt, und
  // "Anderes Foto" im Kartenfuss fuehrt weiter. Ein schwarzes Bild oder gar
  // kein Foto (is_photograph false, 17.10.) gehoert in denselben Zweig.
  const ohneGesichtImFotostil = AEHNLICH && (state.ohnePerson || check?.is_photograph === false)
  if (ohneGesichtImFotostil) {
    state.photoOk = false
    // Kein echtes Foto, aber ein Gesicht zu sehen: Die Haken zeigen den
    // wahren Befund, statt "Gesicht von vorn" und "Nur eine Person" rot zu
    // markieren; was fehlt, sagt der Hinweis (29.10.2026).
    const kiBild = !state.ohnePerson && check?.is_photograph === false && gesichtDa(check)
    setzeFotoZustand('hinweis', { regeln: kiBild ? { ...regeln, kind: true } : { ...regeln, gesicht: false }, hinweis: ohnePersonHinweis(check) })
    messe('foto_abgelehnt', { grund: kiBild ? 'kein_foto' : 'ohne_gesicht' })
    if (state.ohnePerson) messe('foto_ohne_person')
  } else if (!usable && FOTO_REGELN_AKTIV) {
    state.photoOk = false
    const fehlt = FOTO_REGELN.find(r => regeln[r] === false)
    const name = state.name.trim() || 'dein Kind'
    // Bei "kind" haengt der Satz vom Befund ab: niemand erkannt, zu viele oder
    // gar kein Foto. Vorher stand in allen drei Faellen dasselbe, und bei
    // "niemand erkannt" war es sachlich falsch (13.09.).
    const hinweis = fehlt === 'kind'
      ? kindHinweis(check, name)
      : fehlt ? FOTO_HINWEISE[fehlt](name) : (check?.hint_de || 'Bitte ein anderes Foto wählen.')
    setzeFotoZustand('hinweis', { regeln, hinweis })
    // Der Grund als Kurzform (welche Regel fiel durch), damit sichtbar wird,
    // ob es an Schaerfe, Gesicht oder Format liegt. Kein Bild, kein Text der
    // Kundin, nur die Regel-Kennung.
    messe('foto_abgelehnt', { grund: fehlt || 'ohne Regel' })
  } else {
    state.photoOk = true
    setzeFotoZustand('passt', { regeln, hinweis: state.ohnePerson ? ohnePersonHinweis() : '' })
    messe('foto_ok')
    if (state.ohnePerson) messe('foto_ohne_person')
  }
  // Ein neues Foto macht eine bereits erzeugte Figur ungueltig. Ohne das
  // blieb die alte Vorschau stehen, weil startPreview() nur einmal laeuft:
  // Das Kind auf dem Bild waere dann ein anderes als das hochgeladene.
  if (state.previewStarted) {
    state.previewStarted = false
    state.sheetUrl = null
    state.variants = null
    // Auch die Bestaetigung faellt (07.09.): Sonst haette bestaetigeFigur()
    // die neue Figur uebersprungen und das neue Foto laege bis zum
    // Aufraeumlauf. Auch ein Token wird vergessen.
    state.sheetChosen = false
    state.figurToken = null
    state.figurLink = null
  }
}

/* Neuer Auftrag nach einem Foto fuer ein Buch, das schon im Warenkorb liegt
   (18.10., #1041). Figur, Vorschau und Token gehoeren zum alten Auftrag. */
function neuerAuftragFuerFoto (jobId) {
  state.jobId = jobId
  state.coverUrl = null
  state.previewStarted = false
  state.sheetUrl = null
  state.variants = null
  state.sheetChosen = false
  state.figurToken = null
  state.figurLink = null
}

async function uploadPhoto (file) {
  const box = $('#photo-feedback')
  // Ohne Einwilligung legt ensureJob() sonst einen Auftrag mit
  // consent:false an, der dauerhaft "Einwilligung fehlt" liefert, auch
  // nachdem die Checkbox spaeter noch angehakt wird (derselbe Auftrag wird
  // ja weiterverwendet). Deshalb hier abfangen, bevor ueberhaupt ein
  // Auftrag entsteht.
  if (!state.consent) {
    box.innerHTML = '<div class="notice warn">Bitte bestätige zuerst die Einwilligung weiter unten, dann kannst du das Foto hochladen.</div>'
    return
  }
  box.innerHTML = ''
  state.photoOk = false
  // Fuer den Knopf "Nochmal versuchen": Nach einem Verbindungsabbruch soll
  // die Kundin nicht erst wieder durch ihre Galerie suchen muessen.
  state.fotoDatei = file
  // Foto sofort lokal zeigen, waehrend Upload und Pruefung laufen. Dient
  // spaeter auch der Vorlage-Karte der Warte-Animation.
  state.fotoUrl = URL.createObjectURL(file)
  const bild = $('#fk-fotobild')
  if (bild) bild.src = state.fotoUrl
  let dran = 0
  setzeFotoZustand('prueft', { laeuft: 0 })
  const ticker = setInterval(() => { dran = Math.min(3, dran + 1); setzeFotoZustand('prueft', { laeuft: dran }) }, 900)
  const marke = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 10)
  messe('foto_start')
  try {
    const jobId = await ensureJob()
    const klein = await verkleinereFoto(file)
    const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${jobId}/photo?marke=${encodeURIComponent(marke)}`, {
      method: 'POST',
      headers: { 'Content-Type': klein.type || 'image/jpeg' },
      body: klein,
    }))
    const data = await res.json()
    // Buch lag schon im Warenkorb (18.10., #1041): Der Server hat fuer dieses
    // Foto einen neuen Auftrag angelegt. Ab jetzt laeuft alles ueber ihn, das
    // Buch im Warenkorb bleibt mit seinem Kind, wie es war.
    if (data?.jobId && data.jobId !== state.jobId) neuerAuftragFuerFoto(data.jobId)
    if (!res.ok) {
      // Eine Antwort ist angekommen, der Server hat also etwas zu sagen
      // ("Einwilligung fehlt", Budget, zu viele Versuche). Das ist kein
      // Verbindungsproblem und darf nicht als eines beschoenigt werden.
      const fehler = new Error(data.error || 'Upload fehlgeschlagen')
      fehler.vomServer = true
      fehler.code = data.code || null
      throw fehler
    }
    clearInterval(ticker)
    uebernehmeFotoBefund(data.check, data.usable, data.ohnePerson)
  } catch (err) {
    console.warn('[foto] Pruefung abgebrochen:', err)
    // Verbindung weg, der Server prueft zu Ende. Erst nachfragen, bevor die
    // Kundin dasselbe Foto ein zweites Mal hochlaedt (09.09., gleiches
    // Muster wie beim Zeichnen). Der Takt laeuft waehrenddessen weiter,
    // sonst stuende die Anzeige still, obwohl im Hintergrund noch etwas
    // passiert.
    // Nur nachfassen, wenn keine Antwort kam. Hat der Server geantwortet,
    // gibt es nichts nachzuholen; am 09.09. wartete Pauls Telefon zwei
    // Minuten auf einen Befund, den der Server laengst verneint hatte.
    const nachgeholt = err.vomServer ? null : await warteAufFotoPruefung(marke)
    clearInterval(ticker)
    if (nachgeholt) {
      uebernehmeFotoBefund(nachgeholt.check, nachgeholt.usable, nachgeholt.ohnePerson)
    } else {
      state.photoOk = false
      // Ein technischer Abbruch sagt nichts ueber das Foto, deshalb ein
      // eigener Zustand statt 'hinweis'. Bis 09.09. behauptete die
      // Ueberschrift "Ein Punkt passt noch nicht", waehrend alle vier Haken
      // gruen blieben und darunter "Load failed" stand.
      // Bei FOTO_NICHT_PRUEFBAR hat Googles Sperrfilter das Bild abgelehnt
      // (09.09., Pauls Sommerfoto mit nackten Schultern: PROHIBITED_CONTENT).
      // Der Server kennt den Namen nicht, deshalb entsteht der Satz hier,
      // und er sagt, welches Foto stattdessen klappt, statt nur "ein anderes".
      // Dativ: "von Emma", aber "von deinem Kind", nicht "von dein Kind".
      const name = state.name.trim() || 'deinem Kind'
      const hinweis = err.code === 'FOTO_NICHT_PRUEFBAR'
        ? `Die automatische Prüfung lehnt dieses Foto ab. Am besten klappt ein Bild von ${name} vom Kopf bis zu den Schultern, mit T-Shirt oder Pulli, bei Tageslicht.`
        : err.vomServer
          ? err.message
          : 'Das lag nicht an deinem Foto, die Verbindung war kurz weg. Dein Bild haben wir noch, ein Tipp auf den Knopf genügt.'
      setzeFotoZustand('fehler', { regeln: {}, hinweis })
      // Sagt der Server, dieses Foto lasse sich nicht pruefen, bringt derselbe
      // Knopf mit demselben Bild nichts. Dann bleibt "Anderes Foto".
      if (err.code === 'FOTO_NICHT_PRUEFBAR') { const k = $('#foto-nochmal'); if (k) k.hidden = true }
    }
  }
  validate()
}

/* ------------------------------------------------------------ Vorschau */
/* Cloudflare Turnstile: schuetzt die kostenpflichtige Vorschau vor Bots.
   Ohne gesetzten Sitekey passiert nichts, damit lokal nichts blockiert. */
/* Sitekey aus dem Theme, oder zum Ausprobieren aus der Adresse
   (?turnstile=<sitekey>, 16.09.): So laesst sich der Check auf einem echten
   Telefon pruefen, ohne ihn fuer alle einzuschalten. Der Sitekey ist
   oeffentlich, der Server prueft nur mit seinem geheimen Schluessel. */
function turnstileSitekey () {
  try {
    const probe = new URLSearchParams(location.search).get('turnstile')
    if (probe && /^0x[A-Za-z0-9_-]{10,}$/.test(probe)) return probe
  } catch {}
  return window.WUNOLO_TURNSTILE_SITEKEY || ''
}

function initTurnstile () {
  const sitekey = turnstileSitekey()
  if (!sitekey) return
  let gerendert = false
  const zeichnen = () => {
    if (gerendert) return true
    if (typeof window.turnstile?.render !== 'function') return false
    gerendert = true
    window.turnstile.render('#wunolo-turnstile', {
      sitekey,
      // Der Weiter-Knopf von Schritt 3 haengt am Token (canAdvance), deshalb
      // nach jeder Aenderung neu pruefen. Laeuft das Token ab oder scheitert
      // der Check, weg damit, Turnstile versucht es von selbst noch einmal.
      callback: token => { state.turnstileToken = token; const h = $('#turnstile-hinweis'); if (h) h.hidden = true; validate() },
      'expired-callback': () => { state.turnstileToken = null; validate() },
      'error-callback': () => { state.turnstileToken = null; validate() },
    })
    return true
  }
  // Auf wunolo.de belegt schon ein anderes Skript window.turnstile (Shopify
  // schuetzt eigene Formulare damit), ohne render(). Deshalb nicht am
  // Ladeereignis unseres Skripts haengen, sondern Cloudflares eigenen
  // onload-Rueckruf nutzen und zur Sicherheit nachsehen, bis render() da ist
  // (16.09., live: "window.turnstile?.render is not a function", und weil
  // Schritt 3 aufs Token wartet, stand jeder Kunde davor).
  window.wunoloTurnstileBereit = () => { zeichnen() }
  if (!zeichnen() && !document.querySelector('script[src*="turnstile/v0/api.js"][data-wunolo]')) {
    const script = document.createElement('script')
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=wunoloTurnstileBereit'
    script.async = true
    script.dataset.wunolo = '1'
    document.head.appendChild(script)
  }
  let versuche = 0
  const takt = setInterval(() => {
    versuche += 1
    if (zeichnen() || versuche > 40) clearInterval(takt)
  }, 500)
}

/* Kein stummer Knopf (16.09.): Bleibt das Token 15 Sekunden nach dem
   Betreten von Schritt 3 aus, steht unter dem Widget, was zu tun ist. Kommt
   es doch noch, verschwindet der Satz wieder. */
let turnstileHinweisTimer = null
function turnstileHinweisPlanen () {
  const hinweis = $('#turnstile-hinweis')
  if (!hinweis) return
  clearTimeout(turnstileHinweisTimer)
  hinweis.hidden = true
  if (!turnstileSitekey() || state.turnstileToken) return
  turnstileHinweisTimer = setTimeout(() => {
    hinweis.hidden = Boolean(state.turnstileToken) || state.step !== 3
  }, 15000)
}

/* Weiche Illustrationstoene fuer die Haar-Flaeche der Warte-Animation
   (Handoff 02.09.): keine Vollfarben, sieben Auswahlwerte auf fuenf Toene
   gemappt. */
const HAAR_ANIMATION = {
  'light blonde': '#F2DFA8', 'blonde': '#D9B36A', 'dark blonde': '#D9B36A',
  'light brown': '#9C6B43', 'brown': '#9C6B43', 'black': '#3B4252', 'red': '#C96F3B',
}

/* -------------------------------------- Fortschritt (Handoff v2, 07.09.) */
/* Die Figur entsteht in einem einzigen Gemini-Aufruf ohne Zwischenstand. Der
   Prozentwert ist deshalb eine Zeitschaetzung: Der Server meldet Median und
   90. Perzentil der letzten Laeufe (GET /api/figur-dauer), die Kurve
   p = 100 * (1 - (1 - t/T)^1.6) erreicht beim Median etwa 88 und haelt bei
   96, bis das Bild wirklich da ist. Dann 100 und Ueberblendung. Nie
   rueckwaerts, nie 100 vorher. */
// Testballon (06.10.): Kopftausch, Figur und Cover parallel ueber Flash,
// eigene Vorgabe und eigene Messreihe auf dem Server (?stil=aehnlich).
const FIGUR_DAUER_VORGABE = AEHNLICH ? { medianMs: 30000, p90Ms: 50000 } : { medianMs: 20000, p90Ms: 40000 }
const FORTSCHRITT_SCHRITTE = AEHNLICH ? ['Foto anschauen', 'Gesicht übernehmen', 'Haare anpassen', 'Aufs Cover setzen'] : ['Foto anschauen', 'Konturen zeichnen', 'Farben mischen', 'Aufs Cover setzen']

function fortschrittWerte (tSek, medianSek, p90Sek) {
  const T = Math.max(20, medianSek * 1.36)
  const x = Math.min(1, tSek / T)
  const prozent = Math.min(96, Math.round(100 * (1 - Math.pow(1 - x, 1.6))))
  const phase = prozent < 12 ? 0 : prozent < 58 ? 1 : prozent < 86 ? 2 : 3
  const rest = Math.max(0, T - tSek)
  const zeit = tSek > p90Sek ? 'dauert heute etwas länger'
    : rest > 90 ? 'noch etwa zwei Minuten'
      : rest > 45 ? 'noch etwa eine Minute'
        : rest > 12 ? 'noch unter einer Minute' : 'gleich fertig'
  return { prozent, phase, label: FORTSCHRITT_SCHRITTE[phase], meta: `Schritt ${phase + 1} von 4 · ${zeit}`, fertig: false }
}

function zeigeFortschritt ({ prozent, label, meta, fertig }) {
  const bar = $('#wu-ring-bar')
  if (bar) bar.style.strokeDashoffset = String(100 - prozent)
  const p = $('#wu-prozent')
  if (p) p.textContent = String(prozent)
  const name = $('#wu-schrittname')
  if (name) name.textContent = label
  const dots = $('#wu-dots')
  if (dots) dots.hidden = Boolean(fertig)
  const m = $('#wu-meta')
  if (m) m.textContent = meta
}

function schreibeDauerHinweis (dauer) {
  const el = $('.wu-dauer')
  if (!el) return
  const grob = dauer.medianMs < 75000 ? 'etwa eine Minute' : 'etwa zwei Minuten'
  el.textContent = `Dauert meist ${grob}. Du kannst das Fenster offen lassen, ${tx('wir zeichnen weiter.', 'wir arbeiten weiter.')}`
}

async function fortschrittFertig () {
  zeigeFortschritt({ prozent: 100, label: tx('Fertig gezeichnet', 'Fertig'), meta: tx('Deine Hauptfigur ist da', 'Dein Kind ist im Buch'), fertig: true })
  await new Promise(r => setTimeout(r, 700))
}

/* Passt der Text in eine Zeile des Weiter-Knopfs? Die Zeichenzahl taugt dafuer
   nicht: "Charlotte-Sophies" (17 Zeichen) braucht 281 px, "Wolfgang-Wilhelmis"
   (18) schon 303 und damit mehr als die 292 px, die bei 375 px frei sind. Also
   mit der wirklich gesetzten Schrift messen. Ist der Knopf gerade nicht
   sichtbar, greift 17 Zeichen als Notbremse. */
let stift = null
function passtInKnopf (text, el = $('#next')) {
  if (!el) return text.length <= 31
  const cs = getComputedStyle(el)
  const frei = el.getBoundingClientRect().width -
    parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) -
    parseFloat(cs.borderLeftWidth) - parseFloat(cs.borderRightWidth)
  if (!(frei > 0)) return text.length <= 31
  if (!stift) stift = document.createElement('canvas').getContext('2d')
  stift.font = `${cs.fontWeight} ${cs.fontSize}/${cs.lineHeight} ${cs.fontFamily}`
  return stift.measureText(text).width <= frei
}

/* Genitiv fuer die Ueberschrift: Mias, Max’ (Handoff-Regel: s, x, z, ß). */
function genitiv (name) {
  const n = (name || '').trim()
  if (!n) return ''
  return /[sxzß]$/i.test(n) ? `${n}\u2019` : `${n}s`
}

/* Ueberschrift und Einleitung des Figur-Schritts: Buchheld/Buchheldin in
   der Ueberschrift, Hauptfigur im Fliesstext, nie "Figur" allein. */
function schreibeFigurTexte () {
  const titel = $('#figur-titel')
  const lede = $('#figur-lede')
  if (!titel || !lede) return
  const maedchen = state.gender === 'girl'
  const held = maedchen ? 'Buchheldin' : 'Buchheld'
  const g = genitiv(state.name)
  const wer = g ? `${g} ${held}` : `dein${maedchen ? 'e' : ''} ${held}`
  const name = state.name.trim() || 'dein Kind'
  const anderesBuch = $('#anderes-buch')
  if (anderesBuch) anderesBuch.hidden = !(state.coverUrl && !state.coverLaeuft)
  // Im neuen Stil zu den vier Abenteuern, nicht in den alten Shop (07.10., Welt abenteuer)
  if (AEHNLICH) $('#anderes-buch-link')?.setAttribute('href', '/collections/abenteuer')
  if (state.coverLaeuft) {
    // Geschichte gewechselt: die Figur steht, nur das Cover wird neu.
    titel.textContent = `${g ? g + ' Buch' : 'Dein Buch'} entsteht gerade`
    lede.textContent = `Die Hauptfigur ist schon da. Wir setzen sie jetzt aufs Cover von „${state.storyTitle || 'deiner Geschichte'}“.`
  } else if (!state.sheetUrl) {
    titel.textContent = state.storyId
      ? `${g ? g + ' Buch' : 'Dein Buch'} entsteht gerade`
      : tx(`${wer.charAt(0).toUpperCase()}${wer.slice(1)} wird gerade gezeichnet`, `${state.name.trim() || 'Dein Kind'} kommt gerade ins Buch`)
    const quelle = state.ohnePerson ? 'deinen Angaben' : 'deinem Foto'
    lede.textContent = state.storyId
      ? tx(`Aus ${quelle} zeichnen wir die Hauptfigur und setzen sie aufs Cover.`, `Aus deinem Foto setzen wir ${state.name.trim() || 'dein Kind'} aufs Cover, zum Verwechseln ähnlich.`)
      : `Aus ${quelle} entsteht die Hauptfigur für dein Buch.`
  } else if (state.coverUrl) {
    // Buchvorschau (15.09.): das Cover ist das Ergebnis, die Figur der Beleg.
    titel.textContent = `Das ist ${g ? g + ' Buch' : 'das Buch für ' + name}`
    lede.textContent = `Das Cover ist fertig. Die ersten 10 Seiten zeigen wir dir als Vorschau. ${tx(`${name} zeichnen wir nach der Bestellung auf jede Seite`, `Nach der Bestellung kommt ${name} auf jede Seite`)}, deshalb ist ${maedchen ? 'sie' : 'er'} dort noch unscharf.`
  } else {
    titel.textContent = `Das ist ${name} als ${held}`
    lede.textContent = `So zieht ${wer} durch das ganze Buch. Gefällt ${maedchen ? 'sie' : 'er'} dir? Dein Foto löschen wir 48 Stunden nach deiner Bestätigung automatisch. ${tx('Nur die gezeichnete Hauptfigur bleibt.', `Nur ${state.name.trim() || 'dein Kind'} im Buch bleibt, das Foto nicht.`)}`
  }
}

/*
 * Bildseiten vorladen (16.09., Paul: "hat gedauert, bis die Seiten geladen
 * waren"). Die vier Bildseiten der Buchvorschau haengen nicht an der Figur,
 * nur an der Geschichte. Waehrend die Figur entsteht (60 bis 150 Sekunden),
 * ist das Netz frei: also die Adressen holen und die Bilder still laden,
 * dann liegen sie beim Blaettern im Cache des Browsers. Beim ersten Abruf je
 * Geschichte rechnet der Server jede Seite noch (4 bis 6 Sekunden, gemessen
 * 16.09.), auch das faellt so in die Wartezeit statt ins Blaettern. Die
 * Bildobjekte bleiben referenziert, sonst darf der Browser sie vergessen.
 */
let vorgeladen = { storyId: null, bilder: [] }
async function seitenVorladen () {
  if (!state.jobId || !state.storyId || vorgeladen.storyId === state.storyId) return
  vorgeladen = { storyId: state.storyId, bilder: [] }
  try {
    const res = await fetch(`${BACKEND}/api/jobs/${state.jobId}/buchvorschau`, { cache: 'no-store' })
    if (!res.ok) return
    const d = await res.json()
    for (const s of d.seiten || []) {
      if (s.art !== 'bild' || !s.url) continue
      const bild = new Image()
      bild.decoding = 'async'
      bild.src = s.url
      vorgeladen.bilder.push(bild)
    }
  } catch {
    // Dann laedt der Browser die Seiten beim Blaettern, wie bisher.
  }
}

async function startPreview () {
  state.previewStarted = true
  // Solange gezeichnet wird, gibt es kein Buch: altes Cover vergessen und die
  // fixierte Leiste ausblenden (Paul, 16.09. am Telefon). Sonst stand sie im
  // Wartezustand ueber dem Mailfeld und verdeckte dessen Knopf, weil
  // state.coverUrl aus einem frueheren Durchlauf noch gesetzt war.
  state.coverUrl = null
  zeigeBuchLeiste()
  const status = $('#preview-status')
  status.hidden = true
  const nochmalKnopf = $('#preview-nochmal')
  if (nochmalKnopf) nochmalKnopf.hidden = true
  const zusageWieder = $('.wu-dauer')
  if (zusageWieder) zusageWieder.hidden = false
  schreibeFigurTexte()
  // Die Bildseiten des Buchs schon jetzt holen, waehrend die Figur entsteht.
  seitenVorladen()
  // Zeichnung vorbereiten: Haarfarbe aus Schritt 2, Vorlagenfoto aus dem Upload.
  const haar = document.getElementById('wu-haar')
  if (haar) haar.setAttribute('fill', HAAR_ANIMATION[state.hairColor] || '#9C6B43')
  const vorlage = document.getElementById('wu-vorlage')
  if (vorlage) {
    if (state.fotoUrl) {
      document.getElementById('wu-vorlage-img').src = state.fotoUrl
      vorlage.hidden = false
    } else {
      vorlage.hidden = true
    }
  }
  // Fortschrittsring: Zeitschaetzung, kalibriert an den letzten Laeufen. Die
  // Erwartung kommt parallel zum Zeichnen; bis sie da ist, gilt die Vorgabe.
  const start = Date.now()
  let dauer = FIGUR_DAUER_VORGABE
  schreibeDauerHinweis(dauer)
  fetch(`${BACKEND}/api/figur-dauer${AEHNLICH ? '?stil=aehnlich' : ''}`).then(r => r.ok ? r.json() : null).then(d => {
    // Auch merken (15.09.): Das Neu-zeichnen-Overlay rechnet mit derselben
    // Erwartung, ohne sie ein zweites Mal zu holen.
    if (d?.medianMs && d?.p90Ms) { dauer = d; state.figurDauer = d; schreibeDauerHinweis(dauer) }
  }).catch(() => {})
  const tick = () => {
    const t = (Date.now() - start) / 1000
    zeigeFortschritt(fortschrittWerte(t, dauer.medianMs / 1000, dauer.p90Ms / 1000))
  }
  tick()
  const ticker = setInterval(tick, 400)
  try {
    // storyId mit (15.09.): Der Auftrag entstand beim Foto mit der damals
    // gewaehlten Geschichte; wer dazwischen zurueckging, will die neue.
    state.geschichteGewechselt = false
    const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/preview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ turnstileToken: state.turnstileToken || null, meta: metaKennungen(), storyId: state.storyId || null }),
    }))
    const data = await res.json()
    if (!res.ok) {
      // Antwort da, also hat der Server etwas zu sagen (Budget, Bot-Pruefung,
      // zu viele Versuche). Kein Verbindungsproblem.
      const fehler = new Error(data.error)
      fehler.vomServer = true
      throw fehler
    }
    clearInterval(ticker)
    await fortschrittFertig()
    showPreview(data)
  } catch (err) {
    // Verbindung weg, Server zeichnet weiter (Testbestellung 03.09., iPhone:
    // "Load failed" nach 36 s, obwohl der Server 200 geliefert hatte).
    // Statt aufzugeben den Auftrag nachfragen, bis die Figur da ist. Aber
    // nur ohne Antwort: Hat der Server geantwortet (Budget, Bot-Pruefung),
    // gibt es nichts nachzuholen, und die Kundin soll es sofort lesen.
    const nachgeholt = err.vomServer ? null : await warteAufFigur()
    if (nachgeholt) {
      clearInterval(ticker)
      await fortschrittFertig()
      showPreview(nachgeholt)
    } else {
      // Bis 09.09. stand hier die rohe Browsermeldung, auf Pauls Bildschirm
      // "Da ging etwas schief: Load failed". Das sagt der Kundin nichts und
      // bietet ihr keinen Ausweg. Der Text des Servers dagegen schon.
      console.warn('[figur] Zeichnen abgebrochen:', err)
      messe('vorschau_fehler', { grund: err.vomServer ? 'server' : 'netz' })
      status.textContent = err.vomServer
        ? err.message
        : 'Ups, das hat nicht geklappt. Die Verbindung war kurz weg, dein Foto haben wir noch.'
      status.hidden = false
      const nochmal = $('#preview-nochmal')
      if (nochmal) nochmal.hidden = false
      // "Du kannst das Fenster offen lassen, wir zeichnen weiter" waere jetzt
      // eine Zusage, die wir nicht halten. Weg damit, solange der Fehler steht,
      // und mit ihr die Restzeit unter dem Ring ("noch etwa eine Minute").
      // Der Ring selbst bleibt: Er zeigt, wie weit es gekommen ist.
      const zusage = $('.wu-dauer')
      if (zusage) zusage.hidden = true
      const meta = $('#wu-meta')
      if (meta) meta.textContent = ''
    }
  } finally {
    clearInterval(ticker)
    validate()
  }
}

/* Geschichte gewechselt, Figur schon da (15.09., Paul: "es wird immer wieder
   die alte Geschichte gezeigt"): Die Figur bleibt, denn das Kind ist
   dasselbe. Nur das Cover entsteht neu, mit derselben Warteanimation wie
   beim ersten Mal, nur mit halber Erwartung, weil die Figur entfaellt. */
async function coverNeu () {
  if (!state.jobId || !state.storyId) return
  state.geschichteGewechselt = false
  state.coverUrl = null
  state.coverLaeuft = true
  aktualisiereSchrittanzeige()
  nzZeige(null)
  // Neue Geschichte, neue Bildseiten: schon waehrend das Cover entsteht holen.
  seitenVorladen()
  // Treppe (16.09.): Blaettertiefe des alten Buchs abschliessen, Wechsel melden.
  seitenMelden()
  state.tiefeMax = null
  state.tiefeGemeldet = null
  // Nur ein echter Wechsel zaehlt; die Uebernahme einer gespeicherten Figur
  // nimmt denselben Weg, ist aber keiner (sie meldet figur_uebernommen).
  if (state.storyVorher) messe('geschichte_gewechselt', { storyId: state.storyId, grund: state.storyVorher })
  const wrap = document.querySelector('.step[data-step="4"] .preview-wrap')
  if (wrap) wrap.hidden = false
  const bv = $('#buchvorschau')
  if (bv) bv.hidden = true
  const loading = $('#preview-loading')
  if (loading) loading.hidden = false
  const img = $('#preview-img')
  if (img) img.hidden = true
  const status = $('#preview-status')
  if (status) status.hidden = true
  zeigeBuchLeiste()
  schreibeFigurTexte()
  const start = Date.now()
  const dauer = state.figurDauer || FIGUR_DAUER_VORGABE
  const tick = () => zeigeFortschritt(fortschrittWerte((Date.now() - start) / 1000, dauer.medianMs / 2000, dauer.p90Ms / 2000))
  tick()
  const ticker = setInterval(tick, 400)
  try {
    const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/geschichte`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ storyId: state.storyId }),
      signal: typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(240000) : undefined
    }))
    const data = await res.json()
    if (!res.ok) throw new Error(data.error)
    clearInterval(ticker)
    await fortschrittFertig()
    state.coverLaeuft = false
    showPreview(data, { uebernommen: true })
  } catch (err) {
    // Die Figur bleibt gueltig, nur das Cover fehlt: Figuransicht mit Hinweis.
    console.warn('[Geschichte wechseln]', err)
    messe('vorschau_fehler', { grund: 'cover' })
    clearInterval(ticker)
    state.coverLaeuft = false
    aktualisiereSchrittanzeige()
    if (loading) loading.hidden = true
    zeigeVorschauBild()
    schreibeFigurTexte()
    if (status) {
      status.textContent = err.message || tx('Das Cover konnte gerade nicht gezeichnet werden. Deine Figur ist da, bitte versuch es gleich noch einmal.', 'Das Cover hat gerade nicht geklappt. Bitte versuch es gleich noch einmal.')
      status.hidden = false
    }
  } finally {
    clearInterval(ticker)
    validate()
  }
}

/**
 * Browser-Kennungen fuer Metas Conversions API: _fbp setzt das Pixel fuer
 * jeden Besucher, _fbc entsteht beim Klick auf eine Anzeige (oder wir bauen
 * es aus dem fbclid der Adresse). Der Server meldet damit "Vorschau
 * erstellt" an Meta, ohne Name, Mail oder Foto, und nur bei Einwilligung.
 */
// Shopifys Einwilligungs-API ist erst nach loadFeatures da (Live-Befund
// 04.09.: ohne den Aufruf bleibt Shopify.customerPrivacy undefined, und der
// Funnel haette nie eine Einwilligung gesehen). Einmal beim Start anstossen,
// abgefragt wird sie erst bei der Vorschau, dann hat die Kundin den Banner
// laengst beantwortet.
if (typeof window !== 'undefined' && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
  try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {}) } catch (e) { /* ohne API keine Meldung, sonst nichts */ }
}

/**
 * Shopifys Einwilligungs-API ist nicht von selbst da: window.Shopify.customerPrivacy
 * existiert erst nach loadFeatures (Befund Live-Test 04.09.: vorher undefined,
 * danach true). Wird beim Start angestossen, bis zur Vorschau ist sie geladen.
 */
function initEinwilligung () {
  const sh = window.Shopify
  if (sh && typeof sh.loadFeatures === 'function' && !(sh.customerPrivacy && sh.customerPrivacy.marketingAllowed)) {
    try { sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {}) } catch { /* ohne API keine Meldung, mehr nicht */ }
  }
}

function metaKennungen () {
  // Nur mit Marketing-Einwilligung aus Shopifys Cookie-Banner. Ohne sie
  // bekommt der Server keine Kennungen und meldet nichts an Meta.
  const privacy = window.Shopify && window.Shopify.customerPrivacy
  const erlaubt = Boolean(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed())
  if (!erlaubt) return { einwilligung: false }
  const cookie = n => (document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')) || [])[1] || null
  let fbc = cookie('_fbc')
  const fbclid = new URLSearchParams(location.search).get('fbclid')
  if (!fbc && fbclid) fbc = `fb.1.${Date.now()}.${fbclid}`
  // "von" markiert, welcher Knopf in den Konfigurator gefuehrt hat (leiste
  // oder knopf), damit Meta das Ereignis danach aufschluesseln kann.
  const von = new URLSearchParams(location.search).get('von') || null
  // TikTok: _ttp setzt das TikTok-Pixel fuer jeden Besucher, ttclid haengt
  // TikTok beim Klick auf eine Anzeige an die Adresse. Gleiche Regel wie bei
  // Meta, nur mit Einwilligung, und der Server meldet damit die Vorschau.
  const ttclid = new URLSearchParams(location.search).get('ttclid') || null
  return { einwilligung: true, fbp: cookie('_fbp'), fbc, ttp: cookie('_ttp'), ttclid, url: location.href.split('#')[0], von }
}

/**
 * Nach einem Verbindungsabbruch: alle 3 Sekunden nachsehen, ob die Figur
 * fertig ist, bis zu 5 Minuten. Jede Abfrage ist eine frische, kurze
 * Anfrage; scheitert eine, wird einfach die naechste versucht.
 *
 * Auf das Cover wird bis kurz vor Ende des Fensters gewartet (16.09., Paul
 * am iPhone: "Vorschau wird nicht angezeigt" und "neue Figur nicht ins Buch
 * uebernommen"). Vorher galt: hoechstens 60 Sekunden nach Beginn der
 * Nachfrage, danach Figur ohne Cover. Das iPhone bricht die lange Anfrage
 * aber schon nach gut 30 Sekunden ab (Befund 03.09.), und Figur plus Cover
 * brauchen zusammen 90 bis 150 Sekunden: Die Nachfrage gab regelmaessig auf,
 * kurz bevor das Cover fertig war, und die Kundin sah die Figur statt des
 * Buchs. Nachgestellt am langsamen Mock: Figur bei 70 Sekunden ohne Buch,
 * Cover auf dem Server bei 75 Sekunden, nie abgeholt. Die letzten 20
 * Sekunden bleiben fuer den Fall, dass das Cover serverseitig gescheitert
 * ist: dann Figur ohne Cover, und coverNachziehen sieht im Hintergrund
 * weiter nach.
 */
const WARTE_FENSTER_MS = 300000
async function warteAufFigur ({ mindestensVarianten = 0 } = {}) {
  if (!state.jobId) return null
  const ende = Date.now() + WARTE_FENSTER_MS
  const coverBis = ende - 20000
  while (Date.now() < ende) {
    await new Promise(r => setTimeout(r, 3000))
    try {
      const res = await fetch(`${BACKEND}/api/jobs/${state.jobId}?t=${Date.now()}`, { cache: 'no-store' })
      if (!res.ok) continue
      const job = await res.json()
      if (job.state === 'failed') return null
      // Beim Neu-zeichnen (15.09.) liegt schon eine Figur: Fertig ist erst,
      // wenn eine Variante mehr da ist als vorher, und mit Geschichte erst,
      // wenn DIESE Variante ihr Cover hat. job.coverUrl zeigt sonst das Cover
      // der alten Variante, und die Kundin saehe die neue Figur mit dem alten
      // Cover.
      if (mindestensVarianten) {
        const vs = job.variants || []
        if (vs.length < mindestensVarianten) continue
        const neueste = vs[vs.length - 1]
        if (state.storyId && !neueste.coverUrl && Date.now() < coverBis) continue
        return { sheetUrl: neueste.url, coverUrl: neueste.coverUrl || null, variants: vs, attemptsLeft: job.attemptsLeft }
      }
      if (job.sheetUrl && ['sheet_ready', 'ordered'].includes(job.state)) {
        // Mit Geschichte erst weiter, wenn auch das Cover da ist: Der Server
        // schreibt die Figur vor dem Cover, und die Kundin soll das Buch
        // sehen, nicht erst die Figur und Sekunden spaeter das Cover.
        if (state.storyId && !job.coverUrl && Date.now() < coverBis) continue
        return { sheetUrl: job.sheetUrl, coverUrl: job.coverUrl || null, variants: job.variants, attemptsLeft: job.attemptsLeft }
      }
    } catch {
      // Verbindung noch tot, naechster Versuch
    }
  }
  return null
}

/*
 * Cover im Hintergrund nachholen (16.09.): Kommt die Figur ohne Cover an,
 * weil das Nachfrage-Fenster erschoepft war oder der Server das Cover noch
 * zeichnete, zeigt der Schritt erst die Figur. Hier wird alle 4 Sekunden
 * weiter nachgesehen, bis zu 4 Minuten. Sobald die gewaehlte Variante ihr
 * Cover hat, wechselt die Seite zum Buch, ohne dass die Kundin etwas tun
 * muss. Dasselbe nach "Neu zeichnen": uebernimmt sie die neue Figur, bevor
 * deren Cover da ist, kommt das Buch nach.
 *
 * Laeuft hoechstens einmal zugleich: Jeder Aufruf und jede Vorschau mit
 * Cover loest den alten Lauf ab (Zaehler), damit ein spaeter Treffer nicht
 * eine inzwischen andere Wahl ueberschreibt.
 */
let coverNachziehLauf = 0
async function coverNachziehen () {
  const lauf = ++coverNachziehLauf
  if (!state.jobId || !state.storyId || state.coverUrl) return
  const ende = Date.now() + 240000
  while (Date.now() < ende && lauf === coverNachziehLauf) {
    await new Promise(r => setTimeout(r, 4000))
    if (lauf !== coverNachziehLauf || state.coverUrl) return
    try {
      const res = await fetch(`${BACKEND}/api/jobs/${state.jobId}?t=${Date.now()}`, { cache: 'no-store' })
      if (!res.ok) continue
      const job = await res.json()
      // Das Cover muss zur gezeigten Figur gehoeren, nicht zur neuesten
      // Variante des Servers: Nach "Alte Version behalten" sind das zwei.
      const passend = (job.variants || []).find(v => v.url === state.sheetUrl)
      const cover = passend ? passend.coverUrl : (job.sheetUrl === state.sheetUrl ? job.coverUrl : null)
      if (!cover || lauf !== coverNachziehLauf || state.coverUrl) continue
      state.coverUrl = cover
      if (Array.isArray(job.variants) && job.variants.length) state.variants = job.variants
      zeigeVorschauBild()
      zeigeBuchvorschau()
      validate()
      return
    } catch {
      // Verbindung gerade weg, naechster Versuch
    }
  }
}

/* Varianten anzeigen. Die Kundin waehlt aus, statt ersetzt zu bekommen:
   das fuehlt sich nach Kontrolle an, nicht nach Gluecksspiel. */
function showPreview (data, { uebernommen = false } = {}) {
  // Nicht als "Figur gesehen" zaehlen, wenn sie nur aus der Vorschau
  // uebernommen wurde (12.09.). Die Sitzungskennung lebt nur im Speicher der
  // Seite, also beginnt auf der Produktseite eine neue Sitzung. Die meldete
  // bisher ein zweites "Figur gesehen" ohne je ein Foto gehabt zu haben, und
  // genau daher kamen die 139 Prozent auf dieser Stufe: 32 statt 23 bei
  // 9 Buchklicks. Der Uebergang selbst wird als Nebenereignis gezaehlt.
  if (uebernommen) messe('figur_uebernommen')
  else messe('vorschau')
  state.sheetUrl = data.sheetUrl
  state.coverUrl = data.coverUrl || null
  state.figurArt = data.figurArt || null
  // Figur merken (16.09., Paul: "Figur geht verloren, wenn man den Flow
  // verlaesst"): Das Token aus der Antwort kommt in den Browserspeicher,
  // unter demselben Schluessel wie der Link aus der Mail. Jede andere
  // Buchseite bietet die Figur damit an (figurAnbieten), ohne neues Foto.
  if (data.figurToken) figurTokenMerken(data.figurToken)
  // Ohne Cover, aber mit Geschichte: im Hintergrund weiter nachsehen, das
  // Buch kommt nach (16.09., iPhone). Mit Cover endet ein alter Lauf.
  if (!state.coverUrl && state.storyId) coverNachziehen()
  else coverNachziehLauf++
  // Ab jetzt fuehrt hinter dem Figur-Schritt nichts Sinnvolles mehr zurueck.
  aktualisiereSchrittanzeige()
  state.variants = data.variants || [{ key: null, url: data.sheetUrl, coverUrl: data.coverUrl || null }]
  state.attemptsLeft = data.attemptsLeft ?? 0

  zeigeVorschauBild()
  // Kurzer Crossfade von der Zeichnung zum Ergebnis (Handoff 02.09.).
  $('#preview-img').style.animation = 'rise .4s ease both'
  $('#preview-loading').hidden = true
  schreibeFigurTexte()
  zeigeBuchvorschau()

  const row = $('#variants')
  if (state.variants.length > 1) {
    row.innerHTML = state.variants.map((v, i) => `
      <button class="variant${v.coverUrl ? ' variant-buch' : ''}" type="button" data-key="${v.key}"
              aria-pressed="${v.url === state.sheetUrl}">
        <img src="${v.coverUrl || v.url}" alt="Variante ${i + 1}">
      </button>`).join('')
    row.hidden = false
  } else {
    row.hidden = true
  }

  const regen = $('#regenerate')
  regen.hidden = state.attemptsLeft <= 0
  regen.disabled = false
  regen.textContent = tx('Neu zeichnen lassen', 'Noch einmal versuchen')
  const left = $('#attempts-left')
  left.hidden = false
  left.textContent = state.attemptsLeft > 0
    ? `Noch ${state.attemptsLeft} ${state.attemptsLeft === 1 ? 'Versuch' : 'Versuche'}`
    : 'Alle Versuche aufgebraucht. Wähl deine Lieblingsfigur.'
  merkenMailZeigen()
  validate()
}

/* ------------------------------------------------- Buchvorschau (15.09.) */
/* Paul: "Er will nicht den Character kaufen, sondern das Buch." Liegt ein
   Cover mit dem Kind vor (coverUrl), ist ES das grosse Bild, die Figur steht
   klein daneben als Beleg, wie das Kind gezeichnet wurde. Ohne Cover (Figur
   zuerst, oder Cover-Schritt gescheitert) bleibt alles wie bisher: Figur
   gross. Beide Wege muessen in beide Richtungen sauber sein, weil eine
   Variante mit Cover und eine ohne im selben Auftrag liegen koennen. */
function zeigeVorschauBild () {
  const img = $('#preview-img')
  const rahmen = img.closest('.fk-figur')
  const buch = Boolean(state.coverUrl)
  img.src = buch ? state.coverUrl : state.sheetUrl
  img.alt = buch ? 'Vorschau deines Buchcovers' : 'Vorschau der Figur'
  img.hidden = false
  if (rahmen) rahmen.classList.toggle('fk-figur-buch', buch)
  // Der Schrittname folgt dem Bild: "Dein Buch" ueber dem Cover, "Deine
  // Figur" ueber der Figur (Figur zuerst, oder Cover gescheitert).
  const schritt = document.querySelector('.step[data-step="4"]')
  if (schritt) {
    schritt.dataset.kicker = buch ? 'Dein Buch' : 'Deine Figur'
    aktualisiereSchrittanzeige()
  }
  // Mit Buch verschwindet die Figuransicht samt Varianten und Mailfeld: Das
  // Buch ist der Held der Seite (Designpaket buchvorschau). Ohne Buch bleibt
  // alles wie bisher.
  const wrap = document.querySelector('.step[data-step="4"] .preview-wrap')
  if (wrap) wrap.hidden = buch
  const bv = $('#buchvorschau')
  if (bv) bv.hidden = !buch
  zeigeBuchLeiste()
}

/* Die fixierte Leiste liegt im Markup im Schritt, gehoert aber an den
   Seitenkoerper: Der Schritt-Container ist animiert (transform), und darin
   klebt position: fixed nicht am Fensterrand, sondern im Container
   (gemessen 15.09.: Leiste stand bei 5.413 px im Fluss). Einmal umhaengen,
   danach nur noch ein- und ausblenden: sichtbar nur mit Buch und nur auf
   diesem Schritt. */
function zeigeBuchLeiste () {
  const leiste = $('#bv-leiste')
  if (!leiste) return
  if (leiste.parentElement !== document.body) document.body.appendChild(leiste)
  // Waehrend das Neu-zeichnen-Overlay steht, gehoert der Bildschirm ihm
  // (Paul, 16.09. am Telefon, zweiter Befund): Das Buch bleibt dahinter
  // absichtlich stehen, also blieb auch die Leiste sichtbar und lag ueber
  // dem Knopf unter dem Mailfeld. Das Overlay liegt auf Ebene 30, die
  // Leiste auf 50, sie gewinnt jede Ueberdeckung.
  const nzOffen = typeof nz === 'object' && nz !== null && Boolean(nz.zustand)
  const sichtbar = Boolean(state.coverUrl && state.step === 4 && !nzOffen)
  leiste.hidden = !sichtbar
  // Die Leiste liegt fixiert ueber dem Inhalt. Ohne Polster verdeckt sie das
  // Letzte auf der Seite, am Telefon zuerst den Knopf unter dem Mailfeld
  // (Paul, 16.09.). Die Klasse gibt dem laufenden Schritt unten Luft.
  document.body.classList.toggle('fk-mit-buchleiste', sichtbar)
}

/* Buchvorschau (Designpaket buchvorschau, 15.09.): die ersten zehn Seiten des
   echten Buchs zum Durchblaettern, Reihenfolge wie im Druck. Der Server
   liefert Texte mit Name und Pronomen sowie die Bildadressen (Kind weich);
   hier wird nur gebaut. Ohne Geschichte oder ohne Cover passiert nichts. */
/* Inhalt des Bestellknopfs der Buchvorschau (01.10., design_handoff_wunolo_
   vorschau_button): ein Text fuer die ganze Vorschau, Pfeil als Grafik. */
function bvKnopfInhalt () {
  const text = state.bvEndeKnopf || 'Weiter zur Bestellung'
  return `<span>${escHtml(text)}</span><svg class="bv-pfeil" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg>`
}
// Fussvignette der Textseiten: Federstrich mit Funken, Seitenzahl darunter.
function bvFuss (k) { return `<div class="bv-fuss"><svg viewBox="0 0 244 18" aria-hidden="true" fill="none"><path d="M4 11 C 58 4, 116 15, 172 8 S 212 6, 224 9" stroke="#1E3250" stroke-width="4.5" stroke-linecap="round"/><path d="M234 2 L235.6 6.4 L240 8 L235.6 9.6 L234 14 L232.4 9.6 L228 8 L232.4 6.4 Z" fill="#D4622A"/></svg><span>${k}</span></div>` }
async function zeigeBuchvorschau () {
  const bv = $('#buchvorschau')
  if (!bv || !state.coverUrl || !state.storyId || !state.jobId) return
  let d
  try {
    const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/buchvorschau`, { cache: 'no-store' }))
    if (!res.ok) throw new Error(String(res.status))
    d = await res.json()
  } catch (err) {
    console.warn('[buchvorschau]', err)
    return
  }
  const n = (d.name || state.name || '').trim() || 'dein Kind'
  const maedchen = (d.gender || state.gender) === 'girl'
  const g = genitiv(n)
  const seitenText = tx(`Seiten: ${n} wird nach der Bestellung eingezeichnet`, `Seiten: ${n} kommt nach der Bestellung dazu`)
  const legende = $('#bv-legende-seiten')
  if (legende) legende.textContent = seitenText
  const nr = (k, bild) => `<span class="bv-nr">${k}</span>`
  const fuss = bvFuss
  const stift = '<svg viewBox="0 0 20 20" aria-hidden="true" fill="none" stroke="#EFC983" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M13.5 3.5l3 3L7 16H4v-3z"/><path d="M11.5 5.5l3 3"/></svg>'
  const haken = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10.5 L8.5 14 L15 6.5" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  // Marke "Vorschau" oben rechts auf den unscharfen Szenenbildern (08.10.,
  // Paul): klar erkennbar, dass dort noch nicht das fertige Bild steht. Nur
  // dort, nicht auf Cover und Besitzerseite, die zeigen schon das Kind.
  // Unten links steht der Hinweis, unten rechts die Seitenzahl.
  const marke = '<span class="bv-marke" aria-hidden="true">Vorschau</span>'
  const teile = []
  let ersteTextseite = ''
  // Die Wahl der Kundin (state) schlaegt den Stand des Servers (15.09.):
  // Nach "Alte Version behalten" zeigt der Server schon die neue Variante
  // als aktuelle, gezeigt wird aber, was sie behalten hat.
  const cover = state.coverUrl || d.coverUrl
  const figur = state.sheetUrl || d.sheetUrl
  // Besitzerseite im neuen Stil (07.10.): Die eigene Figur steht frei auf dem
  // Seitengrund wie im gedruckten Buch, ein Ausschnitt aus dem Cover (Ersatz,
  // wenn die Figur nicht rechtzeitig kam, oder aeltere Auftraege) im Bogenfenster.
  const figurArt = (state.variants || []).find(v => v.url === figur)?.figurArt || state.figurArt || d.figurArt || null
  const besitzerArt = !AEHNLICH ? '' : figurArt === 'eigen' ? ' bv-besitzer-eigen' : ' bv-besitzer-fenster'
  teile.push(`<div class="bv-page bv-cover" data-page="0"><img class="bv-bild" src="${escHtml(cover)}" alt="Cover: ${escHtml(d.titel || '')}"><span class="bv-pill bv-pill-cover">${haken}Dein Cover</span></div>`)
  for (const s of d.seiten || []) {
    if (s.art === 'besitzer') {
      teile.push(`<div class="bv-page bv-page-papier bv-besitzer${besitzerArt}" data-page="${s.nr}">
        <svg class="bv-funke" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 L14.5 9.5 L22 12 L14.5 14.5 L12 22 L9.5 14.5 L2 12 L9.5 9.5 Z" fill="#EFC983"/></svg>
        <div class="bv-besitzer-kicker">Dieses Buch gehört</div>
        <div class="bv-besitzer-name">${escHtml(n)}</div>
        <img src="${escHtml(figur)}" alt="${escHtml(n)} ${tx('als gezeichnete Hauptfigur', 'im Buch')}" loading="lazy">
        <div class="bv-besitzer-zeile">Eine ${escHtml(d.unterzeile || 'Wunolo')}-Geschichte${d.reihe === 'traumwelten' || AEHNLICH ? '' : ' mit Faro, dem Fuchs'}</div>
        ${nr(s.nr)}</div>`)
      // Der leise Weg zum Neu-zeichnen direkt unter der Seite, auf der die
      // Figur vorgestellt wird (16.09., Paul): Am Telefon lag der Link in
      // der Seitenleiste bei 4.500 px Tiefe, hinter allen Seiten und der
      // Zusammenfassung. Wer die Figur hier beurteilt, findet den Ausweg
      // hier; wer zufrieden ist, scrollt weiter. Kein grosser Knopf, damit
      // es kein Gluecksspiel wird. Am Rechner steht die Seitenleiste daneben,
      // dort blendet das CSS die Zeile aus.
      teile.push(`<div class="bv-zwischen" id="bv-neu-unter" hidden><span>Sieht ${escHtml(n)} nicht ähnlich?</span> <button type="button" class="bv-figur-link" data-bv-neu>${tx('Neu zeichnen lassen', 'Noch einmal versuchen')}</button></div>`)
    } else if (s.art === 'text') {
      // Textseite nach dem Designpaket buchseite_text (15.09.): Bloecke vom
      // Server (Erzaehlung aufrecht, Rede kursiv, Zitate kursiv), Federstrich
      // und Seitenzahl unten. Die Schriftstufe setzt passeTextseitenAn nach
      // dem Rendern, wenn der Text nicht ins Feld passt.
      const bloecke = s.bloecke || (s.absaetze || []).map(a => ({ art: 'erzaehlung', zeilen: [[{ text: a }]] }))
      const absaetze = bloecke.map(b => `<p class="bv-abs${b.art === 'rede' ? ' bv-rede' : ''}">${b.zeilen.map(z => z.map(t => t.kursiv && b.art !== 'rede' ? `<em>${escHtml(t.text)}</em>` : escHtml(t.text)).join('')).join('<br>')}</p>`).join('')
      teile.push(`<div class="bv-page bv-page-papier bv-text" data-page="${s.nr}"><div class="bv-textfeld">${absaetze}</div>${fuss(s.nr)}</div>`)
      if (!ersteTextseite) ersteTextseite = `<div class="bv-textfeld">${absaetze}</div>${fuss(s.nr)}`
    } else if (s.art === 'bild') {
      teile.push(`<div class="bv-page bv-page-bild" data-page="${s.nr}"><img class="bv-bild" src="${escHtml(s.url)}" alt="" loading="lazy" decoding="async"><span class="bv-pill bv-pill-hier">${stift}${tx(`Hier zeichnen wir ${escHtml(n)} ein`, `Hier kommt ${escHtml(n)} hin`)}</span>${nr(s.nr)}${marke}</div>`)
    }
  }
  // Nach der letzten Seite (22.09.): Bis dahin stand hier "Hier endet die
  // Vorschau" mit einem Link zu allen Buechern VOR dem Knopf und ohne Preis.
  // Mindestens 28 von 34 Abbrechern der Runde 2 sind genau hier gegangen,
  // nachdem sie das ganze Buch geblaettert hatten (Head of Conversion,
  // 22.09.). Jetzt: der Satz, warum das Kind in der Vorschau weich ist, die
  // Fakten, der Knopf. Nichts, was wegfuehrt, und keine Zusage, dass die
  // Zeichnung lange bleibt (Paul, 22.09.): Wer liest, dass sie zwoelf Monate
  // gespeichert ist, verschiebt den Kauf auf uebernaechste Woche.
  // Endkarte nach design_handoff_wunolo_vorschau_ende, Variante 2a
  // (01.10., Paul): die gezeichnete Figur ist das Argument, ein Satz statt
  // vier Absaetzen, Fakten als Chips. Am Telefon traegt die fixierte Leiste
  // Preis, Liefertermin und den einzigen Knopf; der Knopf hier gilt nur am
  // Rechner, wo es die Leiste nicht gibt. Der Satz sagt "das Kind", nicht den
  // Namen: In den Szenen der Vorschau steht das Beispielkind, nicht dein Kind.
  const funke = '<svg viewBox="0 0 24 24" width="14" height="14" style="flex:none" aria-hidden="true"><path d="M12 2 L14.5 9.5 L22 12 L14.5 14.5 L12 22 L9.5 14.5 L2 12 L9.5 9.5 Z" fill="#EFC983"/></svg>'
  // Versandtag statt Zustellung (01.10. abends, Paul): Lieferwagen plus "ab".
  const lieferAb = d.lieferung?.versand || ''
  // Ein Knopftext fuer die ganze Vorschau (01.10., Paul: "verwirrend, dass
  // die ganze Zeit Weiter zur Bestellung steht und dann der Knopf wechselt"):
  // von der ersten Seite an der Name des Kindes, Pfeil als Grafik
  // (design_handoff_wunolo_vorschau_button). Ab 17 Zeichen ohne Namen.
  state.bvEndeKnopf = n.length <= 16 && n !== 'dein Kind' ? `${genitiv(n)} Buch bestellen` : 'Buch bestellen'
  teile.push(`<div class="bv-ende" data-ende="1">
    <p class="bv-ende-kicker">Ende der Vorschau</p>
    <h3>${escHtml(n)} ist bereit für ${maedchen ? 'ihr' : 'sein'} Buch</h3>
    ${figur ? `<figure class="bv-ende-figur"><img src="${escHtml(figur)}" alt="${escHtml(n)} ${tx('gezeichnet', 'im Buch')}" loading="lazy"><span class="bv-ende-plakette">${funke}Auf allen ${d.illustrationen || 12} Bildern</span></figure>` : ''}
    <p class="bv-ende-satz">In der Vorschau war das Kind noch unscharf. Im Buch zeichnen wir ${escHtml(n)} genau so in jede Szene.</p>
    <div class="bv-ende-chips"><span>${d.seitenGesamt || 30} Seiten</span><span>${escHtml(d.format || '20 × 20 cm')}</span><span>Gedruckt in Deutschland</span></div>
    ${lieferAb ? `<p class="bv-ende-liefer"><svg viewBox="0 0 24 24" width="18" height="18" aria-label="Versand" fill="none" stroke="#2E7D4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg> ab ${escHtml(lieferAb)}</p>` : ''}
    <button type="button" class="btn btn-primary bv-weiter bv-ende-knopf">${bvKnopfInhalt()}</button>
  </div>`)
  // Leiste fuer das Ende vorbereiten: Liefertermin neben dem Preis.
  const leistenLiefer = $('#bv-leiste-liefer')
  if (leistenLiefer) {
    const t = leistenLiefer.querySelector('span')
    const kurz = { Januar: 'Jan.', Februar: 'Feb.', März: 'März', April: 'Apr.', Mai: 'Mai', Juni: 'Juni', Juli: 'Juli', August: 'Aug.', September: 'Sept.', Oktober: 'Okt.', November: 'Nov.', Dezember: 'Dez.' }
    // Nur das Symbol sagt "Versand" (Paul, 01.10.): Text bleibt "ab 6. Okt.".
    if (t) t.textContent = lieferAb ? `ab ${lieferAb.replace(/[A-Za-zÄÖÜäöü]+$/, m => kurz[m] || m)}` : ''
    leistenLiefer.hidden = !lieferAb
  }
  const buch = $('#bv-buch')
  buch.innerHTML = teile.join('')
  for (const b of $$('.bv-weiter')) if (!b.disabled) b.innerHTML = bvKnopfInhalt()
  // Das Mailangebot unter die Besitzerseite (22.09., Befund Head of
  // Conversion vom 18.09.): Der Kasten lag in .preview-wrap, und die wird mit
  // dem Cover versteckt. Mit Buchvorschau gab es also unter dem Buch kein
  // Mailangebot, 2 von 15 haben es je gesehen, beide bei fehlgeschlagenem
  // Cover. Jetzt wandert dasselbe Element (samt Messung mail_gesehen) hinter
  // "Sieht Mia nicht aehnlich?", also dorthin, wo die Kundin ihr Kind gerade
  // als Besitzerin des Buchs gesehen hat. Ohne Buch bleibt es, wo es war.
  const mailKasten = $('#merken-mail-zeile')
  const unterBesitzer = $('#bv-neu-unter')
  if (mailKasten && unterBesitzer && mailKasten.previousElementSibling !== unterBesitzer) unterBesitzer.insertAdjacentElement('afterend', mailKasten)
  merkenMailZeigen()
  // Seitenleiste
  const setze = (id, text) => { const el = $(id); if (el) el.textContent = text }
  setze('#bv-unter', `personalisiert für ${n}`)
  const alter = state.ageRange ? state.ageRange.replace('-', ' bis ').replace('+', ' plus') + ' Jahre' : (d.alter ? `${d.alter} Jahre` : '')
  setze('#bv-hauptfigur', [n, maedchen ? 'Mädchen' : 'Junge', alter].filter(Boolean).join(' · '))
  const aussehen = [state.hairColor && farbName('hair', state.hairColor), state.hairStyle && HAAR_STIL[state.hairStyle], state.eyeColor && `Augen ${farbName('eyes', state.eyeColor).toLowerCase()}`].filter(Boolean).join(', ')
  setze('#bv-aussehen', aussehen)
  setze('#bv-format', `${d.format || '20 × 20 cm'} · ${d.seitenGesamt || 30} Seiten`)
  setze('#details-format', `${d.format || '20 × 20 cm'}, ${d.seitenGesamt || 30} Seiten mit ${d.illustrationen || 12} Illustrationen, auf jeder davon ${n}`)
  setze('#details-format-oben', `${d.format || '20 × 20 cm'}, ${d.seitenGesamt || 30} Seiten mit ${d.illustrationen || 12} Illustrationen, auf jeder davon ${n}`)
  const preis = $('#fk-zf-preis')?.textContent?.trim()
  if (preis) setze('#bv-preis', preis)
  const figurBild = $('#bv-figur-bild')
  if (figurBild) figurBild.src = figur
  setze('#bv-figur-titel', `${g || 'Deine'} ${maedchen ? 'Buchheldin' : 'Buchheld'}`)
  setze('#bv-figur-text', 'Diese Figur zieht durchs ganze Buch.')
  neuLinksSetzen(d.attemptsLeft ?? state.attemptsLeft ?? 0)
  bv.hidden = false
  buchvorschauSeitenzaehler()
  state.textStufe = d.textStufe || null
  passeTextseitenAn(state.textStufe)
  if (ersteTextseite) {
    lfTextseite = `<div class="bv-page bv-page-papier bv-text"${state.textStufe ? ` style="--stufe: ${Number(state.textStufe)}"` : ''}>${ersteTextseite}</div>`
    zeigeLayflatTextseite()
  }
  if (d.figurArt === 'ausschnitt') figurNachreichenBeobachten(figur)
}

// Figur nachreichen (08.10.2026, Paul: "eigentlich sollte doch hier eine
// cleane Figur erscheinen und kein Ausschnitt vom Cover"): Brauchte die eigene
// Figur laenger als die Nachfrist, zeigt die Besitzerseite erst den Ausschnitt
// aus dem Cover, und der Server reicht die Figur nach. Hier bis zu 90 Sekunden
// alle 4 Sekunden nachsehen und nur die Bilder mit der alten Adresse tauschen,
// ohne das Buch neu zu bauen (Blaetterstand und offene Kaesten bleiben).
let figurNachreichenTakt = null
function figurNachreichenBeobachten (alteUrl) {
  if (figurNachreichenTakt || !state.jobId || !alteUrl) return
  const jobId = state.jobId
  const ende = Date.now() + 90000
  const stopp = () => { clearInterval(figurNachreichenTakt); figurNachreichenTakt = null }
  figurNachreichenTakt = setInterval(async () => {
    if (Date.now() > ende || state.jobId !== jobId) return stopp()
    let d
    try {
      const res = await fetch(`${BACKEND}/api/jobs/${jobId}/buchvorschau`, { cache: 'no-store' })
      if (!res.ok) return
      d = await res.json()
    } catch { return }
    if (d.figurArt !== 'eigen' || !d.sheetUrl || d.sheetUrl === alteUrl) return
    stopp()
    // Nur tauschen, wenn die Kundin noch die Figur von eben sieht (nicht nach
    // "Alte Version behalten" oder neu zeichnen).
    if (state.sheetUrl && state.sheetUrl !== alteUrl) return
    state.sheetUrl = d.sheetUrl
    for (const img of $$('img')) if (img.getAttribute('src') === alteUrl) img.src = d.sheetUrl
  }, 4000)
}

/* Schriftgrad der Textseiten (Designpaket buchseite_text): EIN Grad fuer
   das ganze Buch, den der Server aus den Lora-Metriken des Drucks berechnet
   (textStufe, der groesste, bei dem jede der zehn Seiten samt Schluss
   passt; Paul 15.09.: Text nicht kuerzen, Schrift so stellen, dass alles
   passt). Der Browser prueft nur noch nach, ob sein Umbruch ins Feld passt,
   und geht sonst in Zehntelschritten tiefer, fuer alle Seiten gemeinsam.
   Gemessen wird nach dem Laden der Schrift, sonst misst der Browser mit der
   Ersatzschrift. */
const TEXT_STUFE_MIN = 2.6
function passeTextseitenAn (stufe) {
  const seiten = $$('#bv-buch .bv-text')
  if (!seiten.length) return
  const setze = s => { for (const seite of seiten) seite.style.setProperty('--stufe', String(s)) }
  const anpassen = () => {
    let s = Number(stufe) || 4.9
    setze(s)
    const passt = () => seiten.every(seite => { const f = seite.querySelector('.bv-textfeld'); return !f || f.scrollHeight <= f.clientHeight + 1 })
    while (!passt() && s > TEXT_STUFE_MIN) { s = Math.round((s - 0.1) * 10) / 10; setze(s) }
  }
  anpassen()
  if (document.fonts?.ready) document.fonts.ready.then(anpassen)
}
let textseitenTakt = null
window.addEventListener('resize', () => {
  if (textseitenTakt || $('#buchvorschau')?.hidden !== false) return
  textseitenTakt = setTimeout(() => { textseitenTakt = null; passeTextseitenAn(state.textStufe) }, 150)
})

/* ------------------------------------------- Neu zeichnen: Overlay (15.09.) */
/* Designpaket neu_zeichnen: Statt eines Spinners legt sich eine Karte ueber
   die Buchspalte, das Buch bleibt sichtbar. Drei Zustaende: Start
   (Rueckfrage, was anders werden soll), Zeichnen laeuft (Ring, drei Phasen,
   Restzeit, Ausweg per Mail), Fertig (Vorher/Nachher, uebernehmen oder alte
   behalten). Die alte Version bleibt bis zur Entscheidung, das Buch wird
   erst nach "uebernehmen" neu gebaut. Der Textlink in der Figur-Karte ist
   der einzige Ausloeser; ohne Buch (Figur zuerst) laeuft weiter der alte
   Knopf #regenerate. */
const NZ_PHASEN = [
  { bis: 0.35, text: tx('Wir zeichnen die Umrisse nach deinem Foto …', 'Wir übernehmen das Gesicht aus deinem Foto …') },
  { bis: 0.80, text: tx('Haare, Augen und Kleidung bekommen ihre Farben …', 'Haare und Hautton werden angepasst …') },
  { bis: 1.01, text: tx('Noch die letzten Striche, dann ist {pronomen} fertig.', 'Noch der letzte Schliff, dann ist {pronomen} im Buch.') }
]
const NZ_HINWEISE = ['frisur', 'gesicht', 'kleidung', 'nochmal']
const nz = { zustand: null, ticker: null, hinweis: null, vorher: null, ergebnis: null, fehlerCode: null, neuesFoto: null, fotoHochgeladen: false }

function nzName () { return (state.name || '').trim() || 'dein Kind' }
function nzHeld () { return state.gender === 'girl' ? 'Buchheldin' : 'Buchheld' }
function nzDauerText () {
  const median = state.figurDauer?.medianMs || FIGUR_DAUER_VORGABE.medianMs
  return median < 40000 ? 'etwa eine halbe Minute' : median < 75000 ? 'etwa eine Minute' : 'etwa zwei Minuten'
}
function nzVersucheText (rest, satz = false) {
  if (rest <= 0) return satz ? 'Das war der letzte Versuch.' : 'Kein Versuch mehr übrig'
  const n = `${rest} ${rest === 1 ? 'Versuch' : 'Versuche'}`
  return satz ? `Du hast noch ${n}.` : `Noch ${n} übrig`
}

/* Zustand setzen. null blendet das Overlay aus und gibt Buch, Seitenleiste
   und Bestellknoepfe wieder frei. Die Klassen liegen am body, weil die
   mobile Leiste dort haengt (zeigeBuchLeiste). */
/* Beide Wege zum Neu-zeichnen (Seitenleiste und Zeile unter der
   Besitzerseite) zeigen dasselbe: sichtbar nur mit Restversuchen, vor der
   Bestaetigung und solange nichts laeuft; der Text nennt die Versuche. */
function neuLinksSetzen (rest) {
  // Testballon (06.10., Paul): Der Weg fuehrt ueber ein neues Foto, und die
  // Versuche gelten je Foto. Deshalb ohne Zaehler und auch bei null Resten.
  const versteckt = Boolean(nz.zustand) || (!AEHNLICH && rest <= 0) || Boolean(state.sheetChosen)
  const text = AEHNLICH ? 'Noch einmal versuchen' : `Neu zeichnen lassen · noch ${rest} ${rest === 1 ? 'Versuch' : 'Versuche'}`
  // Am Ende der Vorschau steht er seit dem 25.09. nicht mehr (Nutzertest
  // Paul): Wer bis zum Ende geblaettert hat, soll dort nur den Weg zur
  // Bestellung finden; ein Neu-zeichnen-Link verunsichert genau dann.
  for (const el of [$('#bv-neu'), $('#bv-neu-unter')]) {
    if (!el) continue
    el.hidden = versteckt
    const knopf = el.matches('[data-bv-neu], #bv-neu') ? el : el.querySelector('[data-bv-neu]')
    if (knopf) knopf.textContent = text
  }
}

function nzZeige (zustand) {
  const ov = $('#bv-overlay')
  if (!ov) return
  nz.zustand = zustand
  ov.hidden = !zustand
  for (const z of ['start', 'lauf', 'fertig']) { const k = $(`#bv-ov-${z}`); if (k) k.hidden = zustand !== z }
  const busy = Boolean(zustand)
  // Die fixierte Leiste weicht dem Overlay und kommt danach zurueck.
  zeigeBuchLeiste()
  document.body.classList.toggle('bv-busy', busy)
  document.body.classList.toggle('bv-zeichnet', zustand === 'lauf')
  for (const b of $$('.bv-weiter')) { b.disabled = busy; if (busy) b.textContent = tx('Bestellen nach dem Zeichnen', `Bestellen, wenn ${state.name.trim() || 'dein Kind'} im Buch ist`); else b.innerHTML = bvKnopfInhalt() }
  // Auch der grosse Weiter-Knopf des Funnels bleibt zu (canAdvance liest
  // die Klasse am body).
  validate()
  neuLinksSetzen(state.attemptsLeft ?? 0)
  const text = $('#bv-figur-text')
  if (text) {
    text.textContent = zustand === 'lauf' ? tx('Wird gerade neu gezeichnet …', 'Wir versuchen es noch einmal …')
      : zustand === 'fertig' ? 'Neue Version bereit' : 'Diese Figur zieht durchs ganze Buch.'
  }
}

/* Karte ins Bild holen: Am Telefon steht die Figur-Karte unter dem Buch,
   das Overlay also oberhalb der Sicht. */
function nzKarteZeigen (id) {
  const karte = $(id)
  if (!karte) return
  const r = karte.getBoundingClientRect()
  if (r.top < 60 || r.bottom > window.innerHeight) karte.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

/* Testballon (06.10., Paul, nach Sparkid): Beim Kopftausch lassen sich
   Frisur, Gesicht und Kleidung nicht gezielt aendern. Der groesste Hebel ist
   ein besseres Foto. Die Rueckfrage zeigt deshalb Fototipps und einen
   Knopf zum Hochladen statt der Hinweis-Chips. Einmal gebaut, danach nur
   noch gefuellt. */
function nzFotoKarteBauen () {
  const karte = $('#bv-ov-start')
  if (!karte || $('#bv-ov-foto')) return
  const chips = karte.querySelector('.bv-ov-chips')
  if (chips) chips.hidden = true
  if (!$('#bv-ov-foto-stil')) {
    const stil = document.createElement('style')
    stil.id = 'bv-ov-foto-stil'
    stil.textContent = '.bv-ov-foto{display:flex;flex-direction:column;gap:8px;margin:4px 0 2px}' +
      '.bv-ov-tipps{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:6px}' +
      '.bv-ov-tipps li{position:relative;padding-left:24px;font-size:15px;line-height:1.4;color:#1E3250}' +
      '.bv-ov-tipps li::before{content:"";position:absolute;left:2px;top:4px;width:12px;height:7px;border-left:2.5px solid #3E8E63;border-bottom:2.5px solid #3E8E63;transform:rotate(-45deg)}' +
      '.bv-ov-fotohinweis{margin:0;padding:10px 12px;border-radius:10px;background:#FBEDE4;color:#9A3F12;font-size:14.5px;line-height:1.4}' +
      '.bv-ov-einwilligung{margin:0;font-size:13px;line-height:1.4;color:#6B7487}'
    document.head.appendChild(stil)
  }
  const block = document.createElement('div')
  block.className = 'bv-ov-foto'
  block.id = 'bv-ov-foto'
  block.innerHTML = '<span class="bv-ov-label">Darauf kommt es an</span>' +
    '<ul class="bv-ov-tipps">' +
    '<li>Gesicht von vorn, nah und gut zu sehen</li>' +
    '<li>Helles Licht, am besten Tageslicht</li>' +
    '<li>Nur dein Kind auf dem Foto</li>' +
    '<li>Keine Mütze, keine Brille, nichts vor dem Gesicht</li>' +
    '</ul>' +
    '<p class="bv-ov-fotohinweis" id="bv-ov-fotohinweis" hidden></p>' +
    '<input type="file" id="bv-ov-datei" accept="image/jpeg,image/png,image/webp" hidden>' +
    '<p class="bv-ov-einwilligung">Es gilt deine Einwilligung von vorhin, auch dieses Foto wird danach gelöscht.</p>'
  if (chips) chips.after(block)
  else karte.querySelector('.bv-ov-knoepfe')?.before(block)
  const abbrechen = $('#bv-ov-abbrechen')
  if (abbrechen && !$('#bv-ov-gleich')) {
    const gleich = document.createElement('button')
    gleich.type = 'button'
    gleich.className = 'bv-ov-textknopf'
    gleich.id = 'bv-ov-gleich'
    gleich.textContent = 'Mit demselben Foto noch einmal'
    abbrechen.before(gleich)
  }
  $('#bv-ov-datei')?.addEventListener('change', e => {
    const datei = e.target.files?.[0]
    e.target.value = ''
    if (datei) nzLauf({ neuesFoto: datei })
  })
}

function nzFotoHinweis (text) {
  const el = $('#bv-ov-fotohinweis')
  if (!el) return
  el.hidden = !text
  el.textContent = text || ''
}

/* Zustand 1: Rueckfrage. */
function nzStart ({ fotoHinweis = '' } = {}) {
  if (!$('#bv-overlay') || !state.coverUrl) { $('#regenerate')?.click(); return }
  if (AEHNLICH) {
    if (state.sheetChosen) return
    nzFotoKarteBauen()
    nzFotoHinweis(fotoHinweis)
    const bild = $('#bv-ov-start-bild')
    if (bild) bild.src = state.sheetUrl
    const titel = $('#bv-ov-start-titel')
    if (titel) titel.textContent = 'Mit einem neuen Foto noch ähnlicher'
    const text = $('#bv-ov-start-text')
    if (text) text.textContent = `Ein anderes Foto bringt meist am meisten. Dauert ${nzDauerText()}.`
    const los = $('#bv-ov-los')
    if (los) los.textContent = 'Neues Foto wählen'
    const gleich = $('#bv-ov-gleich')
    // Nach einem abgelehnten Foto hilft dasselbe Foto nicht weiter.
    if (gleich) gleich.hidden = (state.attemptsLeft ?? 0) <= 0 || Boolean(fotoHinweis)
    nzZeige('start')
    nzKarteZeigen('#bv-ov-start')
    return
  }
  if ((state.attemptsLeft ?? 0) <= 0 || state.sheetChosen) return
  nz.hinweis = null
  for (const c of $$('.bv-chip')) c.setAttribute('aria-pressed', 'false')
  const bild = $('#bv-ov-start-bild')
  if (bild) bild.src = state.sheetUrl
  const titel = $('#bv-ov-start-titel')
  if (titel) titel.textContent = tx(`${nzName()} neu zeichnen?`, 'Noch einmal versuchen?')
  const text = $('#bv-ov-start-text')
  if (text) text.textContent = `Dauert ${nzDauerText()}. ${nzVersucheText(state.attemptsLeft, true)}`
  nzZeige('start')
  nzKarteZeigen('#bv-ov-start')
}

/* Ring, Phasen und Restzeit aus der Zeitschaetzung, dieselbe Kurve wie beim
   ersten Zeichnen (fortschrittWerte), nur mit drei Phasen bei 35 und 80
   Prozent. Restzeit nie unter 3 Sekunden und nie 0. */
function nzFortschritt (tSek, dauer) {
  const T = Math.max(20, dauer.medianMs / 1000 * 1.36)
  const x = Math.min(1, tSek / T)
  const p = Math.min(0.96, 1 - Math.pow(1 - x, 1.6))
  const phase = p < NZ_PHASEN[0].bis ? 0 : p < NZ_PHASEN[1].bis ? 1 : 2
  const rest = Math.max(3, Math.ceil(T - tSek))
  // "Dauert heute etwas laenger" erst hinter dem 90. Perzentil UND hinter der
  // Kurve; sonst stand der Satz nach zwei Sekunden da, wenn die letzten
  // Laeufe schnell waren.
  const langsam = tSek > Math.max(dauer.p90Ms / 1000, T)
  return { p, phase, rest, langsam }
}

function nzMale ({ p, phase, rest, langsam }) {
  const balken = $('#bv-ov-balken')
  if (balken) balken.style.strokeDashoffset = String(Math.round(490 - 490 * p))
  for (const el of $$('#bv-ov-phasen [data-phase]')) {
    const i = Number(el.dataset.phase)
    el.dataset.stand = phase > i ? 'erledigt' : phase === i ? 'aktiv' : 'offen'
  }
  const text = $('#bv-ov-phase')
  // Phase 3 gibt es nur beim Abschluss (alle Segmente voll); der Satz bleibt
  // der des Feinschliffs.
  const satz = NZ_PHASEN[Math.min(phase, NZ_PHASEN.length - 1)].text.replace('{pronomen}', state.gender === 'girl' ? 'sie' : 'er')
  if (text && text.textContent !== satz) {
    text.textContent = satz
    // Einblenden bei Wechsel: Animation neu anstossen.
    text.style.animation = 'none'
    void text.offsetWidth
    text.style.animation = ''
  }
  const restEl = $('#bv-ov-rest')
  if (restEl) restEl.textContent = langsam ? 'Dauert heute etwas länger' : `Noch etwa ${rest} Sekunden`
}

/* Zustand 2: Zeichnen laeuft. */
async function nzLauf ({ neuesFoto = null } = {}) {
  if (!state.jobId) return
  // Gemessen wird die Absicht, nicht der Erfolg (12.09.): Ein verbrauchter
  // Versuch ist auch dann eine Aussage, wenn das Zeichnen scheitert.
  // Mit dem gewaehlten Hinweis als Grund (16.09.), jeder Lauf zaehlt.
  messe('figur_neu', { grund: neuesFoto ? 'neues_foto' : (nz.hinweis || 'ohne') })
  nz.neuesFoto = neuesFoto
  nz.fotoHochgeladen = false
  nz.vorher = { sheetUrl: state.sheetUrl, coverUrl: state.coverUrl, varianten: (state.variants || []).length }
  nz.ergebnis = null
  nz.fehlerCode = null
  const karte = $('#bv-ov-lauf')
  karte?.classList.remove('bv-ov-gescheitert')
  const bild = $('#bv-ov-lauf-bild')
  const fotoUrl = neuesFoto ? URL.createObjectURL(neuesFoto) : null
  if (bild) bild.src = fotoUrl || state.sheetUrl
  const titel = $('#bv-ov-lauf-titel')
  if (titel) titel.textContent = neuesFoto ? 'Wir prüfen dein neues Foto' : tx(`${nzName()} wird neu gezeichnet`, 'Wir versuchen es noch einmal')
  if (AEHNLICH) {
    const labels = ['Gesicht', 'Haare', 'Feinschliff']
    for (const el of $$('#bv-ov-phasen [data-phase] .bv-ov-seglabel')) {
      const i = Number(el.parentElement?.dataset.phase)
      if (labels[i]) el.textContent = labels[i]
    }
  }
  const fuss = $('#bv-ov-fuss'); if (fuss) fuss.hidden = false
  const fehler = $('#bv-ov-fehler'); if (fehler) fehler.hidden = true
  const restzeile = $('#bv-ov-restzeile'); if (restzeile) restzeile.hidden = false
  nzMailFeldVorbereiten()
  nzZeige('lauf')
  nzKarteZeigen('#bv-ov-lauf')

  let dauer = state.figurDauer || FIGUR_DAUER_VORGABE
  if (!state.figurDauer) {
    fetch(`${BACKEND}/api/figur-dauer${AEHNLICH ? '?stil=aehnlich' : ''}`).then(r => r.ok ? r.json() : null).then(d => {
      if (d?.medianMs && d?.p90Ms) { dauer = d; state.figurDauer = d }
    }).catch(() => {})
  }
  const start = Date.now()
  const tick = () => nzMale(nzFortschritt((Date.now() - start) / 1000, dauer))
  tick()
  clearInterval(nz.ticker)
  nz.ticker = setInterval(tick, 500)
  try {
    if (neuesFoto) {
      // Erst das Foto pruefen lassen, dieselbe Strecke wie im Fotoschritt.
      // Passt es nicht, zurueck zur Rueckfrage mit dem Grund; die alte
      // Vorschau bleibt dann unberuehrt, denn der Server raeumt sie erst
      // bei einem brauchbaren Foto weg.
      const marke = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 10)
      const klein = await verkleinereFoto(neuesFoto)
      const fotoRes = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/photo?marke=${encodeURIComponent(marke)}`, {
        method: 'POST',
        headers: { 'Content-Type': klein.type || 'image/jpeg' },
        body: klein
      }))
      const foto = await fotoRes.json()
      // Auch hier (18.10., #1041): neues Foto fuer ein Buch im Warenkorb geht an
      // einen neuen Auftrag, das Neuzeichnen laeuft dann dort.
      if (foto?.jobId && foto.jobId !== state.jobId) neuerAuftragFuerFoto(foto.jobId)
      if (!fotoRes.ok) {
        const err = new Error(foto.error || 'Upload fehlgeschlagen')
        err.vomServer = true
        err.code = foto.code || null
        throw err
      }
      if (!foto.usable || foto.ohnePerson) {
        clearInterval(nz.ticker)
        nz.ticker = null
        messe('foto_abgelehnt', { grund: 'neu_versuchen' })
        nzStart({ fotoHinweis: foto.ohnePerson ? `Auf diesem Foto ist kein Gesicht zu sehen. Bitte ein Foto, auf dem ${nzName()} von vorn zu sehen ist.` : `Dieses Foto passt noch nicht: ${foto.hint || 'Bitte ein anderes Foto wählen.'}` })
        return
      }
      nz.fotoHochgeladen = true
      // Der Server hat die alte Figur weggeraeumt, die Versuche zaehlen neu.
      nz.vorher.varianten = 0
      state.fotoDatei = neuesFoto
      state.fotoUrl = fotoUrl
      const fkBild = $('#fk-fotobild')
      if (fkBild) fkBild.src = fotoUrl
      if (titel) titel.textContent = `${nzName()} kommt ins Buch`
    }
    // bekannteVarianten (23.10.): Kommt die Wiederholung nach einem Neustart
    // an, nachdem der Server die Figur schon fertig hat, zeichnet er nicht
    // noch eine und verbraucht keinen weiteren Versuch.
    const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/regenerate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ hinweis: nz.hinweis || null, bekannteVarianten: nz.vorher.varianten }),
      // Obergrenze (15.09., Pauls Lokaltest: Karte stand nach Minuten noch):
      // Danach nachfragen wie nach einem Verbindungsabbruch, dann Fehlerkarte.
      signal: typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(240000) : undefined
    }))
    const data = await res.json()
    if (!res.ok) {
      const err = new Error(data.error)
      err.vomServer = true
      err.code = data.code || null
      throw err
    }
    await nzFertig(data)
  } catch (err) {
    // Verbindung weg, der Server zeichnet weiter: nachfragen, bis eine
    // Variante mehr da ist. Hat der Server geantwortet, gibt es nichts
    // nachzuholen.
    const nachgeholt = err.vomServer ? null : await warteAufFigur({ mindestensVarianten: nz.vorher.varianten + 1 })
    if (nachgeholt) await nzFertig(nachgeholt)
    else nzFehler(err)
  } finally {
    clearInterval(nz.ticker)
    nz.ticker = null
  }
}

/* Zustand 3: Fertig. Ring auf 100, kurz stehen lassen, dann die Karte mit
   Vorher/Nachher. Das Buch bleibt bis zur Entscheidung das alte. */
async function nzFertig (data) {
  clearInterval(nz.ticker)
  nz.ticker = null
  nz.ergebnis = data
  nzMale({ p: 1, phase: 3, rest: 3, langsam: false })
  const restEl = $('#bv-ov-rest')
  if (restEl) restEl.textContent = 'Fertig'
  await new Promise(r => setTimeout(r, 600))
  if (nz.zustand !== 'lauf') return
  // Neues Foto: Die alte Figur gibt es nicht mehr, also kein Vorher/Nachher,
  // das neue Buch steht sofort.
  if (nz.fotoHochgeladen) { nzUebernehmen(); return }
  const vorher = $('#bv-ov-vorher'); if (vorher) vorher.src = nz.vorher.sheetUrl
  const neu = $('#bv-ov-neu'); if (neu) neu.src = data.sheetUrl
  const titel = $('#bv-ov-fertig-titel')
  if (titel) titel.textContent = tx(`${state.gender === 'girl' ? 'Die neue Buchheldin' : 'Der neue Buchheld'} ist da`, 'Der neue Versuch ist da')
  const versuche = $('#bv-ov-versuche')
  if (versuche) versuche.textContent = nzVersucheText(data.attemptsLeft ?? 0)
  nzZeige('fertig')
  nzKarteZeigen('#bv-ov-fertig')
}

/* Fehler in Zustand 2: Ring grau, Satz statt Phase, zwei Auswege. Bei einer
   Antwort des Servers (keine Versuche mehr, kein Foto) steht sein Text und
   "Nochmal versuchen" entfaellt. */
function nzFehler (err) {
  console.warn('[neu zeichnen]', err)
  nz.fehlerCode = err?.code || null
  messe('figur_neu_fehler', { grund: err?.code || (err?.vomServer ? 'server' : 'netz') })
  $('#bv-ov-lauf')?.classList.add('bv-ov-gescheitert')
  for (const el of $$('#bv-ov-phasen [data-phase]')) el.dataset.stand = 'offen'
  const text = $('#bv-ov-phase')
  if (text) text.textContent = err?.vomServer && err.code ? err.message : 'Das hat nicht geklappt. Dein Versuch wurde nicht abgezogen.'
  const restzeile = $('#bv-ov-restzeile'); if (restzeile) restzeile.hidden = true
  const fuss = $('#bv-ov-fuss'); if (fuss) fuss.hidden = true
  const fehler = $('#bv-ov-fehler'); if (fehler) fehler.hidden = false
  const nochmal = $('#bv-ov-nochmal')
  if (nochmal) nochmal.hidden = ['ATTEMPTS_EXHAUSTED', 'NO_PHOTO'].includes(nz.fehlerCode)
  // Nach einem angenommenen neuen Foto ist die alte Version weg: "Alte
  // Version behalten" waere ein leeres Versprechen.
  const behalten = $('#bv-ov-fehler-behalten')
  if (behalten) behalten.hidden = nz.fotoHochgeladen
  const text2 = $('#bv-figur-text')
  if (text2) text2.textContent = 'Diese Figur zieht durchs ganze Buch.'
}

/* Entscheidung am Ende: uebernehmen baut das Buch mit der neuen Figur,
   behalten laesst die alte als gewaehlte Variante stehen (der Server hat
   beide, bestaetigeFigur schickt spaeter den Schluessel der gewaehlten). */
function nzUebernehmen () {
  const data = nz.ergebnis
  nzZeige(null)
  if (!data) return
  messe('figur_neu_uebernommen')
  const buch = $('#bv-buch')
  if (buch) { buch.classList.remove('bv-frisch'); void buch.offsetWidth; buch.classList.add('bv-frisch') }
  showPreview(data)
}
function nzBehalten () {
  const data = nz.ergebnis
  nzZeige(null)
  if (!data) return
  messe('figur_neu_behalten')
  showPreview({ ...data, sheetUrl: nz.vorher.sheetUrl, coverUrl: nz.vorher.coverUrl })
}

/* Ausweg per Mail: derselbe Endpunkt wie das Mailfeld unter der Figur. Der
   Link fuehrt immer zur aktuellen Figur des Auftrags, also nach dem Zeichnen
   zur neuen. Wer seine Adresse schon dagelassen hat, sieht nur den Satz. */
function nzMailFeldVorbereiten () {
  const mailKnopf = $('#bv-ov-mail')
  const feld = $('#bv-ov-mailfeld')
  const status = $('#bv-ov-mailstatus')
  const adresse = $('#bv-ov-mailadresse')
  if (!mailKnopf || !feld || !status) return
  feld.hidden = true
  if (state.mailGesichert) {
    mailKnopf.hidden = true
    status.hidden = false
    // mailGesichert traegt die Adresse nur, wenn sie in dieser Sitzung
    // eingetippt wurde. Kam sie vom Server (figurAnbieten sagt nur ja oder
    // nein), steht dort true, und der Satz hiess "unterwegs an true"
    // (Paul, 22.09.).
    const adresse = typeof state.mailGesichert === 'string' ? state.mailGesichert : ''
    status.textContent = adresse
      ? `Der Link ist unterwegs an ${adresse} und führt zur fertigen Figur.`
      : 'Deine Mailadresse ist hinterlegt. Der Link führt zur fertigen Figur.'
  } else {
    mailKnopf.hidden = false
    mailKnopf.disabled = false
    status.hidden = true
    status.textContent = ''
    if (adresse && !adresse.value && state.vorabMail) adresse.value = state.vorabMail
  }
}
async function nzMailSchicken () {
  const adresse = $('#bv-ov-mailadresse')
  const status = $('#bv-ov-mailstatus')
  const senden = $('#bv-ov-mailsenden')
  const email = (adresse?.value || '').trim()
  status.hidden = false
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
    status.textContent = 'Bitte eine gültige Mailadresse eingeben.'
    adresse?.focus()
    return
  }
  senden.disabled = true
  senden.textContent = 'Wird geschickt…'
  try {
    const werbung = true
    const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/figur-sichern`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, werbung, stelle: 'figur' })
    }))
    const data = await res.json()
    if (!res.ok) throw new Error(data.error || 'Das hat gerade nicht geklappt.')
    messe('mail_hinterlassen')
    if (werbung) messe('mail_werbung')
    state.mailGesichert = email
    $('#merken-mail-zeile')?.classList.add('ist-fertig')
    mailAngebotSchliessen()
    $('#bv-ov-mailfeld').hidden = true
    status.textContent = data.gesendet ? `Der Link ist unterwegs an ${email}.` : `Gespeichert. Der Link kommt per Mail an ${email}.`
  } catch (err) {
    status.textContent = err.message
    senden.disabled = false
    senden.textContent = 'Link schicken'
  }
}

document.addEventListener('click', e => {
  const chip = e.target.closest('.bv-chip')
  if (chip) {
    const aktiv = chip.getAttribute('aria-pressed') === 'true'
    for (const c of $$('.bv-chip')) c.setAttribute('aria-pressed', 'false')
    if (!aktiv) chip.setAttribute('aria-pressed', 'true')
    nz.hinweis = aktiv ? null : (NZ_HINWEISE.includes(chip.dataset.hinweis) ? chip.dataset.hinweis : null)
    return
  }
  const ziel = e.target.closest('#bv-ov-los, #bv-ov-gleich, #bv-ov-abbrechen, #bv-ov-nochmal, #bv-ov-fehler-behalten, #bv-ov-uebernehmen, #bv-ov-behalten, #bv-ov-mail, #bv-ov-mailsenden')
  if (!ziel) return
  e.preventDefault()
  switch (ziel.id) {
    // Im Testballon oeffnet der Hauptknopf die Fotoauswahl (im Klick selbst,
    // sonst blockt Safari den Dateidialog).
    case 'bv-ov-los': if (AEHNLICH) $('#bv-ov-datei')?.click(); else nzLauf(); break
    case 'bv-ov-gleich': nzLauf(); break
    case 'bv-ov-abbrechen': nzZeige(null); break
    // Ist das neue Foto nie angekommen, mit demselben Foto noch einmal
    // hochladen; sonst liegt es auf dem Server und nur der Tausch faellt neu.
    case 'bv-ov-nochmal': nzLauf(nz.neuesFoto && !nz.fotoHochgeladen ? { neuesFoto: nz.neuesFoto } : {}); break
    case 'bv-ov-fehler-behalten': nzZeige(null); break
    case 'bv-ov-uebernehmen': nzUebernehmen(); break
    case 'bv-ov-behalten': nzBehalten(); break
    case 'bv-ov-mail': {
      const feld = $('#bv-ov-mailfeld')
      if (feld) { feld.hidden = false; ziel.hidden = true; $('#bv-ov-mailadresse')?.focus() }
      break
    }
    case 'bv-ov-mailsenden': nzMailSchicken(); break
  }
})
$('#bv-ov-mailadresse')?.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); nzMailSchicken() } })

/* Seitenzaehler: die Seite, deren Mitte der Marke bei 45 Prozent der
   Bildschirmhoehe am naechsten liegt; Fortschritt Seite geteilt durch 10. */
function buchvorschauSeitenzaehler () {
  const seiten = $$('#bv-buch [data-page]')
  if (!seiten.length) return
  const mitte = window.innerHeight * 0.45
  let beste = 0; let abstand = Infinity
  for (const el of seiten) {
    const r = el.getBoundingClientRect()
    const d = Math.abs((r.top + r.bottom) / 2 - mitte)
    if (d < abstand) { abstand = d; beste = Number(el.dataset.page) }
  }
  // Tiefste Seite merken, gemeldet wird sie von seitenMelden (16.09.).
  if (state.tiefeMax === null || state.tiefeMax === undefined || beste > state.tiefeMax) state.tiefeMax = beste
  const label = beste === 0 ? 'Cover' : `Seite ${beste} von 10`
  const breite = `${Math.max(4, Math.round(beste / 10 * 100))}%`
  const seitenlabel = $('#bv-seitenlabel')
  if (seitenlabel) seitenlabel.textContent = label
  const balken = $('#bv-balken')
  if (balken) balken.style.width = breite
  // Fixierte Leiste am Telefon (01.10., design_handoff_wunolo_vorschau_button):
  // Knopf bleibt immer gleich, nur die Statuszeile wandert. "Vorschau · Seite
  // n" bewusst ohne "von 10", damit niemand denkt, das Buch habe nur 10
  // Seiten. Am Ende "Vorschau komplett" mit Haken, Linie voll.
  const ende = $('.bv-ende')
  const leiste = $('#bv-leiste')
  if (leiste) {
    const amSeitenende = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4
    const amEnde = Boolean(ende) && (ende.getBoundingClientRect().top < window.innerHeight * 0.7 || amSeitenende)
    leiste.classList.toggle('bv-leiste-am-ende', amEnde)
    const leistenLabel = $('#bv-leiste-label')
    if (leistenLabel) leistenLabel.textContent = amEnde ? 'Vorschau komplett' : (beste === 0 ? 'Cover' : `Vorschau · Seite ${beste}`)
    const linie = $('#bv-leiste-balken')
    if (linie) linie.style.width = amEnde ? '100%' : `${Math.max(3, Math.round(beste / 10 * 100))}%`
  }
}
let bvScrollTakt = null
window.addEventListener('scroll', () => {
  if (bvScrollTakt || $('#buchvorschau')?.hidden !== false) return
  bvScrollTakt = requestAnimationFrame(() => { bvScrollTakt = null; buchvorschauSeitenzaehler() })
}, { passive: true })
document.addEventListener('click', e => {
  const weiter = e.target.closest('.bv-weiter')
  if (weiter) { e.preventDefault(); $('#next')?.click(); return }
  const neu = e.target.closest('#bv-neu, [data-bv-neu]')
  if (neu) { e.preventDefault(); nzStart() }
})

/* ------------------------------------------- Gespeicherte Figur uebernehmen */
/* Der Link aus der Versandmail legt ein Token in den lokalen Speicher
   (wunolo-kopf-stil.liquid), oder er steht direkt in der Adresse. Der Server
   prueft Signatur, Ablauf und ob die Figur noch liegt; hier wird nur
   angeboten. Wer ablehnt, bekommt den normalen Weg mit Foto, und das Token
   wird vergessen, damit die Frage nicht bei jedem Besuch wiederkommt. */
/* Mehrere Kinder (25.09., Nutzertest Paul): Der Browser merkte sich nur EINE
   Figur. Wer Mia und danach Karl zeichnete, verlor Mia auf allen anderen
   Buchseiten. Jetzt eine Liste mit bis zu drei Figuren, neueste zuerst, je
   Vorname nur ein Eintrag (eine neue Figur fuer Mia ersetzt die alte).
   'wunolo.figur' traegt weiter die neueste, daran haengt die Umschaltung
   der Produktseite fuer Rueckkehrer (wunolo-kopf-stil). */
const FIGUREN_SCHLUESSEL = 'wunolo.figuren'
const FIGUREN_HOECHSTENS = 3

function figurenListe () {
  try {
    const roh = JSON.parse(localStorage.getItem(FIGUREN_SCHLUESSEL) || '[]')
    const liste = Array.isArray(roh) ? roh.filter(e => e && typeof e.token === 'string' && e.token) : []
    // Aus der Zeit vor der Liste: der eine Eintrag unter dem alten Schluessel.
    const einzeln = localStorage.getItem('wunolo.figur')
    if (einzeln && !liste.some(e => e.token === einzeln)) liste.unshift({ token: einzeln, name: '' })
    return liste.slice(0, FIGUREN_HOECHSTENS)
  } catch { return [] }
}

function figurenSpeichern (liste) {
  try {
    const kurz = liste.slice(0, FIGUREN_HOECHSTENS)
    localStorage.setItem(FIGUREN_SCHLUESSEL, JSON.stringify(kurz))
    if (kurz[0]) localStorage.setItem('wunolo.figur', kurz[0].token)
    else localStorage.removeItem('wunolo.figur')
  } catch {}
}

function figurTokenLesen () {
  try {
    const ausAdresse = new URLSearchParams(location.search).get('figur')
    state.figurAusAdresse = Boolean(ausAdresse)
    if (ausAdresse && !figurenListe().some(e => e.token === ausAdresse)) {
      figurenSpeichern([{ token: ausAdresse, name: '' }, ...figurenListe()])
    }
    return ausAdresse || figurenListe()[0]?.token || null
  } catch { return null }
}

/** Einen Eintrag vergessen (abgelaufen oder nicht mehr ladbar). */
function figurTokenVergessen (token = state.figurToken) {
  if (!token) return
  figurenSpeichern(figurenListe().filter(e => e.token !== token))
}

function figurTokenMerken (token, name = state.name) {
  state.figurToken = token
  const vorname = String(name || '').trim()
  const gleich = e => vorname && String(e.name || '').trim().toLowerCase() === vorname.toLowerCase()
  figurenSpeichern([{ token, name: vorname }, ...figurenListe().filter(e => e.token !== token && !gleich(e))])
}

/*
 * Schritt 1, wenn eine fertige Figur angeboten wird (13.09., Befund Paul):
 * Der Kasten stand oben, und darunter standen Vorname, Kind und Alter, als
 * muesste man sie ausfuellen. Der Weiter-Knopf am Fuss war dabei gesperrt,
 * weil genau diese Felder leer waren. Das sah aus wie ein Formular mit einem
 * Hinweis obendrueber statt wie eine Wahl, und ein gesperrter Knopf ohne
 * sichtbaren Grund ist schlimmer als gar keiner.
 *
 * Solange der Kasten steht, ist er der ganze Schritt. Erst "Anderes Kind oder
 * neues Foto" holt das Formular zurueck, und dieses Zurueckholen ist der Teil,
 * den man leicht vergisst: Ohne es stuende die Kundin nach dem Verwerfen vor
 * einer leeren Seite.
 */
let schritt1Texte = null
function formularVerbergen (verbergen) {
  const felder = $('.fk-felder')
  if (felder) felder.hidden = verbergen
  // Das fruehe Mailfeld (Testhaelfte a) steht in Schritt 1 unter den Feldern.
  // Neben der Wahl eines schon gezeichneten Kindes fragt es nach etwas, das
  // der Auftrag des Kindes schon kennt oder spaeter erfragt (25.09.). In
  // Haelfte b sitzt es in Schritt 2, den die Uebernahme ueberspringt, also
  // sehen beide Haelften hier dasselbe.
  const mailZeile = document.getElementById('vorab-mail-zeile')
  if (mailZeile && mailZeile.closest('.step[data-step="1"]')) mailZeile.hidden = verbergen
  // Der Weiter-Knopf gehoert zum Formular, nicht zum Angebot: Das Angebot
  // traegt seine zwei eigenen Knoepfe. Ueber seine Sichtbarkeit entscheidet
  // aber aktualisiereSchrittanzeige und nicht diese Funktion hier: Beim ersten Bau
  // stand die Zeile in formularVerbergen, und weil die Uebernahme direkt in
  // den Kaufschritt springt, ohne je formularVerbergen(false) zu rufen, blieb
  // der Knopf dort versteckt. Auf dem Bildschirm, auf dem gekauft wird, gab
  // es dann gar keinen Weg mehr (Befund Paul, 13.09.). Eine Stelle, die alle
  // Faelle kennt, statt zweier, die sich gegenseitig ueberschreiben.
  const titel = $('#titel-schritt1')
  const lede = $('#lede-schritt1')
  if (verbergen) {
    // Erst beim Verbergen merken, nicht beim Laden: Eine Konstante vom
    // Seitenanfang wuerde beim Zurueckholen einen Text einsetzen, den eine
    // Section vorher umgeschrieben haben kann.
    if (!schritt1Texte) schritt1Texte = { titel: titel?.textContent || '', lede: lede?.textContent || '' }
    // Die Frage ist seit dem 25.09. eine Wahl statt ja oder nein (Nutzertest
    // Paul): Wer zwei Kinder hat, soll nicht Mia wegklicken muessen, um
    // Karl ins Buch zu holen. Kein Fuerwort fuer die Zeichnung (13.09.).
    if (titel) titel.textContent = 'Für wen ist dieses Buch?'
    if (lede) lede.textContent = tx('Die Zeichnung ist gespeichert, ein neues Foto brauchst du nicht.', `${state.name.trim() || 'Dein Kind'} ist gespeichert, ein neues Foto brauchst du nicht.`)
  } else if (schritt1Texte) {
    if (titel) titel.textContent = schritt1Texte.titel
    if (lede) lede.textContent = schritt1Texte.lede
  }
  aktualisiereSchrittanzeige()
}

async function figurAnbieten () {
  const angebot = $('#figur-angebot')
  const erster = figurTokenLesen()
  if (!angebot || !erster) return
  const tokens = [erster, ...figurenListe().map(e => e.token).filter(t => t !== erster)].slice(0, FIGUREN_HOECHSTENS)
  const geladen = await Promise.all(tokens.map(async token => {
    try {
      const res = await geduldig(() => fetch(`${BACKEND}/api/figur/${encodeURIComponent(token)}`))
      const data = await res.json()
      if (!res.ok) throw new Error(data.error)
      return { token, figur: data.figur }
    } catch {
      // Abgelaufen oder geloescht: still vergessen, kein Fehlerkasten.
      figurTokenVergessen(token)
      return null
    }
  }))
  // Nur Figuren im Stil dieses Buchs (07.10., Audit der Welt abenteuer): Der Server
  // sperrt die Uebernahme zwischen gezeichnetem Stil und "zum Verwechseln aehnlich"
  // (STIL_WECHSEL). Angeboten hiess vorher: Fehlerfenster, und die Figur war danach
  // auch fuer den anderen Stil vergessen. Fremde Figuren bleiben gemerkt, sie werden
  // hier nur nicht gezeigt. Ohne Geschichte (Figur-Einstieg) gilt der gezeichnete Stil.
  const kinder = geladen.filter(k => k && /-aehnlich$/.test(String(k.figur.storyId || '')) === AEHNLICH)
  if (!kinder.length) return
  // Alte Eintraege kannten den Namen noch nicht, die Auskunft schon.
  figurenSpeichern(figurenListe().map(e => {
    const k = kinder.find(x => x.token === e.token)
    return k && !e.name ? { ...e, name: k.figur.name || '' } : e
  }))

  const waehlen = ({ token, figur }) => {
    state.figur = figur
    state.figurToken = token
    /* Adresse schon dagelassen (13.09., Befund Paul): Der Server schickt nur
       ja oder nein, nie die Adresse selbst, deshalb steht hier true und keine
       Zeichenkette. */
    if (figur.mailDa) {
      state.mailGesichert = true
      mailAngebotSchliessen()
    }
  }
  // Mit dem Token in der Adresse (Link aus der Mail, Figur Sekunden alt) keine
  // Rueckfrage. Nur auf einer Produktseite, sonst fehlt die Geschichtenwahl.
  if (kinder[0].figur.nurFigur && state.figurAusAdresse && PINNED_STORY) {
    waehlen(kinder[0])
    return figurUebernehmen()
  }

  const wahl = $('#figur-wahl')
  // Je Kind ein × zum Entfernen (28.09., Paul): Die Zelle traegt beide
  // Knoepfe nebeneinander, ein Knopf im Knopf waere kein gueltiges HTML.
  wahl.innerHTML = kinder.map(({ token, figur }) => `
    <div class="fk-figur-zelle">
      <button type="button" class="fk-figur-kind" data-token="${escHtml(token)}">
        <img src="${escHtml(figur.sheetUrl || '')}" alt="" width="64" height="85">
        <span>${escHtml(figur.name || 'Dein Kind')}</span>
      </button>
      <button type="button" class="fk-figur-weg" data-token="${escHtml(token)}" aria-label="${escHtml(figur.name || 'Dieses Kind')} entfernen"><span aria-hidden="true">×</span></button>
    </div>`).join('')

  // Zurueck zum normalen Weg mit Foto, ohne gewaehlte Figur.
  const zumFormular = () => {
    angebot.hidden = true
    state.figur = null
    state.figurToken = null
    // Die Adresse gehoerte zum Auftrag des anderen Kindes, der neue hat keine
    // (22.09., Paul: MaxTest ohne Kontakt, aber "Link ist unterwegs").
    if (state.mailGesichert === true) state.mailGesichert = ''
    formularVerbergen(false)
  }

  wahl.addEventListener('click', e => {
    if (state.jobId) return
    // Entfernen vergisst die Figur nur auf diesem Geraet. Die Zeichnung
    // bleibt auf dem Server, der Link aus der Mail fuehrt weiter zu ihr.
    const weg = e.target.closest('.fk-figur-weg')
    if (weg) {
      const token = weg.dataset.token
      figurTokenVergessen(token)
      const i = kinder.findIndex(k => k.token === token)
      if (i >= 0) kinder.splice(i, 1)
      weg.closest('.fk-figur-zelle')?.remove()
      // Kaeme das Token aus der Adresse, legte ein Neuladen es wieder an.
      try {
        const u = new URL(location.href)
        if (u.searchParams.get('figur') === token) {
          u.searchParams.delete('figur')
          history.replaceState(history.state, '', u.pathname + u.search + u.hash)
        }
      } catch {}
      if (!kinder.length) zumFormular()
      return
    }
    const knopf = e.target.closest('.fk-figur-kind')
    if (!knopf) return
    const kind = kinder.find(k => k.token === knopf.dataset.token)
    if (!kind) return
    waehlen(kind)
    figurUebernehmen(knopf)
  })
  angebot.hidden = false
  formularVerbergen(true)

  // "+ Anderes Kind": normaler Weg mit Foto. Die gespeicherten Figuren
  // bleiben, die neue kommt dazu (bis 25.09. wurde die alte hier vergessen).
  $('#figur-verwerfen').addEventListener('click', () => {
    messe('anderes_kind')
    zumFormular()
  })
}

/* Der kleine Figur-Streifen in Schritt 5. */
function zeigeFigurBeleg () {
  const kasten = $('#figur-beleg')
  if (!kasten || !state.sheetUrl) return
  const bild = $('#figur-beleg-bild')
  if (bild) {
    bild.src = state.sheetUrl
    bild.alt = tx(`Gezeichnete Hauptfigur${state.name ? ` von ${state.name}` : ''}`, `${state.name || 'Dein Kind'} im Buch`)
  }
  const held = $('#figur-beleg-held')
  if (held) held.textContent = state.gender === 'girl' ? 'Buchheldin' : 'Buchheld'
  kasten.hidden = false
}

$('#figur-beleg-aendern')?.addEventListener('click', () => { go(4) })

// "Anderes Buch waehlen" mit Rueckfrage (08.10.2026, Paul: "nochmal Frage
// stellen, ob er wirklich den aktuellen Funnel verlassen moechte, und auf
// jeden Fall tracken, wer wann diesen Button drueckt"). Der Link oeffnet erst
// die Karte darunter; jeder Schritt zaehlt anonym in der Treppe (messe) und
// steht mit Zeitpunkt am Auftrag (anderesBuchVermerken), dort sieht ihn die
// Werkstatt. Beides per sendBeacon, das auch den Seitenwechsel ueberlebt.
function anderesBuchVermerken (schritt) {
  if (!state.jobId) return
  try {
    const ziel = `${window.WUNOLO_BACKEND || ''}/api/jobs/${state.jobId}/anderes-buch`
    const koerper = JSON.stringify({ schritt })
    if (navigator.sendBeacon) navigator.sendBeacon(ziel, new Blob([koerper], { type: 'text/plain;charset=UTF-8' }))
    else fetch(ziel, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: koerper, keepalive: true }).catch(() => {})
  } catch { /* ein verlorener Vermerk ist folgenlos */ }
}
$('#anderes-buch-link')?.addEventListener('click', e => {
  e.preventDefault()
  messe('anderes_buch', { storyId: state.storyId })
  anderesBuchVermerken('gefragt')
  const frage = $('#anderes-buch-frage')
  const weiter = $('#anderes-buch-weiter')
  if (weiter) weiter.href = e.currentTarget.href
  if (!frage) { location.href = e.currentTarget.href; return }
  frage.hidden = false
  frage.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
})
$('#anderes-buch-bleiben')?.addEventListener('click', () => {
  messe('anderes_buch_geblieben', { storyId: state.storyId })
  anderesBuchVermerken('geblieben')
  const frage = $('#anderes-buch-frage')
  if (frage) frage.hidden = true
})
$('#anderes-buch-weiter')?.addEventListener('click', () => {
  messe('anderes_buch_verlassen', { storyId: state.storyId })
  anderesBuchVermerken('verlassen')
})

async function figurUebernehmen (knopf = null) {
  const f = state.figur
  if (!f || state.jobId) return
  const vorher = knopf?.innerHTML
  if (knopf) {
    knopf.disabled = true
    knopf.classList.add('laedt')
    const text = knopf.querySelector('span')
    if (text) text.textContent = 'Wird geladen…'
  }
  Object.assign(state, {
    name: f.name || '', gender: f.gender, age: f.age, ageRange: f.ageRange,
    hairColor: f.hairColor, hairStyle: f.hairStyle, eyeColor: f.eyeColor,
    consent: true
  })
  const nameFeld = $('#name')
  if (nameFeld) nameFeld.value = state.name
  try {
    const res = await geduldig(() => fetch(BACKEND + '/api/jobs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        storyId: state.storyId, name: state.name, gender: state.gender, age: state.age, ageRange: state.ageRange,
        hairColor: state.hairColor, hairStyle: state.hairStyle, eyeColor: state.eyeColor,
        consent: true, vonFigur: state.figurToken, messung: messKennung()
      })
    }))
    const data = await res.json()
    if (!res.ok) throw new Error(data.error)
    if (!data.sheetUrl) throw new Error(data.figurFehler || 'Figur nicht mehr gespeichert')
    state.jobId = data.jobId
    state.photoOk = true
    state.previewStarted = true
    state.figurUebernommen = true
    // Zum Buch (16.09., Paul: "Figur auf andere Buecher uebertragen"): Die
    // Figur steht, das Cover fuer DIESE Geschichte fehlt noch. Derselbe Weg
    // wie beim Geschichtenwechsel: go(4) startet coverNeu, /geschichte baut
    // das Cover mit der Warteanimation, danach steht das Buch mit der Figur.
    // Bis 16.09. sprang die Uebernahme direkt in den Kaufschritt, damals gab
    // es kein Buch zu sehen, nur die Figur. Das Token des neuen Auftrags
    // ersetzt das alte im Browserspeicher.
    if (data.figurToken) figurTokenMerken(data.figurToken)
    state.sheetUrl = data.sheetUrl
    state.coverUrl = null
    state.variants = [{ key: null, url: data.sheetUrl, coverUrl: null }]
    state.attemptsLeft = 0
    // Ohne Foto gibt es kein Neu-zeichnen; sheetChosen haelt die Links weg.
    state.sheetChosen = true
    state.geschichteGewechselt = true
    merkenMailZeigen()
    aktualisiereZusammenfassung()
    zeigeFigurBeleg()
    go(4)
  } catch (err) {
    // Rueckfall auf den normalen Weg: Auftrag ohne Figur, Foto-Schritt wie
    // immer. Das Profil bleibt vorausgefuellt.
    if (knopf) {
      knopf.disabled = false
      knopf.classList.remove('laedt')
      knopf.innerHTML = vorher
    }
    $('#figur-angebot').hidden = true
    figurTokenVergessen(state.figurToken)
    formularVerbergen(false)
    alert(`${err.message}\n\nKein Problem: Mit einem neuen Foto ist die Figur in zwei Minuten wieder da.`)
    validate()
  }
}

$('#variants').addEventListener('click', async e => {
  const btn = e.target.closest('.variant')
  if (!btn) return
  const v = state.variants.find(x => x.key === btn.dataset.key)
  if (!v) return
  state.sheetUrl = v.url
  state.coverUrl = v.coverUrl || null
  state.figurArt = v.figurArt || null
  zeigeVorschauBild()
  $$('#variants .variant').forEach(b => b.setAttribute('aria-pressed', String(b === btn)))
})

$('#regenerate').addEventListener('click', async () => {
  const btn = $('#regenerate')
  // figur_neu stand seit dem 11.09. in NEBENEREIGNISSE, geschrieben hat es nie
  // jemand (12.09. aufgefallen). Ohne diese Zahl laesst sich nicht sagen, ob
  // die Haelfte, die nach der Figur abbricht, an der Aehnlichkeit scheitert
  // oder am Weg. Vor dem Aufruf gemessen, weil hier die Absicht zaehlt und
  // nicht der Erfolg: Ein verbrauchter Versuch ist auch dann eine Aussage,
  // wenn das Zeichnen scheitert.
  messe('figur_neu')
  btn.disabled = true
  btn.textContent = tx('Faro zeichnet neu…', 'Wir versuchen es noch einmal…')
  // Nur noch fuer die Figuransicht ohne Buch (Figur zuerst). Mit Buch
  // uebernimmt das Overlay (nzStart, Designpaket neu_zeichnen, 15.09.).
  try {
    const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/regenerate`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ bekannteVarianten: (state.variants || []).length }) }))
    const data = await res.json()
    if (!res.ok) throw new Error(data.error)
    showPreview(data)
  } catch (err) {
    $('#attempts-left').textContent = err.message
    btn.disabled = false
    btn.textContent = tx('Neu zeichnen lassen', 'Noch einmal versuchen')
  }
})

/* ------------------------------------------------------ Figur bestaetigen */
/* Beim Verlassen des Figur-Schritts, nicht erst im Warenkorb (03.09.):
   Mit der Bestaetigung loescht der Server das Kundenfoto und die nicht
   gewaehlten Varianten. "Sobald du weitergehst, loeschen wir das Foto" steht
   so ueber der Figur, und Eltern sollen es in der Zusammenfassung sehen,
   noch bevor sie ueber Ausgabe und Widmung entscheiden. Vorher lag das Foto
   bis zum Klick in den Warenkorb, bei Abbruch bis zum Aufraeumlauf. */
/*
 * Figur beim Server bestaetigen. Erst dieser Aufruf loescht das Foto.
 *
 * Gibt true zurueck, wenn es geklappt hat. Bis zum 12.09. gab es diese
 * Unterscheidung nicht: Der Aufruf schluckte jeden Fehler
 * (.then(r => r.ok ? r.json() : null).catch(() => null)) und danach lief
 * state.sheetChosen = true in jedem Fall. Wer weiterging, kaufte mit einer
 * Figur, die der Server nie bestaetigt hatte, und sein Foto blieb liegen,
 * obwohl der Funnel darueber "Sobald du weitergehst, loeschen wir das Foto"
 * schreibt und die Datenschutzerklaerung dasselbe sagt. Weil die Funktion
 * oben mit "if (state.sheetChosen) return" beginnt, konnte auch kein zweiter
 * Versuch mehr etwas senden.
 */
async function bestaetigeFigur () {
  if (state.sheetChosen) return true
  const chosen = state.variants?.find(v => v.url === state.sheetUrl)
  if (chosen?.key) {
    // Antwort lesen: Bei Figur zuerst liefert der Server das Token, mit dem
    // die Buchlinks die Figur in den Produkt-Funnel mitnehmen.
    let antwort = null
    try {
      const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/choose-sheet`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        // Ohne figurMerken (13.09.): Der Haken ist weg, alle Figuren bleiben
        // zwoelf Monate. Der Server entscheidet die Frist selbst.
        body: JSON.stringify({ key: chosen.key }),
        signal: typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(20000) : undefined,
      }))
      if (res.ok) antwort = await res.json().catch(() => null)
    } catch { antwort = null }
    // sheetChosenAt entsteht nur, wenn der Server die Figur wirklich
    // festgeschrieben und das Foto geloescht hat.
    if (!antwort?.sheetChosenAt) return false
    if (antwort.figurToken) {
      state.figurToken = antwort.figurToken
      state.figurLink = antwort.figurLink
    }
  }
  state.sheetChosen = true
  // "Figur bestaetigt" ist seit 16.09. keine Stufe mehr: derselbe Klick
  // meldet "buch" (Weiter zur Bestellung), siehe #next.
  merkenMailZeigen()
  // Neu zeichnen geht ohne Foto nicht mehr; die Knoepfe dafuer weg.
  $('#variants').hidden = true
  const regen = $('#regenerate')
  if (regen) regen.hidden = true
  // Auch die Links in der Buchvorschau (30.09., Pauls Test): Wer nach
  // "Weiter zur Bestellung" zurueckging, sah noch "Neu zeichnen lassen ·
  // noch 1 Versuch", der Klick tat aber nichts (nzStart bricht bei
  // bestaetigter Figur ab). neuLinksSetzen blendet bei sheetChosen aus.
  neuLinksSetzen(0)
  const left = $('#attempts-left')
  if (left) {
    left.hidden = false
    left.textContent = 'Figur bestätigt. Für eine andere Figur bitte ein neues Foto hochladen.'
  }
  aktualisiereZusammenfassung()
  return true
}

/* Text aus dem Shop wandert in Markup: Ein Apostroph oder eine spitze
   Klammer darf die Seite nicht zerlegen. */
function escHtml (wert) {
  return String(wert ?? '').replace(/[&<>"']/g, z => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z]))
}


/*
 * Einmal fragen reicht (13.09., Befund Paul mit zwei Screenshots).
 *
 * Er hatte im Kasten unter der Figur seine Adresse eingetragen, Knopf stand
 * auf "Geschickt", darunter "Der Link ist unterwegs an paul.schoen@me.com".
 * Ein Tipp weiter, auf der Buchwahl, stand die Frage erneut da: als Ankerzeile
 * "Keine Zeit? Wir schicken dir die Figur per Mail" und als vollstaendiges
 * zweites Formular unter den Covern. Zwei Angebote fuer etwas, das schon
 * passiert ist, und das ausgerechnet auf dem Bildschirm, auf dem ein Buch
 * gewaehlt werden soll.
 *
 * Bisher kannte der Funnel nur eine Regel dazu: Sobald die Buchwahl aufgeht,
 * weicht der Kasten unter der Figur dem Formular unter den Covern
 * (merkenMailZeigen, 12.09.). Die Regel achtete darauf, dass nie zwei Felder
 * gleichzeitig dastehen, aber nicht darauf, ob ueberhaupt noch eines noetig
 * ist.
 *
 * Jetzt schliesst der erfolgreiche Versand beide Angebote und ersetzt das
 * Formular unter den Covern durch die Zusage, um die es eigentlich geht: Du
 * musst dich heute nicht entscheiden.
 */
function mailAngebotSchliessen () {
  if (!state.mailGesichert) return
  // Das gerade benutzte Formular bleibt stehen, erkennbar an ist-fertig: Es
  // traegt die Rueckmeldung, und ein Kasten, der im Moment des Absendens
  // verschwindet, sieht aus wie ein Fehler.
  const kasten = $('#merken-mail-zeile')
  if (kasten && !kasten.classList.contains('ist-fertig')) kasten.hidden = true
}

/* --------------------------------- Figur-Link zum Merken-Haken (09.09.) */
/* Der Haken allein verlaengert nur die Aufbewahrung; den Link bekam man
   bisher ausschliesslich mit der Versandmail, also nie ohne Bestellung.
   Das Feld schliesst diese Luecke und nutzt denselben Endpunkt wie die
   Figur-Seite. Freiwillig: ohne Adresse bleibt alles wie vorher. */
function merkenMailZeigen () {
  const zeile = $('#merken-mail-zeile')
  if (!zeile) return
  // 12.09. (Paul): Bis hierher hing das Feld am Merk-Haken UND war im
  // Figur-Einstieg ganz abgeschaltet, also genau dort, wo unsere Anzeigen
  // hinfuehren. Von 20 Besuchern mit Figur hat keiner eine Adresse
  // dagelassen. Jetzt steht die Frage offen da, sobald eine Figur existiert:
  // im staerksten Moment, direkt nachdem die Kundin ihr Kind gezeichnet
  // gesehen hat, und neben dem Knopf "Geschichte waehlen", nicht davor.
  //
  // Sie verschwindet, sobald die Buchwahl aufgeht: Ab da uebernimmt das
  // zweite Formular unter den Covern, und zwei gleiche Mailfelder auf einer
  // Seite waeren nur verwirrend.
  //
  // Den Merk-Haken darueber gibt es seit dem 13.09. nicht mehr, alle Figuren
  // bleiben zwoelf Monate.
  // Nicht mehr an sheetChosen (13.09.): Seit es Verlaufseintraege gibt, kommen
  // Besucher aus der Buchwahl zurueck auf Schritt 4. Dort ist die Figur
  // bestaetigt, das Formular unter den Covern aber zugeklappt, und die
  // Kundin stand vor gar keinem Mailangebot mehr. Massgeblich ist nur, ob
  // eine Figur da ist und ob die Buchwahl gerade den Bildschirm fuellt.
  // Und nicht mehr, wenn der Link schon unterwegs ist (13.09.): Wer die
  // Adresse dagelassen hat, soll sie beim Zurueckkommen aus der Buchwahl nicht
  // noch einmal angeboten bekommen.
  const figurDa = Boolean(state.sheetUrl)
  zeile.hidden = !figurDa || Boolean(state.mailGesichert)
  // Nicht auf dem Umweg "Figur ansehen" aus der Bestellung (22.09., Paul):
  // dort stand der Kasten ein zweites Mal zwischen zwei gleichen Knoepfen.
  if (state.step === 4 && state.figurUebernommen && LETZTER_SCHRITT >= 5) zeile.hidden = true
  // Die Frage nennt das Kind, nicht das Werkstattwort (12.09., Paul):
  // "Sollen wir dir Mias Buchheldin schicken?" statt "die Figur".
  // Wer vorab schon eine Adresse hinterlegt hat, muss sie nicht zweimal
  // tippen. Die Einwilligung entsteht trotzdem erst hier, mit dem Knopf.
  const feld = $('#merken-mail')
  if (feld && !feld.value && state.vorabMail) feld.value = state.vorabMail
  const frage = $('#merken-frage')
  const knopf = $('#merken-knopf')
  const maedchen = state.gender === 'girl'
  const g = genitiv(state.name)
  if (state.coverUrl) {
    // Mit Buch (22.09.): Der Gewinn ist das Wiederfinden des Buchs, nicht
    // die Zeichnung als Anhang. "Mias Buch spaeter wiederfinden?"
    if (frage) frage.textContent = g ? `${g} Buch später wiederfinden?` : 'Dein Buch später wiederfinden?'
    if (knopf) knopf.textContent = 'Link per Mail schicken'
  } else if (frage) {
    const held = maedchen ? 'Buchheldin' : 'Buchheld'
    frage.textContent = g
      ? `Sollen wir dir ${g} ${held} schicken?`
      : `Sollen wir dir ${maedchen ? 'die' : 'den'} ${held} schicken?`
    if (knopf) knopf.textContent = 'Figur per Mail schicken'
  }
}

async function merkenLinkSchicken () {
  const feld = $('#merken-mail')
  const status = $('#merken-status')
  const knopf = $('#merken-knopf')
  const email = (feld?.value || '').trim()
  status.hidden = false
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
    status.textContent = 'Bitte eine gültige Mailadresse eingeben.'
    feld?.focus()
    return
  }
  knopf.disabled = true
  knopf.textContent = 'Wird geschickt…'
  try {
    // Werbe-Haken seit 09.09. auch hier (Paul): gleiches Double-Opt-in wie
    // auf der Figur-Seite, nur ohne Code-Versprechen.
    // Kein Haken mehr (12.09., Paul): Das Angebot unter der Figur nennt
    // beides, den Link und die Nachrichten zu neuen passenden Geschichten.
    // Wer den Knopf drueckt, willigt in beides ein.
    const werbung = true
    const res = await geduldig(() => fetch(`${BACKEND}/api/jobs/${state.jobId}/figur-sichern`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, werbung, stelle: 'figur' })
    }))
    const data = await res.json()
    if (!res.ok) throw new Error(data.error || 'Das hat gerade nicht geklappt.')
    // Erst nach dem OK messen, sonst zaehlen wir Versuche statt Adressen.
    messe('mail_hinterlassen')
    if (werbung) messe('mail_werbung')
    // Keine Bitte um eine zweite Bestaetigung mehr (12.09., Paul): Es kommt
    // keine zweite Mail, die Einwilligung liegt am Knopf.
    status.textContent = data.gesendet
      ? `Der Link ist unterwegs an ${email}.`
      : `Gespeichert. Der Link kommt per Mail an ${email}.`
    feld.disabled = true
    knopf.textContent = 'Geschickt'
    state.mailGesichert = email
    $('#merken-mail-zeile')?.classList.add('ist-fertig')
    mailAngebotSchliessen()
  } catch (err) {
    status.textContent = err.message
    knopf.disabled = false
    knopf.textContent = 'Link schicken'
  }
}
$('#merken-knopf')?.addEventListener('click', merkenLinkSchicken)

/* ------------------------------------- Wird das Mailformular ueberhaupt gesehen?
   Befund 12.09.: 0 von 13 haben ihre Adresse dagelassen, und wir konnten nicht
   unterscheiden, ob sie das Formular abgelehnt oder nie erreicht haben. Das
   sind zwei verschiedene Probleme: nie gesehen heisst Position und Reihenfolge,
   gesehen und abgelehnt heisst Text und Nutzenversprechen.

   Die Frage beantwortet sich mit einem Ereignis, nicht mit einem A/B-Test: Bei
   13 Figuren am Tag braeuchte selbst eine Verdopplung einen Monat, bis sie
   abgesichert waere.

   Beide Formulare starten mit hidden. Das erledigt den Sonderfall von selbst,
   denn ein Element ohne Flaeche meldet nie eine Kreuzung. */
let mailFormularGemeldet = false
function beobachteMailformular () {
  if (typeof IntersectionObserver !== 'function') return
  const ziele = ['#merken-mail-zeile'].map(s => $(s)).filter(Boolean)
  if (!ziele.length) return
  // Die Haelfte muss zu sehen sein. Beide Formulare sind rund 300 px hoch,
  // also deutlich kleiner als jedes Sichtfenster; die Schwelle ist erreichbar.
  const beobachter = new IntersectionObserver(eintraege => {
    if (mailFormularGemeldet) return
    if (!eintraege.some(e => e.isIntersecting)) return
    mailFormularGemeldet = true
    messe('mail_gesehen')
    beobachter.disconnect()
  }, { threshold: 0.5 })
  ziele.forEach(z => beobachter.observe(z))
}
beobachteMailformular()

/* ------------------------------------------------------------ Warenkorb */
/*
 * In den Warenkorb. Der letzte Knopf des Funnels und bis zum 12.09. der
 * einzige ohne jede Absicherung: Er zaehlte beim Druecken statt beim Erfolg,
 * pruefte die Antwort von Shopify nicht, sprang in jedem Fall auf /cart und
 * liess sich beliebig oft druecken. Eine 422 setzte die Kundin nach zwanzig
 * Minuten Arbeit auf einem leeren Warenkorb ab, ein zweiter Tipp legte
 * dieselbe Position noch einmal an (Shopify fasst sie zu Menge 2 zusammen,
 * die Kundin sah 59,98 statt 29,99). Alle anderen Knoepfe im Funnel machen
 * es laengst richtig.
 */
async function addToCart () {
  const knopf = $('#next')
  const status = $('#kauf-status')
  if (knopf?.dataset.laeuft === '1') return
  if (knopf) { knopf.dataset.laeuft = '1'; knopf.disabled = true; knopf.textContent = 'Wird gespeichert…' }
  if (status) { status.hidden = true; status.textContent = '' }
  let zurKasse = false
  try {
    zurKasse = (await kaufen(status)) === 'kasse'
    if (zurKasse && knopf) knopf.textContent = 'Kasse wird geöffnet…'
  } catch (err) {
    // Alles, was vor dem Warenkorbaufruf schiefgeht, landet hier. Die erste
    // Fassung vom 12.09. fing nur den Aufruf selbst ab, und weil die Sperre
    // schon davor stand, blieb der Knopf nach einem Fehler in
    // bestaetigeFigur() fuer immer auf "Wird gespeichert…" stehen. Nachgewiesen
    // im Browser: $('#variants').hidden ohne Nullpruefung reicht dafuer.
    zeigeKauffehler(status, err)
  } finally {
    // Gesperrt lassen, solange die Kasse laedt (25.09., Code-Pruefung): Der
    // Seitenwechsel dauert am Telefon ein bis drei Sekunden, und ein Knopf,
    // der in dieser Zeit wieder "In den Warenkorb" sagt, laedt zum zweiten
    // Tippen ein. Frei wird er erst, wenn der Browser die Seite aus dem
    // Zwischenspeicher zurueckholt (pageshow unten).
    const freigeben = () => {
      if (knopf) { knopf.dataset.laeuft = '0'; knopf.disabled = false; schreibeWeiterText() }
      validate()
    }
    // Rueckfall: Steht die Seite nach 15 Sekunden noch, kam die Kasse nicht.
    if (!zurKasse) freigeben()
    else setTimeout(() => { if (knopf?.dataset.laeuft === '1' && document.visibilityState === 'visible') freigeben() }, 15000)
  }
}

window.addEventListener('pageshow', e => {
  const knopf = $('#next')
  if (!e.persisted || knopf?.dataset.laeuft !== '1') return
  knopf.dataset.laeuft = '0'
  knopf.disabled = false
  schreibeWeiterText()
  validate()
})

/*
 * Was die Kundin liest, wenn der Kauf nicht klappt.
 *
 * Durchgereicht wird nur, was Shopify selbst begruendet hat ("Die gewuenschte
 * Menge ist nicht verfuegbar"), erkennbar an der Marke vomWarenkorb. Alles
 * andere ist ein Programmfehler oder ein Browsertext wie "Load failed", und
 * beides gehoert nicht in den deutschen Kaufweg (Befund 12.09.).
 */
function zeigeKauffehler (status, err) {
  if (!status || err?.stillAbbrechen) return
  const roh = String(err?.message || '').trim()
  const satz = err?.vomWarenkorb && roh
    ? roh.replace(/([^.!?])$/, '$1.')
    : 'Der Warenkorb war gerade nicht erreichbar.'
  status.textContent = `${satz} Deine Angaben stehen noch hier, nichts ist verloren.`
  status.hidden = false
}

/* Ausgabe und Widmung zur Warenkorb-Stufe (16.09.), damit die Treppe zeigt,
   was gewaehlt wurde, nicht nur dass. */
function warenkorbAngaben () {
  const digital = /digital|pdf/i.test(state.binding || '')
  return { ausgabe: digital ? 'digital' : (state.binding || null), widmung: Boolean(state.dedication?.trim()), ...(posterImKorb() ? { poster: state.poster.groesse } : {}) }
}

/*
 * Zwischenschritt, wenn schon ein anderes Buch im Warenkorb liegt (25.09.).
 * Loest mit 'nur', 'alle' oder null (geschlossen) auf. Kurz, wie die Kasse:
 * was dort liegt, zwei Knoepfe, das eigene Buch vorgewaehlt.
 *
 * Mit zusammen (30.09., Paul): Stammen alle anderen Buecher aus diesem
 * Besuch, will die Kundin sehr wahrscheinlich beide. Dann ist "Beide
 * bestellen" der Hauptknopf; wer schnell tippt, wirft das erste Buch nicht
 * mehr versehentlich raus. Reste frueherer Besuche behalten die alte Wahl.
 */
function korbWahl (andere, zusammen = false) {
  return new Promise(resolve => {
    const euro = n => `${(n / 100).toFixed(2).replace('.', ',')} €`
    const knopfNur = art => `<button type="button" class="btn ${art} kw-nur">Nur das neue Buch bestellen</button>`
    const knopfAlle = art => `<button type="button" class="btn ${art} kw-alle">${andere.length === 1 ? 'Beide bestellen' : 'Alle zusammen bestellen'}</button>`
    const huelle = document.createElement('div')
    huelle.className = 'kw-huelle'
    huelle.innerHTML = `
      <div class="kw-karte" role="dialog" aria-modal="true" aria-labelledby="kw-titel">
        <button type="button" class="kw-zu" aria-label="Schließen">×</button>
        <h2 id="kw-titel">Im Warenkorb liegt schon</h2>
        <ul class="kw-liste">${andere.map(z => `<li><strong>${escHtml(z.product_title || z.title || 'Buch')}</strong><span>${escHtml([z.properties?.Name, z.variant_title].filter(Boolean).join(' · '))} · ${euro(z.final_line_price ?? z.line_price ?? 0)}</span></li>`).join('')}</ul>
        ${zusammen ? knopfAlle('btn-primary') + knopfNur('btn-ghost') : knopfNur('btn-primary') + knopfAlle('btn-ghost')}
      </div>`
    const fertig = wert => { huelle.remove(); document.removeEventListener('keydown', taste); resolve(wert) }
    const taste = e => { if (e.key === 'Escape') fertig(null) }
    huelle.addEventListener('click', e => {
      if (e.target === huelle || e.target.closest('.kw-zu')) fertig(null)
      else if (e.target.closest('.kw-nur')) fertig('nur')
      else if (e.target.closest('.kw-alle')) fertig('alle')
    })
    document.addEventListener('keydown', taste)
    document.body.appendChild(huelle)
    huelle.querySelector(zusammen ? '.kw-alle' : '.kw-nur').focus()
  })
}

/* Mailadresse in die Kasse (30.09., Pauls Test im Instagram-Browser): Wer
 * sie im Funnel schon eingetragen hatte, fand in der Kasse ein leeres Feld
 * und musste neu tippen. Shopify befuellt die Kasse nur ueber einen
 * Kassenlink (/cart/<Variante>:<Menge>?checkout[email]=), /checkout mit
 * demselben Parameter bleibt leer (geprueft). Der Link legt den Warenkorb
 * neu an und traegt Merkmale nur fuer den ersten Artikel, als Base64-JSON.
 * Deshalb nur bei genau einem Buch mit Auftrag und ohne Rabatt, Notiz oder
 * Warenkorb-Attribute; sonst wie bisher /checkout, damit nichts verloren geht.
 *
 * Mit Rabattcode (31.10.2026) immer /checkout?discount=, siehe rabattCodes. */
async function kassenZiel () {
  const mail = (typeof state.mailGesichert === 'string' && state.mailGesichert) || state.vorabMail || ''
  try {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(8000) : undefined })
    if (!res.ok) return '/checkout'
    const korb = await res.json()
    const codes = await rabattCodes(korb)
    if (codes.length) return `/checkout?discount=${encodeURIComponent(codes.join(','))}`
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail.trim())) return '/checkout'
    const zeilen = korb.items || []
    if (zeilen.length !== 1 || !zeilen[0].properties?._jobId) return '/checkout'
    const z = zeilen[0]
    const rabatt = (korb.cart_level_discount_applications || []).length || (korb.discount_codes || []).length || (z.line_level_discount_allocations || []).length
    if (rabatt || korb.note || Object.keys(korb.attributes || {}).length) return '/checkout'
    const merkmale = Object.fromEntries(Object.entries(z.properties).filter(([, v]) => v != null && v !== ''))
    let roh = ''
    for (const b of new TextEncoder().encode(JSON.stringify(merkmale))) roh += String.fromCharCode(b)
    const b64 = btoa(roh).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
    return `/cart/${z.variant_id}:${z.quantity}?properties=${b64}&checkout%5Bemail%5D=${encodeURIComponent(mail.trim())}`
  } catch {
    return '/checkout'
  }
}

/* Rabattcode mit Mindestmenge (31.10.2026, Mehrbuch-Pruefung): Der Funnel
 * schickt nach jedem Buch in die Kasse. Greift der Code dort noch nicht (20 %
 * erst ab drei Buechern), loescht Shopify beim ersten Besuch das Cookie und
 * beim zweiten den Code am Warenkorb. Beim vierten Buch stand dann der volle
 * Preis in der Kasse. Deshalb merkt sich der Warenkorb selbst die Codes, in
 * einem versteckten Merkmal und nicht auf dem Geraet, und jede Kasse bekommt
 * sie als ?discount= mit. Mehrere Codes gehen als Liste, Shopify nimmt den
 * passenden (geprueft: drei Buecher 20 %, vier Buecher 25 %). Neueste zuerst:
 * Cookie aus dem zuletzt getippten Link, dann der Warenkorb, dann Gemerktes. */
const RABATT_MERKMAL = '_rabatt'
const RABATT_HOECHSTENS = 3

async function rabattCodes (korb) {
  const liste = wert => String(wert || '').split(',').map(c => c.trim()).filter(Boolean)
  let ausCookie = ''
  try { ausCookie = decodeURIComponent(/(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie)?.[1] || '') } catch {}
  const gemerkt = liste(korb?.attributes?.[RABATT_MERKMAL])
  const alle = [...liste(ausCookie), ...(korb?.discount_codes || []).map(d => String(d?.code || '').trim()), ...gemerkt]
  const codes = alle.filter((c, i) => c && alle.findIndex(x => x.toLowerCase() === c.toLowerCase()) === i).slice(0, RABATT_HOECHSTENS)
  if (codes.join(',') !== gemerkt.join(',')) {
    // Klappt das Merken nicht, geht diese Kasse trotzdem mit dem Code raus.
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [RABATT_MERKMAL]: codes.join(',') } }),
        signal: typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(8000) : undefined,
      })
    } catch (err) { console.warn('[Warenkorb] Rabattcode nicht gemerkt', err) }
  }
  return codes
}

/*
 * Zurueck aus der Kasse (25.09., Test im Browser): Der Browser laedt den
 * Funnel dabei neu, der Zustand war weg. Die Kundin stand wieder bei
 * "Fuer wen ist dieses Buch?", musste ihr Kind noch einmal waehlen, wartete
 * gut 20 Sekunden auf ein neues Cover, und danach fragte die Rueckfrage nach
 * dem Buch, das sie gerade selbst in die Kasse gelegt hatte. Genau das tut,
 * wer in der Kasse doch das Hardcover will oder die Widmung aendern moechte.
 *
 * Deshalb traegt der Verlaufseintrag beim Weg in die Kasse Auftrag, Ausgabe,
 * Widmung und Messsitzung. Der Eintrag lebt nur in diesem Tab, nichts bleibt
 * auf dem Geraet. Beim Zurueckkommen steht Schritt 5 mit demselben Buch.
 */
function kasseMerken () {
  try {
    history.replaceState({
      ...(history.state || {}),
      wunoloSchritt: state.step,
      // Poster zum Buch (29.10.2026): Wahl beim Zurueck aus der Kasse erhalten, nie neu vorwaehlen.
      wunoloKasse: { jobId: state.jobId, storyId: state.storyId, binding: state.binding, dedication: state.dedication || '', sitzung: MESS_SITZUNG, poster: { dabei: state.poster.dabei, groesse: state.poster.groesse } }
    }, '')
  } catch {}
}

async function ausKasseZurueck () {
  let k = null
  try { k = history.state?.wunoloKasse } catch {}
  if (!k?.jobId || !PINNED_STORY || k.storyId !== state.storyId) return false
  if (k.poster) Object.assign(state.poster, { dabei: Boolean(k.poster.dabei), groesse: POSTER_PREISE[k.poster.groesse] ? k.poster.groesse : '30x40' })
  return auftragWiederherstellen(k.jobId, { binding: k.binding, dedication: k.dedication || '', woher: 'Zurueck aus der Kasse' })
}

/* Einen Auftrag mit fertiger Vorschau wieder aufnehmen und direkt im letzten
   Schritt zeigen: aus der Kasse zurueck (ausKasseZurueck) oder aus einer Mail
   mit Figur-Token auf genau das Buch dieser Figur (ausMailFortsetzen, 16.10.).
   Kein neues Cover, die Kundin sieht das Bild, das sie schon kannte. */
async function auftragWiederherstellen (jobId, { binding = null, dedication = '', woher = 'Wiederherstellen', schritt = LETZTER_SCHRITT } = {}) {
  try {
    const res = await fetch(`${BACKEND}/api/jobs/${encodeURIComponent(jobId)}?t=${Date.now()}`, { cache: 'no-store' })
    if (!res.ok) return false
    const job = await res.json()
    // Nur, solange nicht bestellt ist: Nach dem Kauf steht der Auftrag auf
    // ordered oder weiter, dann beginnt der Funnel normal. Bis 25.09. abends
    // prüfte das der Warenkorb; nach einem Länderwechsel in der Kasse kam
    // der Rückweg damit einmal nicht zustande (im Test nicht aufgeklärt).
    if (job.state !== 'sheet_ready' || !job.sheetUrl || !job.coverUrl) return false
    const p = job.profile || {}
    Object.assign(state, {
      jobId: job.id, name: p.name || '', gender: p.gender, age: p.age, ageRange: p.ageRange,
      hairColor: p.hairColor, hairStyle: p.hairStyle, eyeColor: p.eyeColor,
      consent: true, photoOk: true, previewStarted: true, sheetChosen: true, figurUebernommen: true,
      sheetUrl: job.sheetUrl, coverUrl: job.coverUrl, attemptsLeft: 0,
      variants: [{ key: null, url: job.sheetUrl, coverUrl: job.coverUrl }],
      dedication: dedication || ''
    })
    state.poster.stand = job.posterZumBuch || null
    const nameFeld = $('#name')
    if (nameFeld) nameFeld.value = state.name
    const widmung = $('#dedication')
    if (widmung) widmung.value = state.dedication
    const ausgabe = $$('#binding .choice').find(b => b.dataset.value === binding)
    if (ausgabe) {
      $$('#binding .choice').forEach(b => b.setAttribute('aria-pressed', String(b === ausgabe)))
      state.binding = ausgabe.dataset.value
    }
    zeigeVorschauBild()
    const laden = $('#preview-loading')
    if (laden) laden.hidden = true
    const varianten = $('#variants')
    if (varianten) varianten.hidden = true
    const regen = $('#regenerate')
    if (regen) regen.hidden = true
    schreibeFigurTexte()
    zeigeBuchvorschau()
    zeigeFigurBeleg()
    go(schritt)
    return true
  } catch (err) {
    console.warn(`[${woher}]`, err)
    return false
  }
}

/* Kampagne "Mias Figur wartet" (16.10., Paul): Der Link aus der Mail fuehrt mit
   Figur-Token auf das Buch, das die Kundin schon angefangen hatte. Gehoert die
   Figur zu genau diesem Buch und ist die Vorschau fertig, geht es ohne Umweg
   ueber Foto oder Figurwahl in den letzten Schritt. Sonst (anderes Buch, Vorschau
   weg, bestellt) bleibt alles wie bisher: figurAnbieten zeigt das Kind zur Wahl. */
async function ausMailFortsetzen () {
  if (!PINNED_STORY) return false
  let token = null
  try { token = new URLSearchParams(location.search).get('figur') } catch {}
  if (!token) return false
  try {
    const res = await geduldig(() => fetch(`${BACKEND}/api/figur/${encodeURIComponent(token)}`))
    const data = await res.json()
    if (!res.ok || !data.figur?.jobId || data.figur.storyId !== state.storyId) return false
    // In die Buchvorschau, nicht in den Kaufschritt (16.10., Paul: "bevor ich
    // eine Geschichte kaufe, moechte ich mir nochmal kurz angucken, um was es
    // geht"). Blaettern mit dem eigenen Kind, dann ein Tipp auf Weiter.
    const ok = await auftragWiederherstellen(data.figur.jobId, { woher: 'Fortsetzen aus der Mail', schritt: 4 })
    if (ok) figurTokenMerken(token, data.figur.name)
    if (ok) posterNachstarten()
    return ok
  } catch { return false }
}

/* Poster zum Buch beim Rueckweg aus der Mail (30.10.2026, Paul): Der Auftrag
   wird nur gelesen, Buecher von vor dem Livegang des Posters haben deshalb
   keins. Der Server startet es nach, solange Foto und Vorschau da sind; sonst
   bleibt der Schritt weg wie bisher. Ohne Antwort oder bei einem Fehler aendert
   sich nichts, die Kundin wartet auf nichts davon. */
async function posterNachstarten () {
  if (state.poster.stand?.status !== 'offen' || !state.jobId) return
  try {
    const res = await fetch(`${BACKEND}/api/jobs/${encodeURIComponent(state.jobId)}/poster-zum-buch`, { method: 'POST' })
    if (!res.ok) return
    // Bis der Lauf am Auftrag steht, ein paar Mal nachfragen; ab "laeuft"
    // fragt posterStandHolen selbst weiter, bis das Poster fertig ist.
    for (let i = 0; i < 4 && state.poster.stand?.status === 'offen'; i++) {
      await posterAbfrage
      await new Promise(r => setTimeout(r, i ? 1500 : 300))
      await posterStandHolen()
    }
  } catch (err) {
    console.warn('[Poster zum Buch] Nachstart', err)
  }
}

async function kaufen (status) {
  // Rueckfall, falls der Figur-Schritt uebersprungen wurde. Klappt das nicht,
  // wird nicht bestellt: Sonst ginge eine Bestellung mit einer Figur raus, die
  // der Server nie festgeschrieben hat, und das Foto bliebe liegen (12.09.).
  if (!(await bestaetigeFigur())) {
    const fehler = new Error('Deine Figur ließ sich gerade nicht speichern.')
    fehler.vomWarenkorb = true
    throw fehler
  }

  // Digital oder Druck ausdruecklich mitschicken statt in den Mailvorlagen am
  // Variantentitel zu raten (13.08.). Beide Transaktionsmails verzweigen
  // danach; ein umbenannter Variantentitel haette dort still den falschen Text
  // erzeugt. Unterstrich: bleibt im Checkout unsichtbar.
  const digital = /digital|pdf/i.test(state.binding || '')

  // Im Shopify-Theme spricht dieser Aufruf /cart/add.js an. Standalone nur Log.
  const payload = {
    items: [{
      id: window.WUNOLO_VARIANTS?.[state.binding],
      quantity: 1,
      properties: {
        _jobId: state.jobId,
        _ausgabe: digital ? 'digital' : 'druck',
        Name: state.name,
        // Der Kunde sieht diese Zeile im Warenkorb: Titel statt Kennung wie
        // "15-einhorn" (Befund Paul, 03.09.). Die Kennung braucht niemand
        // dort, der Auftrag haengt an _jobId.
        Geschichte: state.storyTitle || state.storyId,
        Widmung: state.dedication || undefined,
        // Wann das Buch in den Korb kam (30.09.): Die Rueckfrage bei einem
        // zweiten Buch unterscheidet damit Buecher aus diesem Besuch von
        // Resten frueherer Besuche. Liegt im Warenkorb selbst, also kein
        // neuer Speicher auf dem Geraet.
        _gelegt: String(Date.now()),
      },
    }],
  }
  // Poster zum Buch (29.10.2026): zweite Position mit derselben _jobId. Der
  // Server baut daraus die Druckdatei; beim Hardcover kommen Buch und Poster
  // in ein Paket. Mit zwei Positionen geht es ueber /checkout (kassenZiel).
  if (posterImKorb()) {
    const p = state.poster.stand
    payload.items.push({
      id: Number(posterVariante(state.poster.groesse)),
      quantity: 1,
      properties: {
        _jobId: state.jobId,
        _ausgabe: 'poster',
        _posterNr: String(p.nr),
        Name: state.name,
        Motiv: String(p.titel || '').replace(/^Poster: /, ''),
        _gelegt: String(Date.now()),
      },
    })
  }

  // Keine zweite Position mehr (22.09., Paul): Die Widmung ist inklusive und
  // geht als Eigenschaft am Buch mit (oben, properties.Widmung); der Server
  // liest sie dort. Bis zum 22.09. lag hier der Artikel "Persoenliche
  // Widmung" fuer 1,99, mit Platzhalterbild und Mengenwahl UEBER dem Buch im
  // Warenkorb. Kommt der Preis zurueck, dann als Variante des Buchs.
  if (window.WUNOLO_VARIANTS) {
    // Zeitgrenze: Ohne sie bleibt der Knopf im Funkloch oder nach dem
    // Ruhezustand des Telefons unbegrenzt stehen, und genau dort sind 98 von
    // 115 Sitzungen unterwegs.
    // Doppelte Buecher verhindern (24.09., Conversion-Befund): Wer aus der
    // Kasse zurueckgeht, die Ausgabe wechselt und noch einmal bestellt, hatte
    // dasselbe Buch zweimal in der Kasse (59,98 oder 69,98 Euro). Vorher alle
    // Zeilen desselben Auftrags entfernen; ein zweites Buch fuer ein anderes
    // Kind oder eine andere Geschichte hat einen anderen Auftrag und bleibt.
    //
    // Andere Buecher im Warenkorb (25.09., Befund Paul und Kasse "Fabian"
    // vom 19.09. mit vier Hardcovern fuer 147,55 Euro): Wer Buecher
    // vergleicht und jedes Mal "Weiter zur Kasse" tippt, sammelte alle in der
    // Kasse, auch aus einem frueheren Besuch. Liegt schon ein anderes Buch
    // dort, fragt ein Zwischenschritt: nur dieses Buch (vorgewaehlt) oder
    // alle. Alte Widmungsartikel (bis 22.09. eigener Artikel fuer 1,99) gehen
    // still, die Widmung steckt seitdem im Buch.
    //
    // Dasselbe Buch fuer dasselbe Kind gilt als derselbe Auftrag (25.09.,
    // Test): Wer aus der Kasse zurueckkam und die Seite neu lud, bekam
    // bisher einen neuen Auftrag, und die Rueckfrage zeigte "Im Warenkorb
    // liegt schon" mit genau diesem Buch. Mit "Beide" lag es zweimal in der
    // Kasse. Gleiche Varianten-Familie (dieses Produkt) und gleicher Name
    // ersetzen jetzt still, wie eine andere Ausgabe desselben Auftrags.
    const zeitgrenze = ms => (typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(ms) : undefined)
    const dieseVarianten = new Set(Object.values(window.WUNOLO_VARIANTS).map(String))
    const gleicherName = z => String(z.properties?.Name || '').trim().toLowerCase() === String(state.name || '').trim().toLowerCase()
    let entfernen = []
    try {
      const antwort = await fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: zeitgrenze(10000) })
      if (!antwort.ok) throw new Error(`cart.js ${antwort.status}`)
      const korb = await antwort.json()
      const zeilen = korb.items || []
      const gleicherAuftrag = zeilen.filter(z => z.properties && (z.properties._jobId === state.jobId || (z.properties._jobId && dieseVarianten.has(String(z.variant_id)) && gleicherName(z))))
      const alteWidmung = zeilen.filter(z => !z.properties?._jobId && /widmung/i.test(z.product_title || z.title || ''))
      const andereBuecher = zeilen.filter(z => z.properties?._jobId && !gleicherAuftrag.includes(z))
      entfernen = [...gleicherAuftrag, ...alteWidmung]
      if (andereBuecher.length) {
        // Aus diesem Besuch: vor hoechstens zwei Stunden gelegt. 29 von 30
        // Koerben entstehen binnen 30 Minuten nach der Figur (25.09.), wer
        // spaeter wiederkommt, hat meist einen Rest im Korb. Alte Zeilen ohne
        // _gelegt zaehlen als Rest.
        const frisch = z => Number(z.properties?._gelegt) > Date.now() - 2 * 60 * 60 * 1000
        // Buch fuer ein anderes Kind (31.10.2026, Mehrbuch-Pruefung): Wer fuer
        // Nichten und Neffen bestellt, sammelt erst Fotos und liegt schnell
        // ueber zwei Stunden. Ein anderer Vorname heisst gewollt dazu, dann
        // ist "Alle zusammen" der Hauptknopf. Derselbe Vorname wie bisher.
        const anderesKind = z => Boolean(String(z.properties?.Name || '').trim()) && !gleicherName(z)
        const wahl = await korbWahl(andereBuecher, andereBuecher.every(z => anderesKind(z) || frisch(z)))
        if (!wahl) {
          const fehler = new Error('abgebrochen')
          fehler.stillAbbrechen = true
          throw fehler
        }
        // grund nur | alle, bei Buechern aus diesem Besuch nur_besuch | alle_besuch
        messe('korb_mehrere', { grund: andereBuecher.every(frisch) ? `${wahl}_besuch` : wahl })
        if (wahl === 'nur') entfernen = [...entfernen, ...andereBuecher]
      }
    } catch (err) {
      if (err.stillAbbrechen) throw err
      console.warn('[Warenkorb] nicht gelesen', err)
    }
    // Klappt das Entfernen nicht, wird nicht hinzugefuegt (25.09.): Sonst
    // laege dasselbe Buch zweimal in der Kasse, und Shopify fasst gleiche
    // Zeilen zu Menge 2 zusammen. Lieber eine Meldung und ein zweiter Tipp.
    if (entfernen.length) {
      let raus = null
      try {
        raus = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: Object.fromEntries(entfernen.map(z => [z.key, 0])) }),
          signal: zeitgrenze(15000),
        })
      } catch (err) { console.warn('[Warenkorb] alte Zeilen nicht entfernt', err) }
      if (!raus?.ok) throw new Error('Warenkorb nicht aufgeraeumt')
    }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(20000) : undefined,
    })
    if (!res.ok) {
      const daten = await res.json().catch(() => ({}))
      const fehler = new Error(daten.description || daten.message || 'Der Warenkorb hat gerade nicht angenommen.')
      // Nur diese Begruendung stammt von Shopify und darf der Kundin gezeigt werden.
      fehler.vomWarenkorb = true
      throw fehler
    }
    // Erst nach dem OK messen, sonst zaehlt die unterste Stufe der Treppe
    // Knopfdruecke statt Warenkoerbe. Dieselbe Regel wie bei den Mailfeldern.
    messe('warenkorb', warenkorbAngaben())
    warenkorbVermerken()
    // Direkt in die Kasse (22.09., Plan): Von 16 Warenkoerben der Runde 2
    // erreichten 2 die Kasse. Dazwischen lag /cart mit Mengenwahl,
    // Rabattfeld, vier anderen Buechern und dem Shop-Cover statt dem Kind.
    // Die Kasse selbst hielt der Head of Conversion fuer gut (8 von 10).
    kasseMerken()
    window.location.href = await kassenZiel()
    return 'kasse'
  }
  messe('warenkorb', warenkorbAngaben())
  warenkorbVermerken()
  console.log('Warenkorb-Payload (Standalone-Modus):', payload)
  alert(`Fertig! Job ${state.jobId} liegt bereit.\n\nIm Shop ginge es jetzt zum Warenkorb.`)
}

/* -------------------------------------------- Poster zum Buch (29.10.2026) */
/* Eigener Schritt nach "Dein Buch" (design_handoff_wunolo_poster_zum_buch). Die
   Preise sind die des versteckten Produkts "Poster zum Buch" (Paul 23.10., E3),
   als zwei feste Preise und keine Aktion. Aendern sie sich in Shopify, hier
   mitziehen; die Varianten selbst nennt der Server (posterZumBuch.varianten). */
const POSTER_PREISE = { '30x40': { zumBuch: 19.99, einzeln: 29.99 }, '50x70': { zumBuch: 34.99, einzeln: 49.99 } }
const posterEuro = n => `${n.toFixed(2).replace('.', ',')}\u00a0€`
let posterAbfrage = null

function posterSchrittDa () {
  const p = state.poster?.stand
  return Boolean(p && (p.status === 'fertig' || p.status === 'laeuft') && p.varianten && /softcover|hardcover|layflat/i.test(state.binding || ''))
}
function posterImKorb () {
  const p = state.poster?.stand
  return Boolean(state.poster?.dabei && p?.status === 'fertig' && p.nr && posterVariante(state.poster.groesse) && posterSchrittDa())
}
/* Je Buch eine eigene Variante mit dem Posterbild (29.10.2026, Paul: Warenkorb
   und Kasse zeigen das richtige Poster). Die Ids legt das Theme nach SKU in
   WUNOLO_POSTER_ZUM_BUCH ab; die Varianten vom Server sind der Rueckfall ohne Bild. */
function posterVariante (groesse) {
  const p = state.poster?.stand
  return (p?.motiv && window.WUNOLO_POSTER_ZUM_BUCH?.[`FF-PO-${groesse}-ZUMBUCH-${p.motiv}`]) || p?.varianten?.[groesse] || null
}

/* Stand vom Server. Laeuft das Poster noch, alle 2,5 s nachfragen, solange
   die Kundin zwischen Vorschau und Posterschritt ist. */
function posterStandHolen () {
  if (!state.jobId || posterAbfrage) return posterAbfrage
  posterAbfrage = (async () => {
    try {
      const res = await fetch(`${BACKEND}/api/jobs/${state.jobId}?t=${Date.now()}`, { cache: 'no-store' })
      if (!res.ok) return
      const job = await res.json()
      const vorher = posterSchrittDa()
      state.poster.stand = job.posterZumBuch || null
      if (posterSchrittDa() !== vorher) {
        if (state.step === POSTER_SCHRITT && !posterSchrittDa()) go(BUCH_SCHRITT)
        aktualisiereSchrittanzeige()
        schreibeWeiterText()
      }
      if (state.step === POSTER_SCHRITT) posterZeigen()
    } catch (err) {
      console.warn('[Poster zum Buch] Stand', err)
    } finally {
      posterAbfrage = null
    }
    const offen = state.step === 4 || state.step === BUCH_SCHRITT || state.step === POSTER_SCHRITT
    if (state.poster.stand?.status === 'laeuft' && offen) setTimeout(posterStandHolen, 2500)
  })()
  return posterAbfrage
}

function posterZeigen ({ betreten = false } = {}) {
  const p = state.poster.stand
  if (!p) return
  const fertig = p.status === 'fertig' && Boolean(p.url)
  const dabei = state.poster.dabei && fertig
  const groesse = dabei ? state.poster.groesse : '30x40'
  const preis = POSTER_PREISE[groesse]
  const url = fertig ? (p.url.startsWith('/') ? (window.WUNOLO_BACKEND || '') + p.url : p.url) : null
  // Waehrend das Poster entsteht, steht das Cover verschwommen an der Wand.
  const quelle = url || state.coverUrl || ''
  const bild = $('#fpz-poster-bild')
  if (bild && quelle && bild.getAttribute('src') !== quelle) bild.src = quelle
  $('#fpz-poster').dataset.groesse = groesse
  $('#fpz-wand').classList.toggle('fpz-in-arbeit', !fertig)
  const abzeichen = $('#fpz-abzeichen')
  abzeichen.hidden = !fertig
  abzeichen.textContent = `Nur zu deinem Buch: ${posterEuro(preis.einzeln - preis.zumBuch).replace(',00', '')} günstiger`
  $('#fpz-laden').hidden = fertig
  if (!fertig) {
    const prozent = Math.max(1, Math.min(95, Math.round((Date.now() - (Date.parse(p.seit) || Date.now())) / 180)))
    $('#fpz-prozent').textContent = String(prozent)
    $('#fpz-ring').style.setProperty('--p', String(prozent))
    if (bild) bild.style.filter = `blur(${Math.max(4, 16 - prozent * 0.12)}px)`
  } else if (bild) bild.style.filter = ''
  $$('.fpz-buchtitel').forEach(el => { el.textContent = state.storyTitle || 'deinem Buch' })
  $('#fpz-grund').textContent = `${state.name.trim() || 'Dein Kind'} ist schon gezeichnet, deshalb gibt es das Poster jetzt zum Buch für ${posterEuro(preis.zumBuch)}.`
  const knopf = $('#fpz-hinzu')
  knopf.disabled = !fertig
  knopf.setAttribute('aria-pressed', String(dabei))
  knopf.classList.toggle('fpz-dabei', dabei)
  $('#fpz-hinzu-titel').textContent = !fertig ? 'Gleich kannst du es dazunehmen' : dabei ? 'Ja, das Poster kommt dazu' : 'Ja, Poster dazunehmen'
  $('#fpz-hinzu-preis').hidden = !fertig || dabei
  $('#fpz-entfernen').hidden = !dabei
  $('#fpz-wahl').hidden = !dabei
  $$('#fpz-groessen .fpz-groesse').forEach(b => b.setAttribute('aria-checked', String(b.dataset.groesse === groesse)))
  $$('#fpz-groessen .fpz-mini img').forEach(i => { if (url && i.getAttribute('src') !== url) i.src = url })
  const summe = $('#fpz-summe')
  summe.hidden = !dabei
  if (dabei) {
    const buch = Number($$('#binding .choice').find(b => b.getAttribute('aria-pressed') === 'true')?.dataset.price) || 0
    const waren = buch + preis.zumBuch
    const frei = waren >= VERSANDFREI_AB
    // Variante A (Paul 29.10.2026): Das Poster kostet keinen Versand extra,
    // Buch und Poster zahlen zusammen den Versand des Buchs.
    // Versand getrennt wie in der Preiszeile (Paul 04.11.2026), keine Summe mit Versand.
    summe.textContent = `Buch und Poster ${posterEuro(waren)} inkl. MwSt., ${frei ? 'versandkostenfrei' : `zzgl. ${posterEuro(versandBetrag())} Versand`}.`
  }
  // Ein Paket mit dem Hardcover erst, wenn Hardcover bei allcop druckt
  // (Server-Schalter, Paul 29.10.2026 abends); bis dahin zwei Pakete. Das
  // Layflat druckt immer dort, also immer ein Paket (Paul 03.11.2026).
  const b = state.binding || ''
  const ausgabe = /layflat/i.test(b) ? 'Layflat' : /hardcover/i.test(b) ? 'Hardcover' : 'Softcover'
  $('#fpz-paket').textContent = ausgabe === 'Layflat' || (ausgabe === 'Hardcover' && p.hardcoverEinPaket)
    ? `Das Poster kommt zusammen mit deinem ${ausgabe} in einem Paket.`
    : `Das Poster kommt in einem eigenen Paket, getrennt vom ${ausgabe}.`
  if (betreten) messe('poster_gesehen', { grund: p.status })
}

$('#fpz-hinzu')?.addEventListener('click', () => {
  if (state.poster.stand?.status !== 'fertig') return
  state.poster.dabei = !state.poster.dabei
  messe(state.poster.dabei ? 'poster_dazu' : 'poster_weg', { grund: state.poster.groesse })
  posterZeigen()
  aktualisiereZusammenfassung()
})
$('#fpz-groessen')?.addEventListener('click', e => {
  const kachel = e.target.closest('.fpz-groesse')
  if (!kachel || !POSTER_PREISE[kachel.dataset.groesse]) return
  state.poster.groesse = kachel.dataset.groesse
  posterZeigen()
  aktualisiereZusammenfassung()
})
// Ausgabe gewechselt: Mit Digitalausgabe gibt es keinen Posterschritt, und
// der Knopf in "Dein Buch" wechselt zwischen "Weiter" und "Zur Kasse".
$('#binding')?.addEventListener('click', () => setTimeout(() => { aktualisiereSchrittanzeige(); schreibeWeiterText() }, 0))

/* ------------------------------------------------------------ Start */
buildSwatches($('#hair'), HAIR, 'hairColor')
buildSwatches($('#eyes'), EYES, 'eyeColor')
bindChoices($('#gender'), 'gender')
bindChoices($('#age'), 'age', Number)
bindChoices($('#hairStyle'), 'hairStyle')
buildEditions($('#binding'))   // aus den echten Produktvarianten, siehe oben
// Widmungspreis aus dem echten Produkt, damit Anzeige und Rechnung nie
// auseinanderlaufen. Genau das war der Fehler: angezeigt 4,99, berechnet nichts.
// Widmungspreis (22.09.): inklusive, der Text steht fest im Markup.
bindChoices($('#binding'), 'binding')

$('#name').addEventListener('input', e => {
  state.name = e.target.value
  $$('.name-slot').forEach(el => { el.textContent = state.name || 'dein Kind' })
  // Genitiv fuer die Einwilligung: "Mias Figur", "Max’ Figur", ohne Namen
  // "die Figur". Dieselbe Regel wie in der Ueberschrift (s, x, z, ß).
  $$('.name-slot-genitiv').forEach(el => { el.textContent = genitiv(state.name) || 'die' })
  schreibeWeiterText()
  // Heldin statt Held bei Maedchen (Feedback aus der ersten Bestellung,
  // 11.08.). Stand fest im Markup und war damit fuer die Haelfte der Kinder
  // falsch, ausgerechnet auf der Seite, die das eigene Kind zeigt.
  $$('.held-slot').forEach(el => { el.textContent = state.gender === 'girl' ? 'Heldin' : 'Held' })
  validate()
})

$('#consent').addEventListener('change', e => {
  state.consent = e.target.checked
  $('#dropzone').classList.toggle('needs-consent', !state.consent)
  // Den Hinweis wieder wegnehmen, sobald der Grund entfallen ist. Sonst
  // steht eine Warnung neben einer erfuellten Bedingung.
  if (state.consent && !state.photoOk) $('#photo-feedback').innerHTML = ''
  // Am bestehenden Auftrag nachtragen (22.09.): Wer seine Adresse dagelassen
  // hat, hat schon einen Auftrag, und der entstand ohne Einwilligung.
  einwilligungNachtragen()
  validate()
})
$('#dropzone').classList.add('needs-consent') // Startzustand: Haken noch nicht gesetzt

/**
 * Ohne Einwilligung kein Foto. Echte Sperre, nicht nur Abblendung.
 *
 * Bis zum 12.08. war der Klick nicht blockiert: Die Klasse needs-consent hat
 * die Dropzone nur halb transparent gemacht, der Dateiwaehler ging trotzdem
 * auf. Die einzige Absicherung war die Reihenfolge im HTML, und die hielt nur,
 * solange niemand das Layout aendert. Genau das stand mit dem Redesign an, in
 * dem die Einwilligung unter der Dropzone sitzt.
 *
 * Statt still nichts zu tun sagt die Sperre, was fehlt, und springt hin: Eine
 * Flaeche, die auf Klicks nicht reagiert, wirkt kaputt.
 */
function einwilligungFehlt () {
  if (state.consent) return false
  const karte = $('.consent')
  $('#photo-feedback').innerHTML =
    '<div class="notice warn">Bitte bestätige zuerst die Einwilligung darunter, dann kannst du das Foto auswählen.</div>'
  karte?.scrollIntoView({ behavior: 'instant', block: 'center' })
  karte?.classList.add('fk-blinkt')
  setTimeout(() => karte?.classList.remove('fk-blinkt'), 1200)
  return true
}

$('#dropzone').addEventListener('click', () => {
  if (einwilligungFehlt()) return
  $('#photo').click()
})
$('#dropzone').addEventListener('keydown', e => {
  if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $('#dropzone').click() }
})
$('#foto-tauschen')?.addEventListener('click', () => $('#photo').click())
$('#preview-nochmal')?.addEventListener('click', () => {
  // Zeichnet der Server inzwischen doch fertig geworden sein, liefert
  // /preview die vorhandene Figur aus dem Zwischenspeicher: Der zweite
  // Versuch kostet dann weder Zeit noch Geld.
  startPreview()
})
$('#foto-nochmal')?.addEventListener('click', () => {
  // Ohne gemerkte Datei bleibt nur der Weg ueber die Auswahl. Sollte nach
  // einem Abbruch nicht vorkommen, kostet aber nichts.
  if (state.fotoDatei) uploadPhoto(state.fotoDatei)
  else $('#photo').click()
})
$('#photo').addEventListener('change', e => {
  if (einwilligungFehlt()) { e.target.value = ''; return }
  if (e.target.files[0]) uploadPhoto(e.target.files[0])
})
;['dragover', 'dragleave', 'drop'].forEach(evt => {
  $('#dropzone').addEventListener(evt, e => {
    e.preventDefault()
    $('#dropzone').classList.toggle('over', evt === 'dragover')
    if (evt === 'drop' && e.dataTransfer.files[0]) {
      if (einwilligungFehlt()) return
      uploadPhoto(e.dataTransfer.files[0])
    }
  })
})

/*
 * Widmung, freiwillig und wieder abwaehlbar (Befund Paul, 13.09.).
 *
 * Vorher gab es nur einen Weg hinein: Ein Tipp auf einen Vorschlag schrieb den
 * Satz ins Feld, ein zweiter Tipp schrieb ihn noch einmal, und wer sich anders
 * entschied, musste das Feld von Hand leeren. Auf dem Telefon heisst das:
 * hineintippen, alles markieren, loeschen. Dazu stand die Wahl nirgends
 * geschrieben, weder welcher Vorschlag genommen wurde noch dass gar keiner
 * auch geht. Und der Aufpreis erschien in der Zusammenfassung erst beim
 * naechsten Tastendruck, weil der Vorschlagsknopf sie nicht neu rechnen liess.
 *
 * Jetzt ist "Ohne Widmung" die erste Wahl und von Anfang an gesetzt, ein
 * zweiter Tipp auf denselben Vorschlag nimmt ihn wieder weg, und der Preis
 * bleibt blass, solange nichts drinsteht.
 */
function widmungsText (index) {
  return DEDICATIONS[index].replace('{NAME}', state.name || 'dich')
}

function zeigeWidmungswahl () {
  const text = (state.dedication || '').trim()
  $$('#dedication-templates .choice').forEach(btn => {
    const i = btn.dataset.vorlage
    // Ohne Widmung ist gewaehlt, wenn nichts dasteht. Ein Vorschlag ist
    // gewaehlt, solange sein Wortlaut unveraendert im Feld steht; sobald
    // jemand daran herumschreibt, ist es sein eigener Text.
    const aktiv = i === undefined ? !text : text === widmungsText(Number(i))
    btn.setAttribute('aria-pressed', aktiv ? 'true' : 'false')
    // Der Name steht erst ab Schritt 1 fest. Bis dahin bleibt die Auslassung
    // stehen, damit da nicht "Fuer dich" als Vorschlag klebt.
    if (i !== undefined && state.name) btn.textContent = widmungsText(Number(i))
  })
}

/*
 * Emojis gleich beim Tippen heraus (29.09., Auftrag #1008): Die Buchschrift
 * hat keine, im PDF standen zwei leere Zeichen und die Druckvorpruefung
 * stoppte. Dasselbe Muster wie druckbarerText auf dem Server.
 *
 * Paul, 29.09.: Wer statt "Fest" ein Emoji tippt, darf nicht mit einem
 * halben Satz im Buch enden. Deshalb verschwindet das Emoji in dem Moment,
 * in dem es getippt wird (die Kundin sieht die Luecke und schreibt das Wort),
 * und der Hinweis darunter bleibt stehen, bis der Schritt verlassen wird.
 * Waehrend das Handy ein Wort zusammensetzt (Vorschlaege, Diktat), wird
 * nicht eingegriffen, erst danach.
 */
const EMOJI_MUSTER = /\p{Extended_Pictographic}|[\u{1F3FB}-\u{1F3FF}\u{1F1E6}-\u{1F1FF}\u{FE0E}\u{FE0F}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu
function emojisAusWidmung (feld) {
  const vorher = feld.value
  const ohne = vorher.replace(EMOJI_MUSTER, '')
  if (ohne === vorher) return false
  // Einfuegemarke an derselben Stelle halten, nicht ans Ende springen.
  const marke = feld.selectionStart ?? vorher.length
  const neueMarke = vorher.slice(0, marke).replace(EMOJI_MUSTER, '').length
  feld.value = ohne
  try { feld.setSelectionRange(neueMarke, neueMarke) } catch {}
  let hinweis = $('#widmung-emoji-hinweis')
  if (!hinweis) {
    hinweis = document.createElement('p')
    hinweis.id = 'widmung-emoji-hinweis'
    hinweis.className = 'fk-hinweis fk-emoji-hinweis'
    hinweis.setAttribute('role', 'status')
    hinweis.textContent = 'Emojis können wir nicht drucken und haben sie entfernt. Lies deine Widmung bitte noch einmal, damit kein Wort fehlt.'
    feld.closest('label')?.after(hinweis)
  }
  hinweis.hidden = false
  return true
}
function widmungUebernehmen (feld) {
  emojisAusWidmung(feld)
  state.dedication = feld.value
  zeigeWidmungswahl()
  aktualisiereZusammenfassung()
}
$('#dedication').addEventListener('input', e => {
  if (e.isComposing) return
  widmungUebernehmen(e.target)
})
$('#dedication').addEventListener('compositionend', e => widmungUebernehmen(e.target))
$('#dedication-templates').innerHTML =
  '<button class="choice" type="button" aria-pressed="true">Ohne Widmung</button>' +
  DEDICATIONS.map((t, i) => `<button class="choice" type="button" data-vorlage="${i}" aria-pressed="false">${t.replace('{NAME}', '…')}</button>`).join('')
$('#dedication-templates').addEventListener('click', e => {
  const btn = e.target.closest('.choice')
  if (!btn) return
  const i = btn.dataset.vorlage
  const gewaehlt = i === undefined ? '' : widmungsText(Number(i))
  // Derselbe Vorschlag zweimal getippt heisst: doch nicht.
  state.dedication = gewaehlt && (state.dedication || '').trim() === gewaehlt ? '' : gewaehlt
  $('#dedication').value = state.dedication
  zeigeWidmungswahl()
  aktualisiereZusammenfassung()
})
zeigeWidmungswahl()

$('#zurueck-zur-figur')?.addEventListener('click', () => go(4))
$('#zurueck-zum-kauf')?.addEventListener('click', () => go(5))

/* Zurueckspringen ueber den Stepper. Nur auf erledigte Schritte: Vorspringen
   wuerde Angaben ueberspringen, die die naechsten Schritte brauchen. */
$('#fk-stepper').addEventListener('click', e => {
  const btn = e.target.closest('[data-ziel]')
  if (!btn || btn.disabled) return
  const ziel = Number(btn.dataset.ziel)
  if (ruecksprungZurKindwahl(ziel)) return zurueckZurKindwahl()
  go(ziel)
})

/* Zusammenfassung auf schmalen Schirmen ein- und ausklappen. Auf dem Desktop
   ist der Schalter ausgeblendet und die Karte immer offen. */
$('#fk-zf-schalter')?.addEventListener('click', () => {
  const koerper = $('#fk-zf-koerper')
  const offen = koerper.classList.toggle('offen')
  $('#fk-zf-schalter').setAttribute('aria-expanded', String(offen))
})

/* Kopf-Links auf die Produktseite zeigen lassen, wenn der Funnel im Shop
   laeuft. Ohne Produkt bleibt der Verweis auf die Startseite. */
if (window.WUNOLO_PRODUKT_URL) {
  for (const id of ['#fk-schliessen', '#fk-rueckweg']) {
    const el = $(id)
    if (el) el.href = window.WUNOLO_PRODUKT_URL
  }
}

$('#next').addEventListener('click', async () => {
  if (state.step === letzterSchritt()) return addToCart()
  if (state.step === 4 && !(await bestaetigeFigur())) {
    const left = $('#attempts-left')
    if (left) { left.hidden = false; left.textContent = 'Die Figur ließ sich gerade nicht speichern. Bitte noch einmal versuchen.' }
    return
  }
  // "Buch gewaehlt" in der Treppe (16.09.): Ohne Figur zuerst ist das der
  // Schritt vom Buch mit Kind zur Bestellung.
  if (state.step === 4) messe('buch', { storyId: state.storyId || null })
  // Adresse sichern, ohne den Weg aufzuhalten (22.09.): kein await, der
  // naechste Schritt kommt sofort. Beim Verlassen von Schritt 2, damit beide
  // Varianten des Mailtests (Feld in Schritt 1 oder 2) hier ankommen.
  // Im Testballon ohne Aussehen-Schritt ist Schritt 1 der letzte vor dem Foto (08.10.).
  if (state.step === (UEBERSPRUNGEN.has(2) ? 1 : 2)) auftragSichern()
  go(state.step + 1)
})
$('#back').addEventListener('click', () => {
  if (ruecksprungZurKindwahl(state.step - 1)) return zurueckZurKindwahl()
  go(state.step - 1)
})

/* Feste Texte im Funnel-Markup fuer den Testballon tauschen (06.10.2026). Steht
   hier statt im Theme, damit lokale Seite und Shop dieselbe Fassung zeigen und
   alle anderen Buecher unberuehrt bleiben. Teilstuecke, weil manche Texte neben
   Namensfeldern stehen ("Mia ist schon gezeichnet"). Einwilligung im Wortlaut,
   den Paul am 06.10. freigegeben hat. */
const AEHNLICH_TEXTE = [
  ['Das Alter steuert, wie jung dein Kind gezeichnet wird.', 'Das Alter brauchen wir für die passende Geschichte.'],
  ['Nur zum Zeichnen, danach gelöscht', 'Nur für dein Buch, danach gelöscht'],
  ['Ich darf dieses Foto verwenden und bin einverstanden, dass daraus die Hauptfigur für das Buch gezeichnet wird. Das Foto wird danach gelöscht.',
    'Ich darf dieses Foto verwenden und bin einverstanden, dass daraus das Gesicht meines Kindes für die Bilder im Buch erstellt wird. Das Foto wird danach gelöscht.'],
  ['Deine Buchheldin wird gerade gezeichnet', 'Dein Kind kommt gerade ins Buch'],
  ['Das Foto wird nach dem Zeichnen automatisch gelöscht', 'Das Foto wird danach automatisch gelöscht'],
  ['wir zeichnen weiter.', 'wir arbeiten weiter.'],
  ['Neu zeichnen lassen', 'Noch einmal versuchen'],
  ['Cover: fertig gezeichnet', 'Cover: fertig'],
  ['wird nach der Bestellung eingezeichnet', 'kommt nach der Bestellung dazu'],
  ['Jetzt neu zeichnen', 'Jetzt noch einmal versuchen'],
  ['Neu zeichnen?', 'Noch einmal versuchen?'],
  ['Wird neu gezeichnet', 'Wir versuchen es noch einmal'],
  ['Wir zeichnen die Umrisse nach deinem Foto …', 'Wir übernehmen das Gesicht aus deinem Foto …'],
  ['Fertig gezeichnet', 'Fertig'],
  ['Die Zeichnung ist gespeichert.', 'Dein Kind ist gespeichert.'],
  ['Zurück zur Zeichnung', 'Zurück zur Vorschau'],
  ['ist schon gezeichnet', 'ist schon im Buch'],
  ['den Link zur fertigen Zeichnung', 'den Link zur fertigen Vorschau']
]
function aehnlichTexteSetzen () {
  if (!AEHNLICH || typeof document === 'undefined') return
  const lauf = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT)
  const knoten = []
  while (lauf.nextNode()) knoten.push(lauf.currentNode)
  for (const k of knoten) {
    let t = k.nodeValue
    if (!t || !t.trim()) continue
    const norm = t.replace(/\s+/g, ' ')
    let neu = norm
    for (const [alt, ersatz] of AEHNLICH_TEXTE) if (neu.includes(alt)) neu = neu.split(alt).join(ersatz)
    if (neu !== norm) k.nodeValue = neu
  }
  for (const el of document.querySelectorAll('[aria-label], [alt], [title]')) {
    for (const attr of ['aria-label', 'alt', 'title']) {
      const v = el.getAttribute(attr)
      if (!v) continue
      let neu = v
      for (const [alt, ersatz] of AEHNLICH_TEXTE) if (neu.includes(alt)) neu = neu.split(alt).join(ersatz)
      if (neu !== v) el.setAttribute(attr, neu)
    }
  }
}

/* "Faro geht mit" nur, wo Faro mitgeht (06.10.2026, Paul): In den Traumwelten
   und im Testballon gibt es keinen Faro. Der feste Satz im Markup gilt fuer alle
   Buecher; hier wird er fuer die Buecher ohne Faro gekuerzt. Die Reihe kommt
   aus der Geschichtenliste des Servers; versteckte Geschichten (Testballon)
   stehen dort nicht, die erkennt AEHNLICH. */
async function faroSatzAnpassen () {
  const lede = typeof document !== 'undefined' && document.getElementById('lede-schritt1')
  if (!lede || !/Faro geht mit\./.test(lede.textContent)) return
  let ohneFaro = AEHNLICH
  if (!ohneFaro && PINNED_STORY) {
    try {
      const res = await fetch((window.WUNOLO_BACKEND || '') + '/api/stories')
      const { stories } = await res.json()
      const s = (stories || []).find(x => x.id === PINNED_STORY || x.slug === PINNED_STORY)
      ohneFaro = s?.series === 'traumwelten'
    } catch { /* ohne Antwort bleibt der Satz, wie bisher */ }
  }
  if (ohneFaro) lede.textContent = lede.textContent.replace(/\s*Faro geht mit\./, '').trim()
}
faroSatzAnpassen()
aehnlichTexteSetzen()
mailfeldPlatzieren()
initTurnstile()
initEinwilligung()
loadStories().then(async () => {
  if (await ausKasseZurueck()) return
  if (await ausMailFortsetzen()) return
  go(FIRST_STEP)
  await figurAnbieten()
})
